const usangeo = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {
        NAME: 'AKGD',
        id: 0,
        label: 'AKGD',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value:  0.47982821487199995,
        year: 2023,
        centroid: [89.68358885850064, 363.0716682573017],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-141.00185399966233, 60.39043799961405],
              [-141.00184099996216, 60.30610500014569],
              [-141.0016959995707, 59.7698290001083],
              [-141.44347700006347, 59.87726900036415],
              [-141.2752180001106, 59.93041299956036],
              [-141.29022830019585, 60.058506300225645],
              [-141.6790699997806, 59.94791700006954],
              [-141.9594960003401, 60.01800199989242],
              [-142.6994230001713, 60.09148900011729],
              [-143.46143100024045, 60.04628600019879],
              [-143.88366599958619, 59.9916179999708],
              [-144.33551999964823, 60.18936499999484],
              [-144.94881900019666, 60.29101200020369],
              [-144.83874099969734, 60.44518900007233],
              [-145.01687700007346, 60.44983400023898],
              [-145.32691199998877, 60.33630199963761],
              [-145.59749299980206, 60.45344999971775],
              [-145.96378400033132, 60.47035300039073],
              [-145.63317999975715, 60.671078000149635],
              [-145.90221600026817, 60.614453999652426],
              [-146.2697830002852, 60.650992000180736],
              [-146.05768000013188, 60.73722299994154],
              [-146.30399999990004, 60.76032200036008],
              [-146.61906699984215, 60.68456199963663],
              [-146.09759800004764, 60.79642399966792],
              [-145.91505799982681, 60.949124999818935],
              [-145.63229100012953, 60.936735000420015],
              [-145.5685400001209, 61.10516300007242],
              [-144.96609600013028, 61.21313999991111],
              [-144.41301500034197, 61.2140450002766],
              [-144.42413899981497, 61.04058299960582],
              [-143.71682700036575, 61.03162700028588],
              [-143.7170360001113, 60.84541499980247],
              [-143.3850040002344, 60.844846999689366],
              [-143.38379400019295, 60.75889200006583],
              [-142.86191500037694, 60.75852999955987],
              [-142.86180499980088, 60.590932000411556],
              [-141.95584900033106, 60.60472000042773],
              [-141.7817239996628, 60.43275200030462],
              [-141.21352999990955, 60.43369199958619],
              [-141.00185399966233, 60.39043799961405],
            ],
          ],
          [
            [
              [-149.2376069997632, 61.479119999788225],
              [-149.1874000002098, 61.4252670002719],
              [-148.4600840000765, 61.42697299980415],
              [-148.4735870004397, 60.85063100022052],
              [-148.74610499964598, 60.8461430000994],
              [-148.65576700024684, 60.72725599986455],
              [-148.6564809998982, 60.66705099970392],
              [-148.65606100031488, 60.49822100039893],
              [-148.66516900034907, 60.45815399990721],
              [-148.56249599959068, 60.4225930003667],
              [-148.58360309970325, 59.96142349969483],
              [-148.6800670002918, 59.94379720038057],
              [-149.12628300026023, 59.98292100000418],
              [-149.2731715003644, 59.914731600183245],
              [-149.37700459958256, 60.12392229967446],
              [-149.46219300000692, 59.91859200032059],
              [-149.66434060043832, 59.80181379966717],
              [-149.74430709999265, 59.948291699902086],
              [-149.7496700999951, 59.69501620043735],
              [-150.06708479992355, 59.845172600335275],
              [-149.95099249960415, 59.65470830034786],
              [-150.35056799991324, 59.45299799975794],
              [-150.21468640035707, 59.73663500000532],
              [-150.47911560030468, 59.45889600015033],
              [-150.94421399977625, 59.30813300033776],
              [-151.32608300013032, 59.30886199978153],
              [-151.74845200025956, 59.15860099973639],
              [-151.99161800027048, 59.31361799967101],
              [-151.88794800029996, 59.42516799970349],
              [-151.16426000019882, 59.587012999750186],
              [-151.0637510003084, 59.79314699983422],
              [-151.49972500010864, 59.63243299978319],
              [-151.86946799974837, 59.76915999983419],
              [-151.70377899960113, 60.03128299991056],
              [-151.4216600001089, 60.21299599976561],
              [-151.2644549999982, 60.54339499987941],
              [-151.40926999981062, 60.7205580003515],
              [-151.06255900019767, 60.78742900034814],
              [-150.37717100004159, 61.03914399979578],
              [-150.06119599959567, 60.91263699979777],
              [-149.77026400018343, 60.96760699956343],
              [-148.99804300038414, 60.84753599958674],
              [-149.73687400003504, 61.016412000113746],
              [-150.07441989985847, 61.1563458000187],
              [-149.72201400004604, 61.37186499996983],
              [-149.2376069997632, 61.479119999788225],
            ],
          ],
          [
            [
              [-149.46992400039227, 61.49877899985103],
              [-149.72149649956378, 61.46498399991174],
              [-149.98510399974975, 61.23760899965566],
              [-150.46881300021977, 61.2446270004358],
              [-150.55173000003944, 61.293597999648],
              [-151.02490500036544, 61.17839200009081],
              [-151.1666059995672, 61.046405000090715],
              [-151.74002900033807, 60.922784000081606],
              [-151.79280000031972, 61.12919500034906],
              [-152.01340300034815, 61.19858699969035],
              [-152.70024800024498, 61.207725000208654],
              [-153.0021809997533, 61.425685999809104],
              [-153.00294599995792, 62.308891999666116],
              [-153.0723519999448, 62.23029200017572],
              [-153.3996619997015, 62.22072100037394],
              [-153.40065699972072, 62.13095300028078],
              [-153.74063299991298, 62.121531000155585],
              [-153.73588400034632, 62.02933399956447],
              [-157.0664430000444, 62.03072799999728],
              [-157.0667050004354, 62.12953399959446],
              [-158.23645499969845, 62.12172700020096],
              [-158.23831700012943, 62.429808999985426],
              [-158.11805899962312, 62.570779999697265],
              [-157.81701199960406, 62.47069200033559],
              [-157.37941000027126, 62.566140999807374],
              [-157.5313810000331, 62.91660699991314],
              [-157.4249050001656, 63.17141800004072],
              [-157.22386700036174, 63.37854800019011],
              [-157.28394099987722, 63.605877000123485],
              [-156.93325100023344, 63.636250999683966],
              [-156.80263899979, 63.77197100006168],
              [-156.30550799999418, 63.96717299963427],
              [-155.44664400032033, 63.977701000400884],
              [-155.4248659996661, 63.81246699965237],
              [-155.6804739996753, 63.64941599974867],
              [-155.89308699996505, 63.605255000218165],
              [-155.8374900000634, 63.277495000394026],
              [-155.54163700034727, 63.48742200002533],
              [-154.93216800015307, 63.41430799991434],
              [-154.46170299979357, 63.55183700007757],
              [-154.1780850004224, 63.48853500009022],
              [-153.92032300000642, 63.68649700013651],
              [-153.39664700005898, 63.773825000123736],
              [-152.98589100036935, 63.98846799959858],
              [-151.8251330002877, 64.00545599969468],
              [-151.5792160002182, 64.0854339997793],
              [-151.30077400031982, 64.01001899967713],
              [-150.75005599978454, 64.36520199967259],
              [-149.31068600005884, 64.35843999990612],
              [-149.3019500000924, 64.49265800026654],
              [-148.64518890004766, 64.6012636001351],
              [-148.66384400040027, 65.211355000433],
              [-148.1386499996977, 65.21128099971844],
              [-148.32470900032007, 65.32632800003722],
              [-147.68296099995015, 65.5509110001426],
              [-147.84193199966202, 65.39764700010903],
              [-147.30143800026346, 65.39613899981504],
              [-147.20798900039202, 65.27805899992296],
              [-146.9027179998358, 65.28384399960095],
              [-146.1794130003097, 65.45327499964156],
              [-145.99511099977278, 65.4064719996831],
              [-146.07812400042226, 65.2452450002566],
              [-145.61870400038927, 65.14344100000221],
              [-145.64924999978763, 65.03317900001088],
              [-144.89548000010188, 65.1364270003059],
              [-144.4493450002715, 65.06158499964806],
              [-144.25133899999483, 65.11799200003082],
              [-143.8883030002832, 65.08959099972492],
              [-144.12281899979698, 64.79780399955501],
              [-144.07262399989764, 64.65206700039181],
              [-144.46418700032976, 64.58255800015166],
              [-144.97940399959487, 64.57170399963991],
              [-145.53182200028505, 64.41758099956354],
              [-145.73916000013386, 64.46031299974521],
              [-146.15676099982025, 64.38606400035337],
              [-146.3557470003238, 64.27971400000115],
              [-147.57194900044598, 64.2600220002152],
              [-147.36454200011318, 64.02154599974813],
              [-147.61885999998898, 63.91403599986154],
              [-147.68942500036346, 63.789410000271346],
              [-147.2482400003757, 63.61880099986632],
              [-147.6862109996379, 63.47215500015318],
              [-146.4895410000171, 63.48291299983515],
              [-146.43826899991438, 62.95930200018722],
              [-146.42645600014427, 62.24720899969566],
              [-146.98476500000473, 62.24247299982915],
              [-146.942666799733, 61.689909899822055],
              [-147.1583362997804, 61.64186199983146],
              [-147.26657370011614, 61.830382599577376],
              [-147.48387779982056, 61.78956000039375],
              [-148.44987000030025, 61.78525100043339],
              [-149.07306400030333, 61.70055899969816],
              [-148.98601999992303, 61.86215399990721],
              [-149.25189000012338, 61.84660000028981],
              [-149.2909829997656, 61.54049199980602],
              [-149.46992400039227, 61.49877899985103],
            ],
          ],
          [
            [
              [-145.02380500030048, 66.62709400038784],
              [-145.03773999990105, 66.47229399966841],
              [-145.21767200036248, 66.55211699979975],
              [-145.74079099980477, 66.3567299997897],
              [-145.5277549997934, 66.2472750001412],
              [-146.3762879996914, 66.34480200011228],
              [-146.63509599978053, 66.44363500005528],
              [-145.80355400011697, 66.59450200016721],
              [-145.358994000073, 66.54083600028122],
              [-145.02380500030048, 66.62709400038784],
            ],
          ],
        ],
      },
      id: 0,
      NAME: 'AKGD',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'AKMS',
        id: 1,
        label: 'AKMS',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.225687874744,
        year: 2023,
        centroid: [83.39549764049552, 329.982807044359],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [178.69958099956352, 51.64276800044291],
              [178.97021299993003, 51.588639999936106],
              [179.2809669997273, 51.3900220002152],
              [179.05842300012148, 51.454923000196345],
              [178.69958099956352, 51.64276800044291],
            ],
          ],
          [
            [
              [-176.2816940003778, 51.86391999970829],
              [-176.28992200030004, 51.7416790003856],
              [-176.42433799989874, 51.850621999805526],
              [-176.2816940003778, 51.86391999970829],
            ],
          ],
          [
            [
              [-178.09063299981307, 51.91939899956424],
              [-177.95209599993044, 51.91534899985652],
              [-177.81748500033248, 51.706342000383074],
              [-178.2151240003723, 51.857800999916265],
              [-178.09063299981307, 51.91939899956424],
            ],
          ],
          [
            [
              [-177.14394699985414, 51.943442000348114],
              [-177.04509099974982, 51.89860600026674],
              [-177.14567600044703, 51.707294000217985],
              [-177.51559099992468, 51.72497900008085],
              [-177.20567600014726, 51.8206400003358],
              [-177.14394699985414, 51.943442000348114],
            ],
          ],
          [
            [
              [-176.57997499964648, 52.00323899968015],
              [-176.63546700010195, 51.85523500029507],
              [-176.42864000043565, 51.84051999979823],
              [-176.46628799999118, 51.72923300020284],
              [-176.93095299998095, 51.59247000029035],
              [-176.9844890001672, 51.65741200036359],
              [-176.70443399962934, 51.788448999721595],
              [-176.81043400002906, 51.92708899985752],
              [-176.57997499964648, 52.00323899968015],
            ],
          ],
          [
            [
              [179.64763299956337, 52.026259000052846],
              [179.76663999993616, 51.97407200002283],
              [179.61548600007893, 51.87160299967877],
              [179.48246299996754, 51.98283500033506],
              [179.64763299956337, 52.026259000052846],
            ],
          ],
          [
            [
              [-176.1344219996755, 52.11255199997487],
              [-176.02183899967008, 51.98484799963552],
              [-176.18646999959077, 51.99934800011016],
              [-176.1344219996755, 52.11255199997487],
            ],
          ],
          [
            [
              [-173.51905600043403, 52.152209000445055],
              [-173.55060999955182, 52.11757799972497],
              [-172.95357800002466, 52.09568500006276],
              [-173.14513200044144, 52.06309499993438],
              [-173.83155599980952, 52.04076399985877],
              [-173.88493399990415, 52.111180999703436],
              [-173.51905600043403, 52.152209000445055],
            ],
          ],
          [
            [
              [-172.42916999959579, 52.38708400032641],
              [-172.30287699957384, 52.3300000001999],
              [-172.60893599959667, 52.253013999596476],
              [-172.42916999959579, 52.38708400032641],
            ],
          ],
          [
            [
              [-174.14314100015702, 52.415973999800315],
              [-173.98941500040192, 52.32527599998747],
              [-174.19672099967437, 52.19583799972395],
              [-174.08281499981237, 52.13206999983066],
              [-174.38873699981266, 52.10376899963967],
              [-174.41110199965752, 52.03749600024025],
              [-174.73659300006688, 52.00730900031016],
              [-175.092867000012, 52.03479399974333],
              [-174.62028199991434, 52.11103800030355],
              [-174.28461000035122, 52.2182489998915],
              [-174.31751999994802, 52.38053799972897],
              [-174.14314100015702, 52.415973999800315],
            ],
          ],
          [
            [
              [173.76254700034383, 52.51234000019093],
              [173.725698999909, 52.3565790001208],
              [173.35610499994584, 52.405563999978654],
              [173.76254700034383, 52.51234000019093],
            ],
          ],
          [
            [
              [-170.66259400041275, 52.6983149996376],
              [-170.6038619998314, 52.60173300007796],
              [-170.78510799973438, 52.54116300017239],
              [-170.66259400041275, 52.6983149996376],
            ],
          ],
          [
            [
              [172.83241700034432, 53.001094000387866],
              [173.10724399991068, 52.99322800007218],
              [173.31758699984027, 52.91111000022636],
              [173.17540700013296, 52.79120199967258],
              [172.90643599992154, 52.74613299963829],
              [172.73790500001576, 52.792508999690654],
              [172.79836100006014, 52.88454400000563],
              [172.44475099975887, 52.92097400005014],
              [172.83241700034432, 53.001094000387866],
            ],
          ],
          [
            [
              [-167.9684600002288, 53.55610600019179],
              [-167.78916400031832, 53.51932900033313],
              [-167.84232899958363, 53.38649099975987],
              [-168.2707449997819, 53.24281100012763],
              [-168.4571039998497, 53.055839999716284],
              [-169.0669070001579, 52.830143000399175],
              [-168.75969199988586, 53.081461000424895],
              [-168.79369799966292, 53.16039199989092],
              [-168.60404899986142, 53.27797800038445],
              [-168.3439939998232, 53.26214999982267],
              [-168.40820799959948, 53.41952899986353],
              [-168.23386299957775, 53.52833400011406],
              [-167.9684600002288, 53.55610600019179],
            ],
          ],
          [
            [
              [-166.11992200030005, 53.85504900031117],
              [-166.2383199995683, 53.711502999663765],
              [-166.30842000008292, 53.787335000110204],
              [-166.11992200030005, 53.85504900031117],
            ],
          ],
          [
            [
              [-166.65732200001025, 54.01374900011632],
              [-166.5902087999961, 53.83127190027801],
              [-166.3648099996817, 53.94498900024223],
              [-166.2018710004463, 53.93342000003304],
              [-166.57677299967418, 53.70485199962013],
              [-166.3431990004335, 53.78734899985653],
              [-166.27489600005035, 53.68725300012591],
              [-166.50958400030134, 53.65104999975773],
              [-166.74916999979564, 53.443239999726245],
              [-166.9162369996378, 53.467854999908354],
              [-167.6560080003689, 53.246795000389],
              [-167.85151200037848, 53.30866900017429],
              [-167.47309299994197, 53.446921000403904],
              [-167.06901099955795, 53.511363999948685],
              [-167.16319700014142, 53.61381400031593],
              [-166.99687000025028, 53.625039999996034],
              [-167.14729299967217, 53.866453000105935],
              [-166.89074899966658, 53.989708000324015],
              [-166.65732200001025, 54.01374900011632],
            ],
          ],
          [
            [
              [-165.9294349996255, 54.22127599968769],
              [-165.67147700006348, 54.09623599989152],
              [-166.04796499958505, 54.04477400002014],
              [-166.08407300006888, 54.17236999987563],
              [-165.9294349996255, 54.22127599968769],
            ],
          ],
          [
            [
              [-165.47845300020577, 54.29533400016402],
              [-165.40537700004847, 54.21283799997377],
              [-165.56327699983365, 54.10633599980662],
              [-165.66938399977175, 54.22903599961177],
              [-165.47845300020577, 54.29533400016402],
            ],
          ],
          [
            [
              [-132.72816200007622, 54.93057700002856],
              [-132.63406600004583, 54.75575499959359],
              [-132.8046700002203, 54.8733879995566],
              [-132.72816200007622, 54.93057700002856],
            ],
          ],
          [
            [
              [-162.29500500008066, 54.98513100039543],
              [-162.32109499993427, 54.82792800037697],
              [-162.42567799973986, 54.92176600020082],
              [-162.29500500008066, 54.98513100039543],
            ],
          ],
          [
            [
              [-131.24938799985625, 54.999525999625234],
              [-131.35158700033975, 54.86241299976018],
              [-131.45791399963133, 54.969846999739275],
              [-131.24938799985625, 54.999525999625234],
            ],
          ],
          [
            [
              [-163.763564999625, 55.05217200013777],
              [-163.44285500025802, 54.969876000177294],
              [-163.3278849998928, 54.7531879999263],
              [-163.58708299998042, 54.608910999742875],
              [-164.047268000218, 54.62511299956532],
              [-164.32853700008246, 54.53969300033174],
              [-164.41682000004295, 54.43171400040086],
              [-164.844931999712, 54.41758399990175],
              [-164.93218799997618, 54.59874600042764],
              [-164.70946600025567, 54.661519000301666],
              [-164.5640499997077, 54.87553999987114],
              [-164.23007300006887, 54.90201100020755],
              [-163.763564999625, 55.05217200013777],
            ],
          ],
          [
            [
              [-132.83443999980614, 55.20279799992778],
              [-132.6907159999434, 55.03154899968666],
              [-132.89319299955724, 55.04173900015479],
              [-132.83443999980614, 55.20279799992778],
            ],
          ],
          [
            [
              [-133.1093149997874, 55.21874999991263],
              [-133.05566499973992, 55.07700000024988],
              [-132.74888599978902, 54.82445999962931],
              [-132.84068099982824, 54.69717399968039],
              [-133.16168099997816, 54.9509909998348],
              [-133.21665399988217, 55.24374799977045],
              [-133.1093149997874, 55.21874999991263],
            ],
          ],
          [
            [
              [-131.56928999973366, 55.286728999743616],
              [-131.40537100027143, 55.21401199995387],
              [-131.3849170004192, 55.022030999631],
              [-131.64980700039274, 55.02783400013902],
              [-131.5307157002693, 55.13796829999711],
              [-131.56928999973366, 55.286728999743616],
            ],
          ],
          [
            [
              [-159.87324499965698, 55.286353000390704],
              [-159.8685819995596, 55.094887999581545],
              [-160.178707000028, 54.94458899958272],
              [-159.87324499965698, 55.286353000390704],
            ],
          ],
          [
            [
              [-133.34408500022255, 55.347658900238116],
              [-133.25327599978755, 55.22447999975225],
              [-133.4339250000387, 55.213414000255966],
              [-133.34408500022255, 55.347658900238116],
            ],
          ],
          [
            [
              [-160.35687900026562, 55.36204199963862],
              [-160.32804000044564, 55.253964999685024],
              [-160.5289663997795, 55.31961719977403],
              [-160.35687900026562, 55.36204199963862],
            ],
          ],
          [
            [
              [-160.7102989998989, 55.40307599975762],
              [-160.4939249997389, 55.22349400014804],
              [-160.52523300010284, 55.12987000030034],
              [-160.72805400029185, 55.20234100043689],
              [-160.82312500031847, 55.11856100038989],
              [-160.85673599986646, 55.321568000163154],
              [-160.7102989998989, 55.40307599975762],
            ],
          ],
          [
            [
              [-131.84774999956278, 55.426261999691576],
              [-131.69971200040845, 55.31163299976316],
              [-131.82500700027282, 55.18386500006977],
              [-131.84774999956278, 55.426261999691576],
            ],
          ],
          [
            [
              [-133.5709419999733, 55.8357530004007],
              [-133.34865899981298, 55.756227999622524],
              [-133.52402800029193, 55.69479600043513],
              [-133.69260599966714, 55.7826300003743],
              [-133.5709419999733, 55.8357530004007],
            ],
          ],
          [
            [
              [-155.5675300001094, 55.782470000190415],
              [-155.74911200021862, 55.82345900003287],
              [-155.57083100035035, 55.917311999649144],
              [-155.5675300001094, 55.782470000190415],
            ],
          ],
          [
            [
              [-131.26552300018625, 55.97109200029564],
              [-130.97966900022413, 55.70375599993952],
              [-130.98002899973852, 55.40398200016921],
              [-131.2216990000088, 55.195910999792886],
              [-131.55723899978, 55.29627300009895],
              [-131.83630699976817, 55.45081299962027],
              [-131.63431199989884, 55.60283399988924],
              [-131.7310539996423, 55.64188000006203],
              [-131.7172030003182, 55.83563999968629],
              [-131.26552300018625, 55.97109200029564],
            ],
          ],
          [
            [
              [-133.41108599991895, 56.16294800025008],
              [-133.2883029998835, 56.01614000026086],
              [-133.8126340003588, 55.951732999678256],
              [-133.62215500005317, 56.105479000355615],
              [-133.41108599991895, 56.16294800025008],
            ],
          ],
          [
            [
              [-132.41281699990458, 56.335343000279295],
              [-132.3744499995678, 56.22635699977576],
              [-132.11178399963183, 56.111049000011405],
              [-132.21818599968412, 55.936143000199365],
              [-132.6283720000677, 56.036022999861586],
              [-132.71749700018637, 56.216642999674775],
              [-132.41281699990458, 56.335343000279295],
            ],
          ],
          [
            [
              [-133.61898549958113, 56.35285119972315],
              [-133.198318999722, 56.33473800025854],
              [-133.03775600033913, 56.18256600022079],
              [-133.10532099996414, 56.09711599960377],
              [-132.63578400013148, 55.92102900018824],
              [-132.16922199989534, 55.452956000419135],
              [-132.47335700022535, 55.56206300020733],
              [-132.03191700016941, 55.28115399985728],
              [-132.03928800014108, 55.03846300016738],
              [-131.95797299955427, 54.796067999738455],
              [-132.03002800029196, 54.70563999978623],
              [-132.30515500020306, 54.72181900034667],
              [-132.42235099979877, 55.04750299976371],
              [-132.43614400004554, 54.92595500002329],
              [-132.61338799975636, 54.974680999628504],
              [-132.57530099974133, 55.17258199955967],
              [-132.80011599975353, 55.18361900041657],
              [-132.85558400000156, 55.28040100020604],
              [-133.21687500018106, 55.28228699994514],
              [-133.22586400012347, 55.38388100040788],
              [-132.91909599978055, 55.34715600024924],
              [-133.1467989998739, 55.466019000276674],
              [-133.04795000009238, 55.60079200015076],
              [-133.38502300041108, 55.61983999991611],
              [-133.1561900003682, 55.81263600005144],
              [-133.24989600040004, 55.89055100032846],
              [-133.26554399985565, 56.14623600029125],
              [-133.58480799998915, 56.18066399974384],
              [-133.61898549958113, 56.35285119972315],
            ],
          ],
          [
            [
              [-132.70418899982246, 56.448247999845364],
              [-132.66221699961483, 56.273442000148236],
              [-132.85863799964392, 56.231638999640154],
              [-133.06977400016996, 56.35245599984455],
              [-132.95255400036677, 56.45167999983221],
              [-132.70418899982246, 56.448247999845364],
            ],
          ],
          [
            [
              [-154.49493799998868, 56.60172499980894],
              [-154.49244500013663, 56.513794999939364],
              [-154.74488799988126, 56.402717000089524],
              [-154.70589700044619, 56.52145699984072],
              [-154.49493799998868, 56.60172499980894],
            ],
          ],
          [
            [
              [-154.0817759999624, 56.60406299970771],
              [-153.8797699995858, 56.57301000031134],
              [-154.0439339995544, 56.502254000122036],
              [-154.36146799994822, 56.52939800001775],
              [-154.0817759999624, 56.60406299970771],
            ],
          ],
          [
            [
              [-169.74411299981506, 56.613915999923506],
              [-169.47126399973376, 56.598378000144635],
              [-169.585525999825, 56.53513600022626],
              [-169.74411299981506, 56.613915999923506],
            ],
          ],
          [
            [
              [-132.05319600029515, 56.69565100009362],
              [-131.83462699963627, 56.59336700018696],
              [-131.58291300023473, 56.60591899986201],
              [-131.08834599996788, 56.39748099964845],
              [-130.78561300043958, 56.35709799987285],
              [-130.47048799962147, 56.23157100010161],
              [-130.42944099980224, 56.1307500002124],
              [-130.1065050003055, 56.11060100003618],
              [-130.01742799970242, 55.91187799996976],
              [-130.1853260000948, 55.77785599965472],
              [-130.1659450002615, 55.59534099968744],
              [-130.01323100041031, 55.28449900032865],
              [-130.24268400026637, 55.042871000196556],
              [-130.5079670003767, 54.84125799995678],
              [-130.72980299970862, 54.772649999897624],
              [-130.9558479997853, 54.833163999918725],
              [-131.1027929997971, 55.1948999999351],
              [-130.8603659996911, 55.30515399955749],
              [-130.93281899989688, 55.43951100003267],
              [-130.91466800012807, 55.71582499982395],
              [-131.2227699999355, 55.98324599960324],
              [-131.44200299973863, 55.99948000000205],
              [-131.76169900000883, 55.87817199963814],
              [-131.97674600012778, 55.49984099966247],
              [-132.18799300037665, 55.58958000021687],
              [-132.185831100325, 55.80341600024826],
              [-131.9626339995594, 56.00441600009839],
              [-131.97330999995648, 56.172700000304815],
              [-132.08240500009066, 56.11731700037933],
              [-132.33273200028157, 56.2339720002077],
              [-132.39430299958372, 56.483360699936384],
              [-132.23664400012046, 56.68500600022679],
              [-132.05319600029515, 56.69565100009362],
            ],
          ],
          [
            [
              [-132.94165470010432, 56.822716599591445],
              [-132.54436100016, 56.581674999701534],
              [-132.94755099987873, 56.50683399998917],
              [-132.94165470010432, 56.822716599591445],
            ],
          ],
          [
            [
              [-134.23769239968448, 56.92650499980596],
              [-133.73013099984576, 56.77426600027576],
              [-133.97845300020577, 56.36672699965135],
              [-133.9513830001253, 56.09612399972286],
              [-134.0442890001372, 56.29671200035858],
              [-134.1270299999345, 55.99941399965644],
              [-134.2239339999541, 56.06681199967409],
              [-134.28569599997041, 56.34891500022712],
              [-134.03729599961065, 56.3604190001368],
              [-134.39486399987368, 56.71907400016505],
              [-134.40743999975615, 56.84636200020623],
              [-134.23769239968448, 56.92650499980596],
            ],
          ],
          [
            [
              [-133.8853069999181, 57.094794000242985],
              [-133.4278630001773, 57.008796000435154],
              [-133.10725500011813, 57.003117000249404],
              [-132.9866459996132, 56.92424399986078],
              [-132.9365410002669, 56.66244799957559],
              [-133.01529799980284, 56.594927000180974],
              [-133.36907999994202, 56.84434599986804],
              [-133.25073500041992, 56.63645899988302],
              [-133.08970700027783, 56.53419299990708],
              [-133.20280999998147, 56.44618399999166],
              [-133.44522400038727, 56.50334400002566],
              [-133.65209200014567, 56.436597000351355],
              [-133.7713759998025, 56.80443500027508],
              [-134.04532900043301, 57.02396300019234],
              [-133.8853069999181, 57.094794000242985],
            ],
          ],
          [
            [
              [-153.2093600003637, 57.20226800026808],
              [-152.87079599963565, 57.15920099992627],
              [-153.17975800043135, 57.09735699972583],
              [-153.3024869997752, 56.99477400041985],
              [-153.38778530005152, 57.10667229978685],
              [-153.2093600003637, 57.20226800026808],
            ],
          ],
          [
            [
              [-170.11744500038643, 57.24244699962941],
              [-170.26865800026647, 57.13732700024093],
              [-170.42046200042097, 57.19014499969205],
              [-170.11744500038643, 57.24244699962941],
            ],
          ],
          [
            [
              [-135.7671089995806, 57.33974799997026],
              [-135.56502500010362, 57.0894229998716],
              [-135.81730200028704, 56.98334100018707],
              [-135.7671089995806, 57.33974799997026],
            ],
          ],
          [
            [
              [-135.41102700039573, 57.555107000088015],
              [-135.00440199965254, 57.39788600013884],
              [-134.84321800041033, 57.408416000098384],
              [-134.8580160002382, 57.26771999957839],
              [-134.6143539998372, 56.66074900036614],
              [-134.61836799968341, 56.25313800001874],
              [-134.80168999999347, 56.23862199970557],
              [-135.1151630001723, 56.59060899980557],
              [-135.13582699981617, 56.68749800003275],
              [-135.36920599995688, 56.813566999617365],
              [-135.3602390001297, 57.247109999726774],
              [-135.54550900034008, 57.23099500031907],
              [-135.68347099978678, 57.37031500033703],
              [-135.41102700039573, 57.555107000088015],
            ],
          ],
          [
            [
              [-153.45321699986462, 57.96684600014282],
              [-153.2066230000514, 57.80332300005648],
              [-153.5377220000702, 57.937875999677715],
              [-153.45321699986462, 57.96684600014282],
            ],
          ],
          [
            [
              [-153.26086100023494, 57.99534899975657],
              [-152.63526800021802, 57.91931299979518],
              [-152.3254529996562, 57.82246200042101],
              [-152.4822859996991, 57.723397999717974],
              [-152.46777899980097, 57.598188000176094],
              [-152.15197500004618, 57.620699999605336],
              [-152.31849499984435, 57.43157999991712],
              [-152.9553399998411, 57.52210599989206],
              [-152.60404300008435, 57.35790299992357],
              [-152.8187454996051, 57.266097000276375],
              [-153.2295580001016, 57.22452100034394],
              [-153.63739500007915, 57.01652299973671],
              [-153.54055100012852, 56.99490200002731],
              [-153.90874800041985, 56.76641299966025],
              [-154.1494429997946, 56.74573600031624],
              [-153.87761299993997, 56.925627999832386],
              [-153.88129000043315, 57.11887500008123],
              [-154.0767559995897, 56.97146100002516],
              [-154.053439999956, 57.09189599970068],
              [-154.22607000003046, 57.16424599965319],
              [-154.46455800015156, 57.13196999961582],
              [-154.41101000031122, 57.05417200023766],
              [-154.09615100006857, 57.123290999580036],
              [-154.26173900005477, 56.90150099967144],
              [-154.52233499986033, 56.99214399964592],
              [-154.5265239996828, 57.175762000116265],
              [-154.7329600002038, 57.27691099984281],
              [-154.70844099995216, 57.44438699966037],
              [-154.35311100037234, 57.650649000251235],
              [-154.01097400034982, 57.65537100037142],
              [-153.761255000318, 57.311265000379535],
              [-153.88294100012703, 57.642102000007355],
              [-153.63987700032328, 57.63632299970675],
              [-153.94061799972087, 57.741578999970955],
              [-153.85979300014682, 57.87314300024934],
              [-153.62236100016, 57.89138000038679],
              [-153.2053990002636, 57.79273500012022],
              [-153.26086100023494, 57.99534899975657],
            ],
          ],
          [
            [
              [-136.49524000042567, 58.09429999974526],
              [-136.3388819998044, 58.01022699967638],
              [-136.4546730002587, 57.84362799983239],
              [-136.55458000026675, 57.90942099957954],
              [-136.49524000042567, 58.09429999974526],
            ],
          ],
          [
            [
              [-153.1991170001494, 58.102005999877065],
              [-152.89362300010134, 57.99363599990153],
              [-153.41978300038514, 58.059639000339644],
              [-153.1991170001494, 58.102005999877065],
            ],
          ],
          [
            [
              [-135.77035900016767, 58.26721400032591],
              [-134.975941000177, 58.048403000198334],
              [-134.94686100003508, 57.802902000427025],
              [-135.37404500007665, 57.80031199969909],
              [-135.23202299956176, 57.70186000023887],
              [-134.93189200041547, 57.75950400010959],
              [-134.86585500020806, 57.46460400027445],
              [-135.1191600001339, 57.49126200024119],
              [-135.81946100002511, 57.769886000438646],
              [-135.56235600022922, 57.591974999646595],
              [-135.55167399955542, 57.44960800030901],
              [-135.83779500013912, 57.38793499990038],
              [-136.14810300005337, 57.6425380003285],
              [-136.11435599962965, 57.69277899965118],
              [-136.42006499969995, 57.84614800003021],
              [-136.36235200024458, 58.20939000024839],
              [-136.23286699961233, 58.15321399972635],
              [-135.77035900016767, 58.26721400032591],
            ],
          ],
          [
            [
              [-134.53205599978452, 58.34393100021555],
              [-134.28207500026105, 58.21985099972392],
              [-134.62825499966846, 58.248294000168016],
              [-134.53205599978452, 58.34393100021555],
            ],
          ],
          [
            [
              [-134.90091199988888, 58.34984000021592],
              [-134.69550099987123, 58.16011000027635],
              [-134.55654300035917, 58.194580999913285],
              [-134.18759499960953, 58.08272300006644],
              [-133.90112099983423, 57.80540599988706],
              [-133.8927879995665, 57.683395000378994],
              [-134.31680960018286, 58.09383289996839],
              [-134.32321399982618, 57.99511999998805],
              [-133.852547000044, 57.46162100030898],
              [-133.98108800031093, 57.30170100000123],
              [-134.08082499967395, 57.37261600032821],
              [-134.15098100007305, 57.20643199983698],
              [-134.56251599971358, 57.017142000403055],
              [-134.6460419997385, 57.240132999938055],
              [-134.5770780003494, 57.475016000188305],
              [-134.72796899976947, 57.72098099977336],
              [-134.7853999997102, 58.09653700038234],
              [-134.90091199988888, 58.34984000021592],
            ],
          ],
          [
            [
              [-152.65118100020297, 58.48256500007477],
              [-152.48897299960421, 58.45907499961157],
              [-152.4776629996477, 58.33272899984354],
              [-152.09051899975202, 58.37264100038192],
              [-151.9621369996228, 58.33098899964267],
              [-152.08108399992662, 58.15427600013737],
              [-152.3256879997014, 58.24759300021685],
              [-152.26511100037234, 58.135732000231656],
              [-153.02058899968256, 58.04520300011842],
              [-153.2237090001702, 58.162121000383934],
              [-152.9904759995677, 58.19407399991519],
              [-153.0447440002354, 58.30679399994318],
              [-152.78683100005057, 58.28093099976587],
              [-152.81220700025284, 58.40346399996366],
              [-152.65118100020297, 58.48256500007477],
            ],
          ],
          [
            [
              [-152.35222699957635, 58.635627999832366],
              [-152.40916800030294, 58.49491999965829],
              [-152.66628799989124, 58.54406999993063],
              [-152.35222699957635, 58.635627999832366],
            ],
          ],
          [
            [
              [-160.68571400020093, 58.803199999580386],
              [-160.8655089997405, 58.57473700041231],
              [-161.0552120002336, 58.54506399990373],
              [-161.05130199978743, 58.69998599995398],
              [-160.68571400020093, 58.803199999580386],
            ],
          ],
          [
            [
              [-148.04381799990074, 60.19364100023205],
              [-148.15976500035444, 60.031911000092634],
              [-148.29503999999596, 60.102536999682854],
              [-148.04381799990074, 60.19364100023205],
            ],
          ],
          [
            [
              [-141.0016959995707, 59.7698290001083],
              [-141.00184099996216, 60.30610500014569],
              [-140.5488889996276, 60.222671999912905],
              [-140.48303699985763, 60.31163099957104],
              [-140.00305699958085, 60.18660000018991],
              [-139.70930200038697, 60.34130900031016],
              [-139.09033300006786, 60.358992000080775],
              [-139.21538400037127, 60.09192799967752],
              [-138.71582700021588, 59.912058000276545],
              [-138.63096000040366, 59.77157100040142],
              [-137.60442600005985, 59.24475300035073],
              [-137.4461874001284, 58.910321999560665],
              [-136.8239780003844, 59.160780000396755],
              [-136.57828199971448, 59.16752300018635],
              [-136.46333200027158, 59.287515000117196],
              [-136.47126500007965, 59.46806500029959],
              [-136.29821200028357, 59.46822100029897],
              [-136.34635499998325, 59.603682000424044],
              [-135.94193300010784, 59.66737200031764],
              [-135.47023899973004, 59.80308000014196],
              [-135.0190430003342, 59.56776799989336],
              [-135.08982399987764, 59.431171000441395],
              [-134.95539699977166, 59.283112000318624],
              [-134.69810899963062, 59.25098099977339],
              [-134.37883399988914, 59.03746900029421],
              [-134.25117799996468, 58.85968800010119],
              [-133.8445580003514, 58.72949199995588],
              [-133.38563199971696, 58.428486000028954],
              [-133.4671319998419, 58.385684000216486],
              [-133.18172199967051, 58.149178999811056],
              [-132.5627249998588, 57.50047199958317],
              [-132.2550940001879, 57.21097299970421],
              [-132.3737980000776, 57.0915689999095],
              [-132.05369299983204, 57.0456759996477],
              [-132.12759100012454, 56.87047000039024],
              [-131.87348199999428, 56.79874899976659],
              [-131.89605300034566, 56.64349699978675],
              [-132.0812750001411, 56.71431199999887],
              [-132.36305100000362, 56.66469399972834],
              [-132.77531099980274, 56.83525999994907],
              [-132.89892000015783, 57.02336200035609],
              [-133.56364599986296, 57.180863999773806],
              [-133.47089099961988, 57.38498999988866],
              [-133.6496429996247, 57.712613999736334],
              [-133.17571000031626, 57.58115399975736],
              [-133.55824800004513, 57.77613399988422],
              [-133.58692499958903, 57.924449000121285],
              [-133.72507539980984, 57.80155150020164],
              [-134.04872699975118, 58.061631999617134],
              [-134.07581099957793, 58.27864899975157],
              [-134.2214169998946, 58.20601700028436],
              [-134.51715580010006, 58.35604350030735],
              [-134.7253574998487, 58.371308699736744],
              [-134.9894776999359, 58.675353400039455],
              [-134.9335840002014, 58.78496400038836],
              [-135.13529200032553, 58.83425499996832],
              [-135.18572200027006, 59.04803500011519],
              [-135.39202900023815, 59.29067300005897],
              [-135.38449299985206, 59.17323700018744],
              [-135.59627899977596, 59.265485999579255],
              [-135.37763200001677, 59.06484800023509],
              [-135.37663199976697, 58.92516200042604],
              [-135.1383940003828, 58.61887899996594],
              [-135.05654500035143, 58.350612999890075],
              [-135.1666700003202, 58.20972999973975],
              [-135.34507599965764, 58.27087199994287],
              [-135.45216700000702, 58.454339999791216],
              [-135.91846999999046, 58.381085000372536],
              [-135.84357200034748, 58.519059000372636],
              [-136.087738999755, 58.81748099984833],
              [-136.17395799986178, 58.755856999900686],
              [-136.86945400030186, 58.96312199998039],
              [-136.89268499961304, 58.88807899994595],
              [-136.56591200033853, 58.83389599960077],
              [-136.26900399963483, 58.65142699995613],
              [-136.035742000393, 58.381942000323136],
              [-136.36771700033927, 58.30198000007698],
              [-137.08835500008314, 58.38009799982291],
              [-137.60761300043958, 58.6006009997364],
              [-137.90157700027834, 58.76485700035033],
              [-137.94338640036204, 58.87928990040865],
              [-138.17298499955803, 59.003598000447425],
              [-138.9444070002828, 59.25366500033954],
              [-139.33372899989342, 59.34924999978773],
              [-139.85848200004426, 59.532523999682894],
              [-139.53141299971014, 59.68493900013482],
              [-139.65047299982905, 59.87816700040679],
              [-139.5275879995865, 60.06148100034795],
              [-139.83128000017183, 59.82243299958333],
              [-140.14856099969035, 59.87860099973642],
              [-140.3368220002351, 59.7744760003672],
              [-140.00715100041828, 59.785420999679445],
              [-140.31559399976322, 59.69514500044147],
              [-141.0016959995707, 59.7698290001083],
            ],
          ],
          [
            [
              [-147.13550299956376, 60.3438860004386],
              [-146.91844100005207, 60.314581999859456],
              [-147.49978299998543, 59.951069999780714],
              [-147.4438109998777, 59.880716000143366],
              [-147.87409699997653, 59.783260999895276],
              [-147.80425799980682, 59.93649700043625],
              [-147.40600100004607, 60.11263100022052],
              [-147.13550299956376, 60.3438860004386],
            ],
          ],
          [
            [
              [-166.15839600017523, 60.427224999933856],
              [-166.09308700026483, 60.324192999707236],
              [-165.67975100030839, 60.29336800003324],
              [-165.73043300018279, 60.05679700018146],
              [-165.56031399989115, 59.901061000364905],
              [-166.17311499995725, 59.78734999960284],
              [-166.61656600012077, 59.85062400009758],
              [-167.3427019997974, 60.0723960000754],
              [-167.45552400003254, 60.206304999676036],
              [-166.85857499983635, 60.20656700006708],
              [-166.15839600017523, 60.427224999933856],
            ],
          ],
          [
            [
              [-146.5380250001536, 60.4909179999658],
              [-146.08466900007426, 60.39573900035464],
              [-146.6313070004177, 60.24045499979843],
              [-146.730559999944, 60.39468300022031],
              [-146.5380250001536, 60.4909179999658],
            ],
          ],
          [
            [
              [-147.56316600011078, 60.571566000370694],
              [-147.76069700006647, 60.156396000375196],
              [-147.9019280000771, 60.285280000271825],
              [-147.82844500003668, 60.440529000113315],
              [-147.56316600011078, 60.571566000370694],
            ],
          ],
          [
            [
              [-148.6800670002918, 59.94379720038057],
              [-148.66516900034907, 60.45815399990721],
              [-148.4516830002702, 60.54594499966208],
              [-148.26976600000086, 60.49078400008159],
              [-148.0815739999401, 60.59149400024796],
              [-147.96831700032928, 60.41588500039251],
              [-148.14552400013247, 60.39955700015548],
              [-148.3257040003393, 60.26182499962408],
              [-148.13525000028724, 60.16453099960603],
              [-148.6800670002918, 59.94379720038057],
            ],
          ],
          [
            [
              [-172.94692399984268, 60.56462200030512],
              [-172.7064730000289, 60.42517900001087],
              [-172.2548210002889, 60.32646700025191],
              [-172.5896250002935, 60.314864000273474],
              [-172.9514760002172, 60.47864899985154],
              [-172.94692399984268, 60.56462200030512],
            ],
          ],
          [
            [
              [-145.77081200017363, 60.61726299968774],
              [-145.8259440002154, 60.55281399986626],
              [-146.33100999991154, 60.460031000130584],
              [-146.29158500024752, 60.51903699985769],
              [-145.77081200017363, 60.61726299968774],
            ],
          ],
          [
            [
              [-148.65606100031488, 60.49822100039893],
              [-148.6564809998982, 60.66705099970392],
              [-148.40570499968595, 60.78030099989127],
              [-148.1927350000202, 60.60989099966997],
              [-148.3324460000828, 60.53032799983737],
              [-148.65606100031488, 60.49822100039893],
            ],
          ],
          [
            [
              [-164.91365100039332, 60.926215000022296],
              [-164.6924750000212, 60.83164799985536],
              [-164.26416400016845, 60.78962900017825],
              [-164.19925199968, 60.6774540001021],
              [-164.4880440002304, 60.566906999558455],
              [-164.4499790003306, 60.479836999777774],
              [-164.69888699983514, 60.29629900029869],
              [-165.13230499957604, 60.4371519999649],
              [-164.9712799995723, 60.53955800010169],
              [-165.3699539996773, 60.50886700031185],
              [-164.96541099961792, 60.72430699966833],
              [-164.91365100039332, 60.926215000022296],
            ],
          ],
          [
            [
              [-148.03708799981132, 60.92613399988426],
              [-147.92063999963625, 60.81244300004448],
              [-148.1445189996521, 60.79708999980369],
              [-148.03708799981132, 60.92613399988426],
            ],
          ],
          [
            [
              [-171.66839100044427, 63.78235499958362],
              [-171.47831599988345, 63.600381000282994],
              [-170.93770300039313, 63.56424999963781],
              [-170.47432000016784, 63.697304000279416],
              [-170.09933799994872, 63.6122910000297],
              [-170.06067000012038, 63.49508700006504],
              [-169.5610810002879, 63.36220600020681],
              [-168.6885679998133, 63.29604599972316],
              [-168.8621659995612, 63.14657800027453],
              [-169.37852209991496, 63.15037240006626],
              [-169.53240099970634, 62.978365999791095],
              [-169.91100499968096, 63.14540099995622],
              [-170.29560800020903, 63.18731800032549],
              [-170.36829200027557, 63.28517500022616],
              [-170.86893800028847, 63.41378900026223],
              [-171.10439299993698, 63.422972000157756],
              [-171.44129899974902, 63.30653899977506],
              [-171.74288000011188, 63.365642000378045],
              [-171.8535590004475, 63.48456400042835],
              [-171.66839100044427, 63.78235499958362],
            ],
          ],
          [
            [
              [-146.61906699984215, 60.68456199963663],
              [-146.5242980002525, 60.77885099957405],
              [-146.1707510001585, 60.84877800020462],
              [-146.6337760000623, 60.82098500005776],
              [-146.7558469996393, 60.96122200009529],
              [-146.57138199967952, 61.118158000391475],
              [-146.97383899976998, 60.934727999597555],
              [-147.5176730003087, 60.89482000014294],
              [-147.56086500011963, 61.14609600003041],
              [-147.65986499966996, 60.89348100044788],
              [-147.85612400032232, 60.820882999850596],
              [-148.04094200037298, 60.95338300012543],
              [-147.68064300007435, 61.22296599978114],
              [-147.7250740003648, 61.277176999618916],
              [-148.09024599965312, 61.005109999626825],
              [-148.16855600015924, 61.07125899960323],
              [-148.33801499969246, 60.81747099988678],
              [-148.65576700024684, 60.72725599986455],
              [-149.2376069997632, 61.479119999788225],
              [-149.237562000386, 61.48226900021422],
              [-149.2434470001789, 61.4835279998174],
              [-149.24399700036125, 61.48354599974812],
              [-149.25271100021246, 61.483578000324485],
              [-151.74002900033807, 60.922784000081606],
              [-151.70380299980857, 60.73237600035219],
              [-152.05529499956455, 60.659053999642424],
              [-152.30922100024893, 60.506384000021626],
              [-152.2341990002836, 60.39388899957771],
              [-152.55675600028914, 60.22421800016065],
              [-152.93564199977843, 60.246437999614045],
              [-152.56912100033387, 60.07174899991645],
              [-152.70643200033652, 59.915284999802964],
              [-153.28580300020826, 59.82053500019015],
              [-152.99212600011478, 59.81002800039198],
              [-153.21415700034527, 59.63427200005282],
              [-153.4760980001226, 59.642730999835806],
              [-153.81343199988686, 59.53836500014472],
              [-153.7275479999402, 59.43534599961822],
              [-154.11357699967877, 59.29962700018598],
              [-154.17447799956, 59.025601999832475],
              [-153.70416199977643, 59.07577999984716],
              [-153.31805800017653, 58.88684199955867],
              [-153.40247299982906, 58.742607999559596],
              [-153.67759799964793, 58.611602999878585],
              [-153.897224999634, 58.606127000061065],
              [-154.08471399965134, 58.482763000212344],
              [-153.98228100006807, 58.39136000026383],
              [-154.16799800020752, 58.35837900009085],
              [-154.14527800017953, 58.21093200031163],
              [-154.46852699972123, 58.177755000093214],
              [-154.5686269996363, 58.025786999570414],
              [-155.02771000031623, 58.02528799994133],
              [-155.09899199958107, 57.884048000414964],
              [-155.32795700031528, 57.84102300021135],
              [-155.37956699981717, 57.71520000027982],
              [-155.60526199994132, 57.78066700028188],
              [-155.5951300003492, 57.6603450004215],
              [-155.7728339996893, 57.633028999788564],
              [-156.02355299997095, 57.438026000399645],
              [-156.21117199968802, 57.473174999826426],
              [-156.55510199965752, 57.28686700031187],
              [-156.35528200026408, 57.3207659996512],
              [-156.3346399998361, 57.18204500027662],
              [-156.88549600044004, 56.96692999971975],
              [-157.22378900036205, 56.78177799955512],
              [-157.3777890001622, 56.86785899959324],
              [-157.5632350003949, 56.70715099981885],
              [-157.90957199984788, 56.67289600025026],
              [-158.12717099984175, 56.552061000115145],
              [-157.81580599974706, 56.58738799965653],
              [-157.85620900044498, 56.50547000004053],
              [-158.3287979998278, 56.48420899984552],
              [-158.6677420000932, 56.26874700037382],
              [-158.43279499958953, 56.343504999855895],
              [-158.19225800030645, 56.285762999962515],
              [-158.3680299995848, 56.218322999806674],
              [-158.39042299982157, 56.08992199970061],
              [-158.63949699978667, 55.9860710003764],
              [-158.82860499982087, 56.015414000056126],
              [-159.072674000105, 55.92508300008046],
              [-159.52834499992179, 55.88845900008283],
              [-159.49468900009725, 55.76345099996371],
              [-159.62140099965637, 55.58561399988622],
              [-159.61817800031443, 55.812995000418994],
              [-159.81107399966533, 55.856569999905616],
              [-160.01841699974472, 55.718288000091206],
              [-160.35731100040232, 55.61317099994176],
              [-160.53665399978223, 55.474938999735116],
              [-160.86538100013303, 55.5269689997196],
              [-161.2322130004296, 55.35566100035493],
              [-161.50765699967076, 55.36278699982023],
              [-161.35993399975425, 55.592473999675406],
              [-161.5870469996193, 55.620060000168905],
              [-161.6864960000903, 55.40804100029197],
              [-161.87560600021672, 55.249921000254005],
              [-162.02963599960168, 55.239492999602305],
              [-161.9447059995822, 55.12423799958407],
              [-162.41000199989236, 55.03387399988526],
              [-162.5588410000121, 55.29816600016085],
              [-162.56399800040737, 54.952924999988795],
              [-162.83424600015275, 54.92685099997374],
              [-163.00155000013237, 55.08004400033042],
              [-163.2398980000926, 55.10637799974495],
              [-163.02570399973976, 54.9493169999796],
              [-163.36005200029953, 54.811819000346645],
              [-163.2452579999567, 54.96682199963561],
              [-163.33052999955981, 55.08995699971581],
              [-163.10501200040346, 55.18397899993096],
              [-162.85891199998878, 55.18437300011391],
              [-162.80606600014576, 55.29945800038644],
              [-162.48340599988697, 55.38697400005009],
              [-162.48368800030096, 55.49523699958792],
              [-162.24697200005772, 55.6800130003997],
              [-161.8162250002835, 55.88899399957347],
              [-160.87322999966472, 56.001448999971444],
              [-161.0279399998311, 55.89767100041638],
              [-160.67389900033857, 55.696258999553265],
              [-160.7715380000786, 55.885985000207654],
              [-160.53350800039388, 55.871479000355635],
              [-160.2562639999836, 55.76602199981551],
              [-160.2250779998498, 55.83893699974277],
              [-160.56194100037683, 55.999680000231876],
              [-160.34024899959164, 56.29127100035646],
              [-159.8280500001074, 56.54393600044614],
              [-159.24751799975584, 56.69615399990721],
              [-158.9503899996987, 56.838822999681724],
              [-158.60707300011885, 56.759047999965276],
              [-158.6948819998044, 56.90176300006243],
              [-158.63810700043769, 57.056869999650814],
              [-158.25056300008237, 57.31428600029875],
              [-157.67959700020137, 57.56393499980044],
              [-157.5749459999579, 58.129241000371906],
              [-157.39809799962296, 58.173419999833186],
              [-157.5440089996156, 58.280881000158104],
              [-157.46357500008617, 58.49775299990108],
              [-157.0680450001766, 58.7082180000607],
              [-156.96694500001172, 58.95227399974533],
              [-157.11639000019832, 58.86754700009402],
              [-158.14192899962362, 58.612882000404056],
              [-158.5365239995829, 58.789498999978946],
              [-158.53294530038528, 59.02426090022044],
              [-158.89377399957039, 58.720179000360645],
              [-158.68997500014612, 58.48984100016207],
              [-158.88639400008302, 58.39450200036708],
              [-159.0518539995624, 58.42898200041901],
              [-159.36464099958243, 58.74875599978964],
              [-159.7170379997039, 58.9307479999203],
              [-159.89870099995116, 58.77633399991424],
              [-160.00838600031364, 58.88070499983593],
              [-160.24773299957823, 58.893031999926905],
              [-160.357409000425, 59.07169849958615],
              [-160.81476699979717, 58.82495099988881],
              [-160.95616500031448, 58.87596499978497],
              [-161.28346499961, 58.76939900026372],
              [-161.36353300024774, 58.66028900033717],
              [-161.63412399962286, 58.599248000295006],
              [-162.15467800038937, 58.64665900041257],
              [-161.64379400039277, 58.800701000350955],
              [-161.75306100036485, 58.809501999717554],
              [-162.0157060002317, 59.21699299992707],
              [-161.9428120003735, 59.37395999985415],
              [-161.70404800011508, 59.501535999686666],
              [-162.21081199987387, 60.02677099958203],
              [-162.1884419997984, 60.15650900019028],
              [-162.53926900036404, 60.3395370004323],
              [-162.4457279998473, 60.17644899972163],
              [-162.51698199961956, 59.98103400021898],
              [-163.12697899988092, 59.828777999904844],
              [-163.63016800025298, 59.78093499965058],
              [-164.13102300001142, 59.8498250001237],
              [-164.09240799992924, 59.97537900024071],
              [-164.38636300025223, 60.07730499982591],
              [-164.6666410002819, 60.29595199958516],
              [-164.56513899956514, 60.44300900026519],
              [-164.02397399980023, 60.76308600011885],
              [-163.78061699997454, 60.753806000246755],
              [-163.79269000004345, 60.58488300025033],
              [-163.41482700006597, 60.70616000008397],
              [-163.54445500009814, 60.80880499955117],
              [-163.94728300021026, 60.85836299975267],
              [-163.9774940003478, 61.05309500013419],
              [-164.08591700006946, 60.87436200010626],
              [-164.53356999975566, 60.84700800041895],
              [-164.57440100040583, 60.907745999977976],
              [-165.0324199996832, 60.90373999960133],
              [-165.19496399958888, 60.97991599972369],
              [-164.9569380000886, 61.02456900035912],
              [-165.30790800005414, 61.182256000214295],
              [-165.34344300019427, 61.07056399992871],
              [-165.54961300013983, 61.088163000322254],
              [-165.63614000006092, 61.29409800022256],
              [-165.8589930004266, 61.31886500021966],
              [-165.7396350000552, 61.48162100000917],
              [-166.16523299980307, 61.55061900006683],
              [-166.13735300014082, 61.63307300011894],
              [-165.82213999976116, 61.67060999995158],
              [-166.0943120000987, 61.8138590003926],
              [-165.60009799992272, 61.85960300007844],
              [-165.7568069996433, 62.006337000252415],
              [-165.67560499977088, 62.135591000124634],
              [-164.85087799961997, 62.69219699969182],
              [-164.87564000028576, 62.806254000222],
              [-164.65175600003934, 63.029535999686686],
              [-164.44346000007891, 63.03614899977657],
              [-164.5453839995719, 63.15328200006428],
              [-164.048585999844, 63.26215499985341],
              [-163.75528399995662, 63.21746200007129],
              [-163.3635869996403, 63.03458699969036],
              [-163.04050100042082, 63.06215200011479],
              [-162.66791500007716, 63.22712899980354],
              [-162.26824299981456, 63.49079900017375],
              [-162.14259699995156, 63.43422700027588],
              [-161.45244899972153, 63.45400400038437],
              [-161.13675899982795, 63.504525000028764],
              [-160.76555999959427, 63.773553000170864],
              [-160.9761235996244, 64.23580820018833],
              [-161.23115900038752, 64.37094600015786],
              [-161.51876600025068, 64.39510900018024],
              [-161.37357100000162, 64.53502899998841],
              [-161.02418500023754, 64.49971900033165],
              [-160.78339800021752, 64.71716100027999],
              [-161.188784999628, 64.92169400027797],
              [-161.3769850000577, 64.77303699955792],
              [-162.06743299973311, 64.71323800013363],
              [-162.5399959997156, 64.5309309998658],
              [-162.7901679999532, 64.32518200044899],
              [-162.85756199978644, 64.49978000044672],
              [-163.13872200002027, 64.64751199987893],
              [-163.386698999759, 64.60091200028864],
              [-163.10743799986378, 64.50277900025071],
              [-163.10745899993287, 64.40919300035671],
              [-163.5978340002389, 64.56335599957976],
              [-164.42191700036923, 64.54529999969526],
              [-165.01651900025163, 64.43439199959118],
              [-166.23693899973503, 64.58355800040147],
              [-166.48380100021595, 64.73342000003305],
              [-166.46000700012294, 64.9121720000378],
              [-166.89772100012402, 65.13902799974244],
              [-166.6703199995683, 65.10971999987817],
              [-166.361307000018, 65.26251099968295],
              [-166.0421139995614, 65.23366100025504],
              [-165.65767400025487, 65.04920399976481],
              [-165.38000099984623, 65.15013900041458],
              [-166.02642700010594, 65.19427999992212],
              [-166.13780200016214, 65.28461099989778],
              [-167.3984579998368, 65.40026000009897],
              [-168.07520099972632, 65.57635499988339],
              [-167.27280100036586, 65.9007809997434],
              [-167.18485299966616, 65.84454700014402],
              [-166.65960600011678, 66.07362399974784],
              [-166.22318699958035, 66.17103299967323],
              [-166.0464719999828, 66.1078339999392],
              [-165.58458799963645, 66.12790099993128],
              [-165.87751400017095, 66.24031000000656],
              [-165.38055500021306, 66.41175700038531],
              [-165.00507799964993, 66.39298599990406],
              [-164.708801000166, 66.54212699956145],
              [-163.9659810000231, 66.59414800003026],
              [-163.7541709998917, 66.55128500010272],
              [-163.92988300000042, 66.21601400014606],
              [-163.76884800043484, 66.08132899983354],
              [-163.09300299968865, 66.06295999990414],
              [-162.74752000004793, 66.10063399975934],
              [-162.39189300026172, 66.02872500035852],
              [-161.9885459995982, 66.07137999968728],
              [-161.87984999987756, 65.9617279999473],
              [-161.48865100004357, 66.2680110004074],
              [-160.9794359996716, 66.23949600024025],
              [-161.10165000044714, 66.33118199974956],
              [-161.5326569996208, 66.3991000003648],
              [-161.92180600024668, 66.34766900012431],
              [-161.87179099965488, 66.4903519996451],
              [-162.17465199969, 66.68436200000633],
              [-162.50361900031658, 66.73663200026664],
              [-162.6135779998248, 66.84490300017336],
              [-162.3277399997012, 66.94350900044009],
              [-162.01366100035486, 66.77451099968295],
              [-162.06862499984385, 66.64113000014942],
              [-161.58061799992072, 66.4405540000671],
              [-161.177752999901, 66.53593500000028],
              [-160.79203099993066, 66.3697529996013],
              [-160.23545299985602, 66.38686199988143],
              [-160.20223200030654, 66.47391799991584],
              [-159.67634700011394, 66.39963699994763],
              [-159.9298680001081, 66.5398840004463],
              [-160.19235900006777, 66.48939000024836],
              [-160.3359439998157, 66.60581100007767],
              [-161.1416759999474, 66.63827799992981],
              [-161.4937139997013, 66.52709799987286],
              [-161.88236099966036, 66.71616099963046],
              [-161.68211000017635, 66.95606500029959],
              [-161.81196299979257, 67.04780899978556],
              [-162.44747000014036, 66.98601800023056],
              [-163.73857900032058, 67.12883599968171],
              [-163.81778900006228, 67.35250299981362],
              [-164.10654099966737, 67.60259900014381],
              [-164.5232800000719, 67.72151099973291],
              [-165.4701329996382, 68.05555980034455],
              [-165.85882209956023, 68.10762149963256],
              [-166.13799430039663, 68.24387400028496],
              [-166.64376330013616, 68.34201439994467],
              [-166.41695799971188, 68.38426200009127],
              [-166.2332299995648, 68.57554799984035],
              [-166.22485199991982, 68.87189399980832],
              [-165.3437130000549, 68.85868799965152],
              [-164.25241199961405, 68.92626599987602],
              [-163.6304250004134, 69.09979399999315],
              [-163.11056400012848, 69.37166599998596],
              [-162.96361199979393, 69.78037100042138],
              [-161.86147200043246, 70.30775899977806],
              [-161.8448740003348, 70.15041400040587],
              [-160.8365600002438, 70.3429880001961],
              [-160.14690600031165, 70.58801599973867],
              [-159.90117199968802, 70.58613400018402],
              [-160.0054639995639, 70.38905999971928],
              [-159.8351680001031, 70.24978900016231],
              [-159.83870300034317, 70.57738699971031],
              [-160.10679699968176, 70.61145699974082],
              [-159.66035299999092, 70.78552799971749],
              [-159.16486999975066, 70.85665399988227],
              [-159.3049879996964, 70.74044199979852],
              [-158.02903100038034, 70.83216700020694],
              [-157.49911599960367, 70.94892500028857],
              [-156.59102399965784, 71.34659099977489],
              [-156.0308100000814, 71.17006199976151],
              [-155.56364299982457, 71.16418600038367],
              [-155.71692399974276, 70.98131200004883],
              [-155.9878039998547, 70.96322499963406],
              [-155.94513699997253, 70.77778299958584],
              [-155.63228899983744, 70.81829800005272],
              [-155.14655000018234, 71.11148600007891],
              [-154.57293899973502, 70.99067500015121],
              [-154.64451299987502, 70.88804799971547],
              [-154.1641400003607, 70.7701180004454],
              [-153.88603299972314, 70.886532999998],
              [-153.13057200029755, 70.92853099960598],
              [-152.26736499999473, 70.83580399975483],
              [-152.41890999989656, 70.61062700013599],
              [-151.81698300036516, 70.54739299968725],
              [-151.87801399994612, 70.43131400034088],
              [-151.19802299956174, 70.3688870002349],
              [-150.7348399995663, 70.50034199998339],
              [-150.1145379998288, 70.43405399989223],
              [-149.87189100036935, 70.51748700012502],
              [-149.1675490002861, 70.48945000041726],
              [-148.5946690002741, 70.4029639996889],
              [-148.4058429997546, 70.30415900013782],
              [-148.10762099960942, 70.3430929996423],
              [-147.78249399979822, 70.21590399966988],
              [-146.98678000029673, 70.14974300003945],
              [-146.52030699966826, 70.1914929999021],
              [-145.86033899994487, 70.13524000032584],
              [-145.25418899992238, 69.99755800030152],
              [-144.62952699967127, 69.9707790001508],
              [-144.12322399958788, 70.05835599992952],
              [-143.28447799956, 70.11931699987969],
              [-142.77274399993564, 70.03426300043719],
              [-142.01169700011644, 69.79801400014605],
              [-141.540015000292, 69.73111299966524],
              [-141.26693500034997, 69.59694599985806],
              [-141.00252700012095, 69.646660000059],
              [-141.00185399966233, 60.39043799961405],
            ],
          ],
        ],
      },
      id: 1,
      NAME: 'AKMS',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'AZNM',
        id: 2,
        label: 'AZNM',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.353521440144,
        year: 2023,
        centroid: [173.88294565258624, 273.3279984494679],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-115.90793900038454, 32.63373400042383],
              [-116.2709350000502, 32.60545200020971],
              [-116.22008899980744, 32.82878200008929],
              [-116.42230199983737, 32.85650199956768],
              [-116.51750399960986, 32.97467149998977],
              [-116.74124300036414, 32.986811000427394],
              [-116.51335900001783, 33.16393299990807],
              [-116.5014139995564, 33.34115300031078],
              [-116.61768799980132, 33.427354999633565],
              [-116.08516500016458, 33.42593299970821],
              [-116.10272699975121, 32.855771000031666],
              [-115.85214899967656, 32.80988500009272],
              [-115.96297599964265, 32.74101200040354],
              [-115.90793900038454, 32.63373400042383],
            ],
          ],
          [
            [
              [-108.25033200032152, 36.91011299971524],
              [-108.09902899988839, 36.91910399974984],
              [-108.05359300001692, 36.74357700007852],
              [-107.88226199959155, 36.81877800020459],
              [-107.78858099981323, 37.00000199999238],
              [-106.86979599958568, 36.99242699960638],
              [-105.02922800027198, 36.992730000089466],
              [-102.86544999961774, 36.99959099992475],
              [-102.80498700014988, 36.71921099968796],
              [-103.00213660032381, 36.719434500102125],
              [-102.83087899986589, 36.587398999664174],
              [-102.68893800038836, 36.628981999919404],
              [-102.64312109985883, 36.50047629984141],
              [-103.04192380014325, 36.50040079995699],
              [-103.04116800000315, 35.89902400025744],
              [-103.1608992999627, 35.89064029981006],
              [-103.125798999724, 35.73978099969344],
              [-103.37497299980407, 35.74001299960031],
              [-103.36497099991169, 36.086364999745],
              [-103.55319200041043, 36.08664700015896],
              [-103.43994200022308, 35.998915999573796],
              [-103.68592499973892, 35.94046400021347],
              [-103.79398299971564, 36.17399500016916],
              [-104.13409299979207, 36.21828800039094],
              [-104.13396700027681, 36.07339200044049],
              [-104.36478700021985, 36.07101200040353],
              [-104.362246999999, 35.78325499991837],
              [-104.86242600005983, 35.77552200034012],
              [-104.91222999991453, 35.69547399972538],
              [-104.84192599988495, 35.440099999715244],
              [-104.66113000004941, 35.33287799962005],
              [-104.53164700040873, 35.153041999988375],
              [-104.56785800024647, 34.914912000188735],
              [-104.5122150000222, 34.82902500010374],
              [-104.12940999967174, 34.7793119999489],
              [-104.0967889999124, 34.58110100011112],
              [-104.21899100013451, 34.495982000369054],
              [-104.00732100016398, 34.237021999565684],
              [-104.0877589998779, 34.11203599956178],
              [-103.84162899987842, 33.98039600027522],
              [-103.71883600028116, 33.64023499964554],
              [-103.5068229997816, 33.657372000317594],
              [-103.51026800036789, 33.570257000260426],
              [-103.72074300008933, 33.56967899968612],
              [-103.7661769998686, 33.13952500027858],
              [-104.15507599975757, 33.13981900034662],
              [-104.22347700016337, 33.24154799984035],
              [-104.34666099980524, 33.21787299983913],
              [-104.39127830005344, 33.39679449956657],
              [-104.69057959996854, 33.39387950003896],
              [-104.69665999995897, 33.21761200039356],
              [-104.90584899973152, 33.11761699992468],
              [-104.84178200043891, 32.84303299987312],
              [-105.17815819974106, 32.88417479992711],
              [-105.32215800009158, 32.96199199983096],
              [-105.33592700013094, 32.77685200021966],
              [-105.13482299998145, 32.724672999659276],
              [-104.84246100027491, 32.719261000095116],
              [-104.84775799993173, 32.00051999969827],
              [-105.99800399998458, 32.002328000337],
              [-105.71507600005731, 31.821797000131482],
              [-105.48288299975059, 31.781470000240347],
              [-105.4524759995677, 31.597065000349517],
              [-105.15459599990544, 31.64780300010841],
              [-104.6119999998001, 31.518104000399376],
              [-104.59352100019396, 31.58562599984009],
              [-104.06497000026525, 31.537521000094102],
              [-104.10236499984484, 31.105175000326028],
              [-104.97973970022696, 30.629163700144716],
              [-105.21506399960384, 30.805935000000318],
              [-105.39484999962775, 30.849235000295096],
              [-105.6041829997456, 31.083472999579328],
              [-105.7729469996043, 31.16672400041233],
              [-105.95399469989547, 31.36484720033809],
              [-106.20664510039103, 31.466189500345195],
              [-106.38055799955202, 31.731612999740207],
              [-106.52817900016072, 31.78386099988529],
              [-108.20847800015957, 31.783663999793816],
              [-108.20846799969837, 31.333374999956334],
              [-109.08933000027923, 31.332408000328996],
              [-111.07494879984722, 31.332246300426448],
              [-113.14856599992095, 31.98043199963712],
              [-114.81367900018569, 32.494204999760996],
              [-114.71977700010842, 32.718918999612185],
              [-115.6621269997612, 32.65257000030533],
              [-115.77357899977096, 32.774886000388676],
              [-115.66872400001256, 32.926482999990526],
              [-115.84251999989806, 33.120704000189505],
              [-115.70555499966349, 33.223943000069426],
              [-115.90199399962336, 33.426479999752246],
              [-116.04230999970667, 33.42622000035277],
              [-116.10831000000644, 33.671442999894566],
              [-116.23343800026345, 33.59830400042932],
              [-116.4602508001343, 33.714074099739946],
              [-116.44091400018095, 33.834146999984114],
              [-116.60225899965309, 33.9161479998304],
              [-116.59149060021099, 34.0326261003143],
              [-116.457932999908, 34.032873000188886],
              [-116.66500600012677, 34.275926000384686],
              [-116.12754200016315, 34.25150300006345],
              [-116.15653800002866, 34.39584399960097],
              [-116.03290699955835, 34.42142800040193],
              [-115.98351499981737, 34.29668399986673],
              [-115.72033200032155, 34.29594199982347],
              [-115.74406800043784, 34.55244799987537],
              [-115.54311800019553, 34.43190199957769],
              [-115.33351700030926, 34.07722420003688],
              [-114.43543000039415, 34.07972699980127],
              [-114.22971599989347, 34.18692899987349],
              [-114.13828300036016, 34.303230999611],
              [-114.335371999718, 34.45003799955407],
              [-114.47047699961382, 34.711367999933316],
              [-114.6343830002752, 34.87289100041937],
              [-114.63301300004986, 35.002086000268775],
              [-115.89833399991414, 36.004289000037375],
              [-115.89692480003947, 36.84208489959849],
              [-114.95611399996108, 36.853404999840905],
              [-115.018712999905, 37.20281199967411],
              [-114.81229900039853, 37.56034400007559],
              [-114.83675899972803, 37.907168000402976],
              [-114.67196600043053, 37.87534000034077],
              [-114.43816239977491, 37.74647310015348],
              [-114.28056600032062, 37.78755600000943],
              [-114.05184299995443, 37.724001000046144],
              [-114.04683800027345, 36.194068999584715],
              [-114.15412999999944, 36.02386199973154],
              [-114.25080000001998, 36.01956600037067],
              [-114.27155000003245, 35.77600800026903],
              [-114.0437360002162, 35.75481300041969],
              [-114.05385500010811, 35.981480000401746],
              [-113.90442199957556, 35.94495999980421],
              [-113.810565999821, 36.04849599989052],
              [-113.63164700020889, 35.8194190002867],
              [-113.38499999975016, 35.75389799959305],
              [-113.31006400015343, 35.89200400028443],
              [-113.35417600012227, 36.04036900012932],
              [-113.0063430000294, 36.238753999897256],
              [-112.79376000022381, 36.28439500022915],
              [-112.64544700007895, 36.38508999970378],
              [-112.45609599963063, 36.336210000191386],
              [-112.5309479998503, 36.262908999550746],
              [-112.34001200005372, 36.23364900010131],
              [-112.20055700010545, 36.09691199958917],
              [-111.90575200015462, 36.04607799989981],
              [-111.80078299963571, 36.203006999873196],
              [-111.89224100032186, 36.370467999898324],
              [-111.3994969995868, 36.172853999712345],
              [-111.46057250032061, 36.30387810009432],
              [-111.34075400029684, 36.38624599995296],
              [-111.00072799959747, 36.25222799982237],
              [-110.82813429975812, 36.387289899709174],
              [-110.5067559997895, 36.375834000039106],
              [-110.33549299980206, 36.48372400036237],
              [-110.16951499981735, 36.43238699996016],
              [-110.00067400000506, 36.45934500027158],
              [-110.00067500005116, 35.66265799996677],
              [-109.82691399998106, 35.662462999967545],
              [-109.84369699961678, 35.17074399973586],
              [-109.6860909998997, 35.17011300031476],
              [-109.78950499975588, 35.05417100009163],
              [-109.73688100025794, 34.96763599980159],
              [-109.78997199970797, 34.79413199989193],
              [-109.8429039999196, 35.17040200015225],
              [-110.20377499961648, 35.1704060003367],
              [-110.32384799968543, 34.93762299980165],
              [-110.35220899994533, 34.69866499959011],
              [-110.10922279959249, 34.70230159983902],
              [-110.1331330001878, 34.797688000201106],
              [-109.81086199988135, 34.64202099996925],
              [-109.32473999965123, 34.67185699990068],
              [-109.04607009985517, 34.87073259962983],
              [-109.04633799979882, 35.66059800029751],
              [-108.26951099983273, 35.65853699968284],
              [-108.27183700007748, 36.16450000027487],
              [-108.5471509996189, 36.1841000003148],
              [-108.59708299998044, 36.41890100038091],
              [-108.5380380002535, 36.71774100024703],
              [-108.29340259975015, 36.73711620035243],
              [-108.25033200032152, 36.91011299971524],
            ],
            [
              [-110.75069300028173, 35.50257200009776],
              [-110.25068299992046, 35.51864400022049],
              [-110.28478300043508, 35.68609899996892],
              [-110.54995199978492, 35.79028300026033],
              [-110.64050400005954, 35.8881199003132],
              [-110.75069300028173, 35.76865999955936],
              [-110.75069300028173, 35.50257200009776],
            ],
          ],
        ],
      },
      id: 2,
      NAME: 'AZNM',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'CAMX',
        id: 3,
        label: 'CAMX',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.226468506576,
        year: 2023,
        centroid: [69.95340117068643, 210.2798631831915],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-118.59278999965875, 33.03402599960026],
              [-118.35413299983804, 32.82235999981418],
              [-118.50033049955289, 32.851413999656415],
              [-118.59278999965875, 33.03402599960026],
            ],
          ],
          [
            [
              [-118.60443199963703, 33.478709999966554],
              [-118.36615000002246, 33.40598799994632],
              [-118.3274040001944, 33.298318999921946],
              [-118.4655239997328, 33.32557599963275],
              [-118.60443199963703, 33.478709999966554],
            ],
          ],
          [
            [
              [-120.05494599975805, 34.037363000402195],
              [-119.96755100027843, 33.94262200030511],
              [-120.12016199987636, 33.894121000283974],
              [-120.22313299998791, 33.987873999785336],
              [-120.05494599975805, 34.037363000402195],
            ],
          ],
          [
            [
              [-119.9171530000109, 34.07743400017904],
              [-119.55963900043946, 33.99578799961654],
              [-119.87438499996773, 33.97987100034646],
              [-119.9171530000109, 34.07743400017904],
            ],
          ],
          [
            [
              [-115.89833399991414, 36.004289000037375],
              [-115.6621269997612, 32.65257000030533],
              [-116.2709350000502, 32.60545200020971],
              [-117.12416399976877, 32.534343300303135],
              [-117.09721289995531, 32.62040230022603],
              [-117.28037959993856, 32.82162409987234],
              [-117.25157099990167, 32.8743679996835],
              [-117.34358600019374, 33.14587599997748],
              [-117.51345599979453, 33.33921399992619],
              [-118.10847049981368, 33.752181699625794],
              [-118.29762219970473, 33.7094801001266],
              [-118.54530299963369, 34.0385929995673],
              [-118.78534500037142, 34.02098599970418],
              [-119.13056999980563, 34.100250000137464],
              [-119.28227699998354, 34.270019999623344],
              [-119.56156200008621, 34.41437699989865],
              [-119.87810179995807, 34.40690410044391],
              [-120.00745799968689, 34.46045999992913],
              [-120.47252600027468, 34.44863999983619],
              [-120.64602900013818, 34.57900899986549],
              [-120.61124599960317, 34.840982000219185],
              [-120.6721030001533, 34.90306299965778],
              [-120.65109800007264, 35.14774899961668],
              [-120.89693600009628, 35.24665700032034],
              [-120.88765300008583, 35.43356999985565],
              [-121.00533000027923, 35.46185300011592],
              [-121.16836999967569, 35.63648599992899],
              [-121.28694199977343, 35.66480600009686],
              [-121.7164560002442, 36.19482800041192],
              [-121.89639099994469, 36.30541600014834],
              [-121.97100800011907, 36.569944999662084],
              [-121.86604270031035, 36.60662760038349],
              [-121.7886639999436, 36.80481200007381],
              [-121.93337650042514, 36.977987799597315],
              [-122.06587599977752, 36.94809800042242],
              [-122.32929200012569, 37.112380999583536],
              [-122.42085800039638, 37.24232199966059],
              [-122.40279200005074, 37.36154199996338],
              [-122.51979399969332, 37.534030999830804],
              [-122.51472640000333, 37.7811334997113],
              [-122.40612680041147, 37.81005029988148],
              [-122.36028500035246, 37.59199500006923],
              [-122.10689900028859, 37.50038599961425],
              [-122.36674000035072, 38.01222899976858],
              [-121.909792799598, 38.08315909971276],
              [-122.06230499967597, 38.13266600043562],
              [-122.12966299964768, 38.044656999620884],
              [-122.39640899977547, 38.1439389995852],
              [-122.48303199962703, 38.11345799958707],
              [-122.52918500018757, 37.819027999842376],
              [-122.82362400034731, 37.997983000215356],
              [-122.99745299995595, 38.029238999979896],
              [-122.94836299975259, 38.15425300037572],
              [-122.85022999971466, 38.0953879999563],
              [-123.13100400013445, 38.45248500008273],
              [-123.3334940003478, 38.56568000043171],
              [-123.74187400018491, 38.955008000319026],
              [-123.69051000033619, 39.019405000440486],
              [-123.827611999694, 39.34919600039518],
              [-123.76548099974832, 39.55895300028078],
              [-123.85435299989098, 39.834456000444106],
              [-124.10976199971645, 40.10375000026238],
              [-124.36285499975838, 40.2609989997041],
              [-124.40972099992416, 40.43850399975986],
              [-124.18436300005237, 40.79881799985088],
              [-124.1088069997432, 41.02719999978024],
              [-124.16505199984988, 41.13866600043565],
              [-124.06483399988917, 41.46609200014575],
              [-124.140134000084, 41.685371000271516],
              [-124.00407600030712, 41.74421000039126],
              [-123.94815199971498, 41.465492000355596],
              [-123.77055099972881, 41.46419299980715],
              [-123.7702490001912, 41.38077700035831],
              [-123.24413900041452, 41.346937000142475],
              [-123.11820499986084, 41.23755999959434],
              [-122.83795500022308, 41.293719000231704],
              [-122.96615629957353, 41.08094969956903],
              [-122.62028399960684, 41.00039300013691],
              [-122.88111300026469, 40.83317200038755],
              [-122.63968600040857, 40.845058999972935],
              [-122.4983760003521, 41.182675000151164],
              [-121.44649500024406, 41.18348399968687],
              [-121.44970099970135, 41.6256429996248],
              [-121.27185099992369, 41.646352000444494],
              [-121.15303200012664, 41.539899999885165],
              [-121.17074400033533, 41.184384999867916],
              [-119.99986700036175, 41.18397499984644],
              [-119.99762400034729, 39.96043899966014],
              [-119.77364600026266, 39.835682000324084],
              [-120.00281320006911, 39.46188390002203],
              [-120.00101500024203, 38.999573999640404],
              [-115.89833399991414, 36.004289000037375],
            ],
            [
              [-123.03957099970182, 40.99369000039326],
              [-123.10414900007623, 40.92660000018992],
              [-123.10684899958164, 40.64961900021672],
              [-122.97054099996717, 40.67502299991156],
              [-123.03957099970182, 40.99369000039326],
            ],
            [
              [-120.72203100033039, 40.76238499966803],
              [-120.43690499976589, 40.774772999874074],
              [-120.34251499966746, 40.986929999819665],
              [-120.56243100039035, 41.01993200006183],
              [-120.77499900040351, 40.97050699969833],
              [-120.72203100033039, 40.76238499966803],
            ],
          ],
        ],
      },
      id: 3,
      NAME: 'CAMX',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'ERCT',
        id: 4,
        label: 'ERCT',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value:  0.35121537841600003,
        year: 2023,
        centroid: [291.62017736901544, 328.8183837879146],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-97.25983800022351, 27.657490999809852],
              [-97.20227599963766, 27.613862999677735],
              [-97.36547299997892, 27.199613999886253],
              [-97.37653700028233, 26.964379999637345],
              [-97.27512500011863, 26.566221999945412],
              [-97.3462569996608, 26.65135200019472],
              [-97.38943000039416, 26.967250999833823],
              [-97.38383899976998, 27.214924999988796],
              [-97.25983800022351, 27.657490999809852],
            ],
          ],
          [
            [
              [-96.40218599978402, 28.368715999843573],
              [-96.39784700023881, 28.343513999571485],
              [-96.8481050004454, 28.06543999955636],
              [-96.70162400024736, 28.198113999761347],
              [-96.40218599978402, 28.368715999843573],
            ],
          ],
          [
            [
              [-94.73098000002693, 29.337952000084783],
              [-95.1127759997126, 29.084145000391516],
              [-94.86196799982332, 29.295434999925362],
              [-94.73098000002693, 29.337952000084783],
            ],
          ],
          [
            [
              [-93.5672709996569, 31.178780999743367],
              [-93.50813100004558, 31.031478000309505],
              [-93.6097719999778, 30.744788999612695],
              [-93.87113299998794, 30.763189000072373],
              [-93.86977439956883, 30.96620200012228],
              [-93.67005300004587, 30.998372999814137],
              [-93.67260800005914, 31.154369999975586],
              [-93.91112699981113, 31.158070999776896],
              [-93.88548700002502, 31.03922399958799],
              [-94.17282700016591, 31.09075700003558],
              [-94.45049500034395, 31.003064000303425],
              [-94.48749899987888, 31.234160200033273],
              [-94.35431899972201, 31.251161000180048],
              [-94.5448889997275, 31.431714999647568],
              [-94.86580100031586, 31.526957000365314],
              [-94.9580060003766, 31.387003999934677],
              [-95.23023249963012, 31.19886980020118],
              [-95.24570700007797, 31.425313000294807],
              [-95.09453200015167, 31.498804999850904],
              [-95.2553230001563, 31.574860999835323],
              [-95.4441430003991, 31.845732000431553],
              [-95.45264500036643, 31.977230000364273],
              [-95.54672999988952, 31.901067999988243],
              [-95.60100499998072, 32.06148299974069],
              [-95.81244199999827, 31.977276999833748],
              [-95.73747299977907, 31.803798000177608],
              [-95.9151759999724, 31.766],
              [-95.99848099969836, 31.63218100005315],
              [-96.14634599986795, 31.61372299961681],
              [-96.33323939957859, 31.75787319988831],
              [-96.38148600027864, 31.6275480004399],
              [-96.310757999582, 31.523585999594275],
              [-96.73093400020389, 31.444805999897028],
              [-96.77426700022187, 31.319205000310546],
              [-96.5380080003689, 31.24812899975359],
              [-96.61727900022566, 31.12154699989418],
              [-96.48848499998275, 30.89400299993855],
              [-96.24101700033424, 30.973723999862727],
              [-96.17679700028128, 30.85832200026016],
              [-96.18466199965155, 30.588032000376586],
              [-96.10519499974941, 30.43702149994232],
              [-95.88730599987196, 30.439096000280244],
              [-95.912072999869, 30.23974900021625],
              [-95.99543939990832, 30.23425489974386],
              [-95.93451899985195, 30.08779600038514],
              [-96.02484999982761, 29.940723999912734],
              [-96.15466699958233, 29.871363000202336],
              [-96.30133899959515, 29.92117200028764],
              [-96.30531000015634, 29.69567700039329],
              [-96.1749620001961, 29.63341899998693],
              [-96.12903600021122, 29.70422399973785],
              [-95.97594299996945, 29.639996000215262],
              [-95.76026899971453, 29.701833000092904],
              [-95.78159710012602, 30.03701420004535],
              [-95.5835649997249, 30.001370999771893],
              [-95.54120999984156, 30.088935999896535],
              [-95.21241630037196, 29.98188989999892],
              [-94.98868999984359, 29.84320899959573],
              [-95.08279000005842, 29.764057999876854],
              [-94.97966399999359, 29.678269999860674],
              [-95.0216210004088, 29.551874999631593],
              [-94.9096869997552, 29.497021999865467],
              [-94.90375400044672, 29.30030499967603],
              [-95.14782800006213, 29.179322999956526],
              [-95.24124600030262, 29.00047299992906],
              [-95.38117399958037, 28.87761399998618],
              [-95.6553919998409, 28.749372000017843],
              [-95.92629099992968, 28.700389000252187],
              [-96.22638800020599, 28.57947600011738],
              [-96.20529299957224, 28.695802000062315],
              [-96.36210599959219, 28.625757000285375],
              [-96.56429799955299, 28.64270300024333],
              [-96.59096900011923, 28.58400600037669],
              [-96.40344999961775, 28.450100000015027],
              [-96.68788499979286, 28.327844000000653],
              [-96.70757799962496, 28.407031999627122],
              [-96.85963599980153, 28.414053999692385],
              [-96.78760900035502, 28.255988000346008],
              [-96.91137299976407, 28.135503000163396],
              [-97.0309270001809, 28.189301999887448],
              [-97.21657299974413, 28.073691999686105],
              [-97.03120500041041, 28.04945599989452],
              [-97.19096200039598, 27.82287800041945],
              [-97.38625399962234, 27.84015999968426],
              [-97.25425700006048, 27.69680199961266],
              [-97.40319000001847, 27.332362999952522],
              [-97.47372900009327, 27.40357699967882],
              [-97.66888600028864, 27.276599000443582],
              [-97.42276099962038, 27.26079400004312],
              [-97.47842800005213, 26.99861900026667],
              [-97.5609470004037, 26.99394899984651],
              [-97.54825000033719, 26.821675000001278],
              [-97.47149499959454, 26.758830999551037],
              [-97.41711500005715, 26.360517999905824],
              [-97.27968630038242, 26.091993399775617],
              [-97.14659500035896, 25.959816900029978],
              [-97.28956100033986, 25.95438300017537],
              [-97.37321900015672, 25.83981000013148],
              [-97.66807599980751, 26.01942400031743],
              [-98.30569899970902, 26.10309799997276],
              [-98.44421200028353, 26.224311999599138],
              [-98.65584799958549, 26.235783999831767],
              [-98.8054909999097, 26.3680589996232],
              [-99.08466600033563, 26.398100000015063],
              [-99.20981299967013, 26.716432000336624],
              [-99.44550999968669, 27.020606999813253],
              [-99.42623000001447, 27.17686400027344],
              [-99.50433900024461, 27.339039000249727],
              [-99.47881300031969, 27.47884100001221],
              [-99.55458499979784, 27.61424400016051],
              [-99.71055599965962, 27.657705999832103],
              [-99.87672600040457, 27.79785800044641],
              [-99.93145599989447, 27.98072699965138],
              [-100.0860310001305, 28.14609999961533],
              [-100.29425300027572, 28.282180000406754],
              [-100.39857499973641, 28.585289000187288],
              [-100.50051299987501, 28.662059999869143],
              [-100.65135699982562, 28.942924999988804],
              [-100.66370800012407, 29.07408699971529],
              [-100.79421400017594, 29.241152000364593],
              [-101.0099519997849, 29.36828499955311],
              [-101.06035700037523, 29.458479999552367],
              [-101.25501099985775, 29.520143000399173],
              [-101.25146600005581, 29.62517999955736],
              [-101.45264700015889, 29.784483000190335],
              [-101.7096810002779, 29.76172400016253],
              [-101.85252199989037, 29.80786200003132],
              [-102.11554500010163, 29.79230600032173],
              [-102.30057900022064, 29.87766500033956],
              [-102.38999999960026, 29.781959999854166],
              [-102.67387500003122, 29.744682000274167],
              [-102.80852699972121, 29.52292700018097],
              [-102.86737600030216, 29.223831000200562],
              [-102.99814199975344, 29.17426000029883],
              [-103.11644900022117, 28.984443999990674],
              [-103.43286999965073, 29.043603999624906],
              [-103.55361719987383, 29.157980999623476],
              [-103.71864599961316, 29.180901999927414],
              [-103.78386099968537, 29.265412000363597],
              [-104.14091399958136, 29.377701000300988],
              [-104.54418500033745, 29.680860399887592],
              [-104.67995100013849, 29.920803000358205],
              [-104.68707980009265, 30.179218500333548],
              [-104.81168379956767, 30.332960099728894],
              [-104.89892220009943, 30.57057059985334],
              [-104.97973970022696, 30.629163700144716],
              [-104.84775799993173, 32.00051999969827],
              [-103.97982900040802, 32.000109999676795],
              [-103.7974339996793, 31.770478999706143],
              [-103.60535200009468, 31.651757999931817],
              [-103.32755300017078, 31.651419999633333],
              [-103.32722090032428, 31.78188880012806],
              [-103.12909100044925, 31.835781000193037],
              [-103.00350799989423, 31.651401999702557],
              [-102.7989400000809, 31.651782000139235],
              [-102.79908699966529, 32.08579500033903],
              [-102.21125499991825, 32.08693799998878],
              [-102.21102800024198, 32.52305199994987],
              [-101.68875300015083, 32.52524000012596],
              [-101.69128399995662, 32.96183799992383],
              [-102.07621500032195, 32.95970300039323],
              [-102.07592999976964, 33.38958799998625],
              [-101.80654600029766, 33.3418560003542],
              [-101.68377700000849, 33.23945400040185],
              [-101.55719200001073, 33.241117999795904],
              [-101.56134600001786, 33.58048299969073],
              [-101.74964399957088, 33.650607000412776],
              [-101.74970200044692, 33.77965000044719],
              [-101.93996799992323, 33.780718000235595],
              [-101.93984100036187, 33.6358129998701],
              [-102.12294699970425, 33.623308999710616],
              [-102.08745699984064, 34.01153199990193],
              [-101.73151800005564, 33.977723000216315],
              [-101.81826700032178, 34.16680499995084],
              [-102.08901099955796, 34.15928200016424],
              [-101.99802099976927, 34.313039999596356],
              [-101.99849399999806, 34.74819000006852],
              [-102.09881200007374, 34.811014999642566],
              [-101.70927260015031, 34.85175120005789],
              [-101.62844299964468, 34.807245000256614],
              [-101.63603299982304, 35.16382199978551],
              [-101.3288320001966, 35.18201000036129],
              [-101.31089100021944, 35.355217000064556],
              [-101.0445380002285, 35.357351000448375],
              [-101.08595199988486, 35.444554000067114],
              [-101.0857080003239, 36.05757300029376],
              [-100.54022200004522, 36.056491999905916],
              [-100.5401979998378, 35.61930800006422],
              [-100.34001900007678, 35.619486000178824],
              [-100.2889900003882, 35.49860199958266],
              [-100.00038899965256, 35.4658229997317],
              [-100.00038200022908, 34.56050900019028],
              [-99.92321200013367, 34.57455300032075],
              [-99.69452799976733, 34.37821799976092],
              [-99.32825810003123, 34.39487480023189],
              [-99.4753760001023, 34.27397000011547],
              [-99.47560599991692, 33.83405600028425],
              [-98.83843700026733, 33.834416999844734],
              [-98.7611710002414, 34.121135000080244],
              [-98.59738000038669, 34.16000400018453],
              [-98.48027599963763, 34.06353999977125],
              [-98.36041999968319, 34.156471000036674],
              [-98.18959300001688, 34.110111999868934],
              [-97.98437399986017, 33.89802400040736],
              [-97.83350999988653, 33.85810599959228],
              [-97.69311000042615, 33.983698999709134],
              [-97.3650949996345, 33.823278999726085],
              [-97.20054900003629, 33.91225900035266],
              [-97.19299299962722, 33.75922900031816],
              [-96.92156400027835, 33.95961100044735],
              [-96.88301000031123, 33.868018999876995],
              [-96.7137340002239, 33.83132900043307],
              [-96.67344899957163, 33.912279000375634],
              [-96.3625619999363, 33.69232699979125],
              [-96.14922599958015, 33.837091999995835],
              [-95.9367629999125, 33.885933000407704],
              [-95.75274800002018, 33.806583999651934],
              [-95.54070299984352, 33.87059199982099],
              [-95.28066799982827, 33.87710399974986],
              [-95.22639299973713, 33.9619549997235],
              [-94.84929700005648, 33.73958600009388],
              [-94.90075000041213, 33.586135999576754],
              [-94.80822099979929, 33.51855400006713],
              [-94.8119229996467, 33.37458399965192],
              [-95.01234399977574, 33.39307799994981],
              [-95.03033500026004, 33.324573000143914],
              [-95.27280599969708, 33.28875599958974],
              [-95.5385030000134, 33.07696999966578],
              [-95.523912999885, 32.89594700015397],
              [-95.60498299996544, 32.70469500017418],
              [-95.59430100019097, 32.47985900009286],
              [-95.26752800001714, 32.35252299963679],
              [-95.11058100011303, 32.36599400032293],
              [-95.11387600007731, 32.214262999937546],
              [-94.84198330038896, 32.150393400035455],
              [-94.48535399988714, 32.149940999677426],
              [-94.43278600027367, 32.21688500034253],
              [-94.16303500006518, 32.23474900036615],
              [-94.04265040019578, 32.166911499865876],
              [-94.04232700039074, 31.992971999658096],
              [-93.79446299956771, 31.703319999918108],
              [-93.83938399997157, 31.599075999557783],
              [-93.71104600007283, 31.512160999730384],
              [-93.68727900032559, 31.306068999784543],
              [-93.5672709996569, 31.178780999743367],
            ],
            [
              [-94.61309140014794, 32.08992209982512],
              [-94.65573100038534, 31.977439000109825],
              [-94.51146220022031, 31.924133099562937],
              [-94.48336299980258, 32.09518599993402],
              [-94.61309140014794, 32.08992209982512],
            ],
            [
              [-94.62947800020953, 31.844044999976802],
              [-94.6586009996364, 31.618423999667925],
              [-94.48205399969231, 31.73340999987164],
              [-94.62831799977585, 31.742688999697634],
              [-94.62947800020953, 31.844044999976802],
            ],
          ],
        ],
      },
      id: 4,
      NAME: 'ERCT',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'FRCC',
        id: 5,
        label: 'FRCC',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.370536129656,
        year: 2023,
        centroid: [505.5937333579051, 353.69736569461605],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-81.44412399962283, 30.709714000001156],
              [-81.38561999966322, 30.273791999900936],
              [-81.2481969998916, 29.761181000302997],
              [-80.95772099992416, 29.132411000367426],
              [-80.57490299987353, 28.585180999703425],
              [-80.5250840002264, 28.454339000344646],
              [-80.62199499966948, 28.31873399987427],
              [-80.59442199977542, 28.57712799975741],
              [-80.68575099990869, 28.34314999987265],
              [-80.7415520002246, 28.71587500033104],
              [-80.84982900040802, 28.798681999574683],
              [-80.74483599968158, 28.396214999922336],
              [-80.38883599978152, 27.68430899996042],
              [-80.31462799958246, 27.42392600008486],
              [-80.09349999962524, 27.017310999802874],
              [-80.03145800018655, 26.79716800030303],
              [-80.03781300006983, 26.578689000197244],
              [-80.12250800004415, 25.929063999903747],
              [-80.34077600031213, 25.49838699976027],
              [-80.33128100041779, 25.346188000276015],
              [-80.43528599964912, 25.240576999828704],
              [-80.71691900011172, 25.156226999576404],
              [-81.08501999957326, 25.116446999729305],
              [-81.1720280000921, 25.225489000117307],
              [-81.14530599987194, 25.32712199968057],
              [-80.95239799996767, 25.21149400044783],
              [-80.96554700019385, 25.337617999870872],
              [-81.14976699964728, 25.38818299974571],
              [-81.28112700041072, 25.682216000068422],
              [-81.19349099970981, 25.73024399986076],
              [-81.42417000034521, 25.86761099974791],
              [-81.73171299955527, 25.99509399978831],
              [-81.80186899995437, 26.0954309998408],
              [-81.86820899974549, 26.45802399980778],
              [-82.02106900003429, 26.499971999807997],
              [-82.07513799961896, 26.66362100030898],
              [-82.04910599974204, 26.854716000243286],
              [-82.17929999979509, 26.913470000040547],
              [-82.14864900005125, 26.79402600019978],
              [-82.30084700038873, 26.852706000181797],
              [-82.44758270028137, 27.063910100071098],
              [-82.57953399989412, 27.418234000198993],
              [-82.68968099997812, 27.468711999659092],
              [-82.39305499968845, 27.823572000047818],
              [-82.67534699996406, 28.00573600001644],
              [-82.7206599995593, 27.93640699998309],
              [-82.59483899972003, 27.83788499999281],
              [-82.65375299970111, 27.70022500008372],
              [-82.85182000009291, 27.886497999782932],
              [-82.79910900018018, 28.18565199974006],
              [-82.63805499973842, 28.532787000020107],
              [-82.69559500020904, 28.77264200022819],
              [-82.64974500013159, 28.886912999835147],
              [-82.80820899984542, 29.168670999766903],
              [-83.07060800005911, 29.190189000122302],
              [-83.21014300009932, 29.425682999770686],
              [-83.40349099960991, 29.54143999955636],
              [-83.40071100001262, 29.66334799971048],
              [-83.54848400043625, 29.728673000358754],
              [-83.63929400001803, 29.88735700032538],
              [-84.01581900034654, 30.10640599973715],
              [-84.36055499971343, 30.05978099989329],
              [-84.44331799962595, 29.96261999971324],
              [-84.79831500003718, 29.768553000320765],
              [-85.31081399986618, 29.689094999934355],
              [-85.30265599957471, 29.808123000376213],
              [-85.43091920016093, 29.95002950006142],
              [-85.39144799962543, 30.025414999702548],
              [-85.6160440003303, 30.134254999768473],
              [-85.58511500035695, 30.306388000306015],
              [-85.64348699962528, 30.40958800018609],
              [-85.43441799999067, 30.567593000316776],
              [-85.4339599995543, 30.697647000208917],
              [-85.32412699956132, 30.698680000181923],
              [-85.32855399956736, 30.99934699976427],
              [-85.00190100043079, 31.00068100012811],
              [-84.8646939998282, 30.711542999809637],
              [-82.21479509971402, 30.56843310020747],
              [-82.16186399972378, 30.35711799969596],
              [-82.03696800027296, 30.371993000376733],
              [-82.00517099984171, 30.563722999916592],
              [-82.036757999582, 30.75462499994387],
              [-81.96437299981403, 30.81755299977118],
              [-81.44412399962283, 30.709714000001156],
            ],
          ],
        ],
      },
      id: 5,
      NAME: 'FRCC',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'HIMS',
        id: 6,
        label: 'HIMS',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.52755697948,
        year: 2023,
        centroid: [249.97916926202842, 389.65131903498246],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-155.84992199960058, 20.26817500007627],
              [-155.586792999897, 20.119003999934705],
              [-155.27994699955437, 20.018879999812214],
              [-155.0816939995784, 19.846513000174866],
              [-155.09085500025802, 19.73578200013924],
              [-154.80633999999097, 19.51933300011791],
              [-154.97750399990963, 19.345920999954217],
              [-155.29390500021555, 19.262889000227233],
              [-155.50448100009805, 19.135549999632815],
              [-155.67871999972817, 18.910885000242615],
              [-155.87904299983455, 19.033886999585434],
              [-155.9180580003764, 19.11463500010524],
              [-155.88400100004608, 19.33276899958969],
              [-156.0497660001008, 19.77260400027444],
              [-155.92120599985697, 19.855539000024862],
              [-155.82512419962208, 20.032140700333116],
              [-155.90478099964338, 20.19552399973287],
              [-155.84992199960058, 20.26817500007627],
            ],
          ],
          [
            [
              [-156.57311700034927, 20.6039269997313],
              [-156.54365999990904, 20.51134300017935],
              [-156.70011799974586, 20.52413500013023],
              [-156.57311700034927, 20.6039269997313],
            ],
          ],
          [
            [
              [-156.98586700026183, 20.928766999797233],
              [-156.80652099984425, 20.82227900027567],
              [-156.96511900034156, 20.73226399958395],
              [-157.0620770001534, 20.889728999993395],
              [-156.98586700026183, 20.928766999797233],
            ],
          ],
          [
            [
              [-156.60135200019462, 21.031648000255075],
              [-156.47375999962426, 20.891833999939195],
              [-156.32172699970124, 20.94613500033006],
              [-156.00183999961627, 20.792445000436487],
              [-156.0469030002732, 20.651389000402105],
              [-156.37144600013278, 20.574968999819532],
              [-156.44103699965777, 20.604742000443025],
              [-156.46246600040556, 20.78093000001951],
              [-156.6873940002329, 20.88189100006963],
              [-156.60135200019462, 21.031648000255075],
            ],
          ],
          [
            [
              [-157.25375600003935, 21.223818000300525],
              [-156.70961799987077, 21.156986000303732],
              [-156.87437300011385, 21.046551999575172],
              [-157.09520900009525, 21.103352000094787],
              [-157.31016000028376, 21.101565999571278],
              [-157.25375600003935, 21.223818000300525],
            ],
          ],
          [
            [
              [-160.0916350001551, 22.00501600038814],
              [-160.07341800004065, 21.89312099973438],
              [-160.2304520003595, 21.883401000256015],
              [-160.0916350001551, 22.00501600038814],
            ],
          ],
          [
            [
              [-159.40192200020013, 22.232175999722642],
              [-159.31436300035216, 22.18524700024892],
              [-159.3298060002467, 21.96133100032546],
              [-159.44427700008345, 21.86829299962227],
              [-159.60446300006737, 21.89259599980562],
              [-159.78771900003179, 22.02831900032163],
              [-159.72277099968187, 22.150056999830724],
              [-159.58089999983508, 22.223463999963656],
              [-159.40192200020013, 22.232175999722642],
            ],
          ],
        ],
      },
      id: 6,
      NAME: 'HIMS',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'HIOA',
        id: 7,
        label: 'HIOA',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.7198264636239999,
        year: 2023,
        centroid: [195.63292137444293, 360.49799246039066],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-157.9829410000271, 21.711817999900802],
              [-157.6508449998968, 21.298924999689007],
              [-157.81472000002796, 21.25607300026877],
              [-157.89341290038502, 21.333022199714776],
              [-158.10599700006148, 21.296138999815014],
              [-158.28151600026317, 21.57489099961998],
              [-158.11629800025247, 21.584191700086933],
              [-157.9829410000271, 21.711817999900802],
            ],
          ],
        ],
      },
      id: 7,
      NAME: 'HIOA',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'MROE',
        id: 8,
        label: 'MROE',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.675256967296,
        year: 2023,
        centroid: [403.86579816588267, 131.37444015887203],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-87.70037700029826, 43.7674010001561],
              [-87.72666700038172, 43.64996400023847],
              [-87.9098035002313, 43.63828479980373],
              [-87.83149799993271, 43.83371299955536],
              [-87.70037700029826, 43.7674010001561],
            ],
          ],
          [
            [
              [-85.8644140002059, 46.68970400033942],
              [-85.86486600036557, 46.12025899955324],
              [-85.99059499955956, 46.158171999638114],
              [-85.99024200036797, 46.33100600012688],
              [-86.1146155000053, 46.33132029969215],
              [-86.11661789989614, 45.965004600182226],
              [-86.27604000044562, 45.94315399995719],
              [-86.3702779998298, 45.78859200032059],
              [-86.5875279999172, 45.666456999590935],
              [-86.7175160003631, 45.667196000395165],
              [-86.53045300020574, 45.84977399967039],
              [-86.78206800043785, 45.8601869996304],
              [-86.8703929996372, 45.710087999861344],
              [-87.04454000042062, 45.743760999570554],
              [-87.16757000015537, 45.66443699996762],
              [-87.43661400013593, 45.294012000353575],
              [-87.60027899957612, 45.149930000169434],
              [-87.6297760000623, 44.98402199981547],
              [-87.78213899991488, 44.962858999643174],
              [-87.9831739995804, 44.72063199976702],
              [-87.93344000025576, 44.533540000071014],
              [-87.76319860043503, 44.64313649994955],
              [-87.61004700036875, 44.83837400025993],
              [-87.40550099977128, 44.903496999686865],
              [-87.2380059999769, 45.16759700010152],
              [-86.98272000042766, 45.29480500005076],
              [-87.43831029958062, 44.60336639983956],
              [-87.5453819995796, 44.32138600026377],
              [-87.5196619997015, 44.178836499704744],
              [-87.699249000441, 43.965307000317864],
              [-87.8464723001565, 43.854348300034076],
              [-88.08118600033362, 43.804578999621185],
              [-88.40416519966419, 43.938194599900896],
              [-88.59995699981567, 43.85045700009056],
              [-88.4816720003625, 43.66085099957405],
              [-88.64474600042752, 43.63301400009607],
              [-88.65330600037157, 43.39787999996207],
              [-88.50005500003817, 43.44282999990463],
              [-88.46346899999429, 43.25366700003207],
              [-88.5854190002866, 43.196866000365674],
              [-88.89148299964069, 43.19786499967006],
              [-88.94372599955517, 43.01566799997829],
              [-88.66008619971831, 42.93256520022385],
              [-88.5628279999122, 42.800034999815466],
              [-88.65936750020995, 42.676358499944854],
              [-88.54121909968165, 42.64093029969365],
              [-88.52569599987044, 42.4949170000196],
              [-90.43714680018462, 42.50723499969553],
              [-90.640928000227, 42.508302000337096],
              [-90.72020999969169, 42.64075900042758],
              [-91.05373299997791, 42.73823799998377],
              [-91.14337599970258, 42.90467100026649],
              [-91.17525400027188, 43.134665999935976],
              [-91.01246599990594, 43.3147239999127],
              [-90.79487600032712, 43.20539000044823],
              [-90.66607759970145, 43.30790779980515],
              [-90.94447300032868, 43.3719260000849],
              [-90.55221100003757, 43.56343100004068],
              [-90.64088669976132, 43.422276400135786],
              [-90.51935739962425, 43.300293800318684],
              [-90.34163800029341, 43.243345999818075],
              [-90.24816479966574, 43.300638100368076],
              [-90.3124499996677, 43.676058500299575],
              [-90.4785170001594, 43.70416789992868],
              [-90.54629399966831, 43.90014299989957],
              [-90.67051699955982, 43.94054000032082],
              [-90.6200990001687, 44.07258200015923],
              [-90.33263699979767, 44.01868799965149],
              [-90.31776600020072, 44.29480700034287],
              [-90.07971549957063, 44.36487460008277],
              [-90.12982399997759, 44.5248430001044],
              [-90.35591200023856, 44.5116689996247],
              [-90.43597399970031, 44.62545700034036],
              [-90.43469450005108, 44.84275480029385],
              [-90.19891099964286, 44.815006000026926],
              [-90.15953300034766, 44.90198800024609],
              [-89.8859840003613, 44.80094700010403],
              [-89.86487700007348, 45.061741000047164],
              [-89.64972799974737, 45.040518999852],
              [-89.4261090000303, 45.1191960001953],
              [-89.54821500032199, 45.29378699987018],
              [-89.79079700038125, 45.30144200034812],
              [-89.6720779997998, 45.46041500015218],
              [-89.49008200038395, 45.540591000374434],
              [-89.67092299959671, 45.64500859956729],
              [-89.88771099996262, 45.68102300041119],
              [-89.75667699984365, 45.89850500040552],
              [-89.7618449998468, 46.04480000011995],
              [-89.4292069999031, 46.115439000309664],
              [-89.36692700028078, 45.9880720002227],
              [-89.18152899956362, 45.982397000221454],
              [-88.97871100041232, 45.9822170000146],
              [-89.04750900024015, 45.85513699967282],
              [-89.04678099994317, 45.637516999609886],
              [-88.59254399970581, 45.63665999965929],
              [-88.66523889955556, 45.80923020021362],
              [-88.45210600029162, 45.80972900019327],
              [-88.4602930001218, 45.737342000333115],
              [-88.05924600030261, 45.71306300035724],
              [-88.08881229984775, 45.54205000020738],
              [-87.82351399957139, 45.53797600029225],
              [-87.87340840017748, 45.45237869971726],
              [-88.11748509955765, 45.46302280026208],
              [-87.93998900009223, 45.265192999657245],
              [-87.64812600001483, 45.33939599962571],
              [-87.88485499995824, 45.36279300029679],
              [-87.78162400044721, 45.67328100041789],
              [-87.99194209994789, 46.01318380029221],
              [-87.84096400028835, 46.04915999973423],
              [-87.97336699968724, 46.16009700027638],
              [-87.8665399998211, 46.24685400001215],
              [-88.11721099968787, 46.24665299973623],
              [-88.11684599994288, 46.419669999670816],
              [-88.61729199972598, 46.42013699962291],
              [-88.67884900018117, 46.592577999974765],
              [-89.12473100003558, 46.60101699973478],
              [-89.11349800003262, 46.78477100018159],
              [-88.9323959995757, 46.76680049974334],
              [-88.93325799975685, 47.03161299974022],
              [-88.42522700002598, 47.36898100017305],
              [-88.18069700006646, 47.45802099996922],
              [-87.80232600004484, 47.473146999634366],
              [-87.7118759999774, 47.40175099960902],
              [-87.93922800007209, 47.346894999704546],
              [-88.23774300023922, 47.19006399975382],
              [-88.44196800042283, 46.976432000136754],
              [-88.45729939984739, 46.756431500013775],
              [-88.24443799961398, 46.929637999693966],
              [-87.9004820002441, 46.90979900032369],
              [-87.63362699958634, 46.812080999638454],
              [-87.3605349999902, 46.50376199971657],
              [-86.97761100044727, 46.526581999859445],
              [-86.63559299961719, 46.41303999969631],
              [-86.46782499982385, 46.55249200040555],
              [-86.13867799988975, 46.672941999873444],
              [-85.8644140002059, 46.68970400033942],
            ],
            [
              [-88.38467539984981, 44.87245909990759],
              [-88.4891479997803, 44.85547800030952],
              [-88.5146670002818, 44.67773299997805],
              [-88.63275399959736, 44.502454000052126],
              [-88.98098299996542, 44.41142800040194],
              [-89.04686500021955, 44.31622399963794],
              [-88.95211699979967, 44.126250000137475],
              [-88.04636099966035, 44.08088399989674],
              [-87.90721300037961, 44.414915000227154],
              [-88.13838699956034, 44.473795999585775],
              [-88.13042329959558, 44.560604499897806],
              [-88.44742400021738, 44.58935099994875],
              [-88.29114610041216, 44.79532110038855],
              [-88.38467539984981, 44.87245909990759],
            ],
            [
              [-88.8381709998917, 43.37378999970878],
              [-88.93475400039677, 43.22154199976353],
              [-88.75499199968101, 43.348030999830826],
              [-88.8381709998917, 43.37378999970878],
            ],
            [
              [-89.1457370001624, 43.13059700025144],
              [-89.15031759987727, 43.0030354003635],
              [-89.01401199965403, 43.06669200033559],
              [-89.1457370001624, 43.13059700025144],
            ],
          ],
          [
            [
              [-88.42219000026824, 48.18879200025066],
              [-88.7194659999559, 47.99486900030416],
              [-89.15938299992547, 47.82381500006227],
              [-89.22084000026575, 47.91093999968132],
              [-88.42219000026824, 48.18879200025066],
            ],
          ],
        ],
      },
      id: 8,
      NAME: 'MROE',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'MROW',
        id: 9,
        label: 'MROW',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.427926857456,
        year: 2023,
        centroid: [320.4012509516746, 132.93190720700144],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-91.42486790013345, 40.588964900210044],
              [-91.38448900036701, 40.3857369999626],
              [-91.526424999614, 40.41340399969488],
              [-91.53686800005812, 40.55345400010208],
              [-91.42486790013345, 40.588964900210044],
            ],
          ],
          [
            [
              [-106.61476700019688, 44.557061000165106],
              [-107.29631300034464, 44.55909899971914],
              [-107.24861599962867, 44.661772999624304],
              [-106.85617500007618, 44.63013600027625],
              [-106.75883399968927, 44.79369700031634],
              [-106.7407700003352, 44.64192900002337],
              [-106.61476700019688, 44.557061000165106],
            ],
          ],
          [
            [
              [-105.06162100030889, 45.78734300027929],
              [-105.34463199956707, 45.66982900040807],
              [-105.4206230001513, 45.788458000436435],
              [-105.06162100030889, 45.78734300027929],
            ],
          ],
          [
            [
              [-105.06162100030889, 45.78734300027929],
              [-104.98089359965985, 45.881367899908696],
              [-105.06755999989406, 46.06443800011368],
              [-105.25481759985229, 46.23481349964334],
              [-105.30686680036251, 46.42805880017352],
              [-105.62856700006694, 46.39862300035122],
              [-105.72604599962312, 46.52960499987091],
              [-105.14310699978819, 46.804417999691],
              [-105.14308000034168, 46.852768999989394],
              [-104.60376699964729, 46.86087999991213],
              [-104.60701700023435, 46.68492700038081],
              [-104.35387399968528, 46.64144699987918],
              [-104.04533799964895, 46.65719400030292],
              [-103.90263900028958, 46.803415000202165],
              [-103.89905899977299, 47.008488999967426],
              [-103.66700599962712, 47.09567699979374],
              [-103.66672300006638, 47.329355000233136],
              [-104.04535599957967, 47.330279399874485],
              [-104.04412000013787, 47.99610699983822],
              [-103.91978999980859, 47.95595099973889],
              [-103.68305799972688, 48.12170500018567],
              [-103.4850720003725, 48.0067250002586],
              [-103.34616799975333, 48.03192400039234],
              [-103.35312899970353, 48.19786699966238],
              [-103.47434700041373, 48.1980629997077],
              [-103.40704100014199, 48.459587000040074],
              [-103.86342699965627, 48.45994100017708],
              [-104.11894900019615, 48.38942900044805],
              [-104.28137199991784, 48.2297159997936],
              [-104.68380399975473, 48.23464400042036],
              [-104.6827580000816, 47.983730000139474],
              [-104.77889220021484, 47.87282660006758],
              [-105.19501200030356, 47.91131299979514],
              [-105.21958500034748, 48.02907400026493],
              [-105.4528450003964, 47.99867699964386],
              [-105.45384000041565, 47.882820999789374],
              [-105.64110199985737, 47.868527999867354],
              [-105.68971999987804, 47.741415999848584],
              [-105.90212799970737, 47.73192400009259],
              [-105.80480400010447, 48.33365300038571],
              [-106.0000829996307, 48.50846899964466],
              [-106.42272299966669, 48.46339600032519],
              [-106.5993359999564, 48.7046920004355],
              [-106.47951399977126, 48.87072900044308],
              [-106.78376800019299, 48.91211299961532],
              [-106.83187900021568, 48.999921000154075],
              [-105.77799600041504, 48.99967200036258],
              [-105.6282800003217, 48.909927999577576],
              [-105.65010200030702, 48.76602899973858],
              [-105.49273299982804, 48.56310500019566],
              [-104.97335400018693, 48.563180000057],
              [-104.97335400018693, 48.632890999719905],
              [-104.27510499959601, 48.606559000397624],
              [-104.25814900007623, 48.70790490039087],
              [-104.04804300028422, 48.70797099966194],
              [-104.04873699991259, 48.99987799996978],
              [-96.37530600037161, 49.00095200003483],
              [-95.15371099976278, 48.998902999973495],
              [-95.1533130002947, 49.38435900026769],
              [-94.82516000033371, 49.29428400040632],
              [-94.69088900022712, 48.77806699999212],
              [-94.22427600033711, 48.6495269997713],
              [-93.8416520002396, 48.628882000104284],
              [-93.79445400005204, 48.51602199991544],
              [-93.4694309996409, 48.545215999918526],
              [-93.20739900016366, 48.64247400007508],
              [-92.72804600002286, 48.53929000003353],
              [-92.50744969994366, 48.448073600416365],
              [-92.36981299967016, 48.22033599980659],
              [-92.26227999962225, 48.35493399970437],
              [-92.05519999998, 48.359181000402884],
              [-92.00657699972874, 48.26542199972556],
              [-91.71511099997264, 48.19922200009529],
              [-91.56725500021804, 48.043719000231704],
              [-91.25011099982277, 48.08408800026103],
              [-90.88547600011725, 48.245773000123904],
              [-90.74152100039379, 48.09458300040518],
              [-90.14086300002737, 48.11250300031327],
              [-89.87215300016078, 47.985357999671976],
              [-89.61850399965982, 48.01073099973593],
              [-89.97470399978971, 47.830629000428075],
              [-90.52754500020154, 47.706227000375804],
              [-90.89008300033015, 47.544713000304796],
              [-91.46581699975468, 47.131404999840925],
              [-92.0880959998305, 46.79375399984724],
              [-92.01243500007513, 46.68327599978761],
              [-91.79013299993795, 46.69467600029725],
              [-91.16760099988619, 46.84476100031998],
              [-90.8575439998557, 46.96239100014458],
              [-90.75103200012666, 46.88796299969272],
              [-90.88502099981923, 46.75634100033693],
              [-90.91828599959916, 46.58306300005745],
              [-90.71413800026846, 46.667118000195615],
              [-90.43777600006234, 46.56104500002681],
              [-90.03337200011765, 46.67231299964527],
              [-89.7994829998405, 46.81575099980887],
              [-89.41759000017834, 46.84322399958796],
              [-89.11833900024465, 46.99422100029898],
              [-88.93325799975685, 47.03161299974022],
              [-88.61729199972598, 46.42013699962291],
              [-88.61673400007402, 46.24628399980679],
              [-88.49188900027713, 46.23193929965902],
              [-88.52459939984237, 46.04276559965274],
              [-88.57883499973542, 46.00971900023171],
              [-88.93254200001326, 46.07361599977861],
              [-88.97871100041232, 45.9822170000146],
              [-89.18152899956362, 45.982397000221454],
              [-89.18005499993825, 46.11501399959644],
              [-89.4292069999031, 46.115439000309664],
              [-90.43714680018462, 42.50723499969553],
              [-90.55614899997636, 42.417283000110444],
              [-90.40343800026346, 42.306526999821244],
              [-90.08338899990241, 42.19161400028594],
              [-90.02331600043306, 42.01096399998869],
              [-90.14860299992847, 42.02137699994864],
              [-90.18197300005386, 41.807070999826806],
              [-90.31522099974933, 41.73426400038335],
              [-90.25410599989192, 41.52253100020556],
              [-90.31921699966477, 41.41122100044885],
              [-90.20258399995163, 41.353913999931194],
              [-90.30522800027194, 41.26615499985343],
              [-90.45859279991777, 41.32688719968456],
              [-90.84969500032395, 41.31764500011673],
              [-90.78160800000916, 41.45199500026911],
              [-91.04506300035712, 41.41487299978917],
              [-91.11364800025495, 41.24140099955656],
              [-90.94625899995287, 41.094734999820446],
              [-90.95545999977912, 40.98618599968421],
              [-91.24722499983386, 40.8780149998924],
              [-91.19722800007213, 41.11820200012227],
              [-91.283661000155, 41.19055100002868],
              [-91.58226900011425, 41.16329100017958],
              [-91.59951699960982, 41.366705999882015],
              [-91.81215149999167, 41.40957829969881],
              [-91.75475299975108, 41.30757699987868],
              [-91.94509199989585, 41.25138699961042],
              [-92.28731100010253, 41.232577000028584],
              [-92.55905499958851, 41.161426999656385],
              [-92.97143000019429, 41.248219000106815],
              [-92.98586400032332, 41.38878900021223],
              [-93.21393500030001, 41.38557300029379],
              [-93.2322395997777, 41.160779799847944],
              [-93.44187300043859, 41.12811999973826],
              [-93.42291500032695, 40.81170200044704],
              [-93.5563250002985, 40.75417899986098],
              [-93.39838100028288, 40.580097000276396],
              [-94.7080209997693, 40.57224199956869],
              [-95.02178120024217, 40.57618499973802],
              [-95.07877400011995, 40.47821399997616],
              [-94.92797699963876, 40.47593199996186],
              [-95.00931100020244, 40.3039649998849],
              [-94.93398100042282, 40.23033100007564],
              [-95.16174000040064, 40.2614020003021],
              [-95.13552600022467, 40.07944499998683],
              [-95.25540700043268, 39.99867900043557],
              [-97.50737600040208, 40.00227199975302],
              [-101.81280700034273, 40.002851000373425],
              [-101.89239400038275, 40.349373000263824],
              [-101.72109899981893, 40.34963599980159],
              [-101.68463500000519, 40.52317100024152],
              [-101.91188800003113, 40.52335799987185],
              [-101.83828399980672, 40.69878100014307],
              [-101.47670299974362, 40.69817500007622],
              [-101.50044900032105, 41.39535399988722],
              [-101.76387000000045, 41.4110269995964],
              [-101.72259899974398, 41.51056999990561],
              [-101.88265800016654, 41.5006229998516],
              [-101.98463100012054, 41.39471300000503],
              [-101.98552299988648, 41.742291000029695],
              [-102.06778199993931, 41.74220999989166],
              [-102.03816900039902, 42.443306999618414],
              [-102.42516790007846, 42.35060170040822],
              [-102.53694100032686, 42.44106999988065],
              [-102.5383679995835, 42.78533600005642],
              [-102.61279900017371, 42.78521199973403],
              [-102.69419299990699, 42.999981999669615],
              [-103.00089699999654, 43.00074299968975],
              [-103.00107800024949, 43.60587000020041],
              [-102.810295000314, 43.68813200039153],
              [-102.17496099985021, 43.68801200025365],
              [-102.13893799968889, 43.82069199983596],
              [-102.2579979998078, 43.907569999755765],
              [-102.49700499958101, 43.90815299966124],
              [-102.66862599988997, 44.14036199980649],
              [-102.65188999972366, 44.47199700026141],
              [-102.96442980039495, 44.50289630012418],
              [-102.9577260002547, 45.2126409998823],
              [-104.03995799976184, 45.21292600043461],
              [-104.04028400040625, 45.33695899965818],
              [-104.33553300014779, 45.42020100007613],
              [-104.31364599986296, 45.595773000023996],
              [-104.17211300031465, 45.56714900022621],
              [-104.04150400000958, 45.539235999941525],
              [-104.04402999958478, 45.88197599989252],
              [-104.13471599974355, 45.96894599955829],
              [-104.39087700007349, 45.970307000267894],
              [-104.51584099996217, 46.13634500032157],
              [-104.93939699997156, 46.13658999992862],
              [-104.98203600036112, 45.78701000021141],
              [-105.06162100030889, 45.78734300027929],
            ],
          ],
        ],
      },
      id: 9,
      NAME: 'MROW',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'NEWE',
        id: 10,
        label: 'NEWE',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.24515740416,
        year: 2023,
        centroid: [584.6304719044684, 107.27532280557803],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-70.01103099998062, 41.35483300004296],
              [-69.97197000001546, 41.24672300036622],
              [-70.21192899962358, 41.275287000095034],
              [-70.01103099998062, 41.35483300004296],
            ],
          ],
          [
            [
              [-70.60080999958177, 41.48207899994594],
              [-70.4537509997088, 41.34749099960999],
              [-70.77284700018885, 41.35100499978097],
              [-70.60080999958177, 41.48207899994594],
            ],
          ],
          [
            [
              [-68.31748299964067, 44.44393400025399],
              [-68.18495800001165, 44.36969450040095],
              [-68.33656900025909, 44.221905000115726],
              [-68.41988999982357, 44.274635000005276],
              [-68.31748299964067, 44.44393400025399],
            ],
          ],
          [
            [
              [-73.66089499990426, 40.98739100039438],
              [-73.7277760003621, 41.10069600042016],
              [-73.51424900019117, 41.19865100034343],
              [-73.55096199979641, 41.29542299967176],
              [-73.48961500003219, 42.000092000445534],
              [-73.50814300009932, 42.08625799990682],
              [-73.26495700006546, 42.745939999931124],
              [-73.24864100038184, 43.55385800014665],
              [-73.42863700019734, 43.58399400042282],
              [-73.35043200003673, 43.77143800016364],
              [-73.43774100004708, 44.045006000126875],
              [-73.32359599995539, 44.2438969998467],
              [-73.30670699992805, 44.5003340003139],
              [-73.38184900003131, 44.58931600013335],
              [-73.34312400027238, 45.010839999966095],
              [-72.2745710002514, 45.00423300015291],
              [-71.50246949966765, 45.01337340006239],
              [-71.28406300020725, 45.302423999767825],
              [-71.13195300033067, 45.245423999917705],
              [-70.95237500000621, 45.33909900031864],
              [-70.8846559995747, 45.234861000235014],
              [-70.8256519999398, 45.40028699994514],
              [-70.62122600037958, 45.40275799968197],
              [-70.72262900012822, 45.506532999998],
              [-70.55835499958351, 45.66659299956734],
              [-70.38385699970075, 45.73450699999813],
              [-70.2596899996937, 45.889998000207584],
              [-70.31043299968314, 46.06408800016112],
              [-70.20871899998184, 46.32936099981032],
              [-70.05650499980584, 46.41573289995341],
              [-69.99710499989578, 46.69516799960354],
              [-69.22442000028275, 47.45968700035485],
              [-69.04336200005622, 47.42732700004109],
              [-69.05015200021461, 47.256411999913894],
              [-68.90241999988302, 47.17883800007371],
              [-68.57854999958278, 47.287550999678956],
              [-68.23103599981152, 47.35432799983738],
              [-67.7905149998673, 47.06792199960063],
              [-67.78109499983435, 45.94303299977315],
              [-67.80331400014097, 45.67788699968531],
              [-67.4297149998473, 45.5837739997703],
              [-67.50376900013919, 45.48852699972133],
              [-67.48610999967673, 45.29113099969595],
              [-67.35343300023271, 45.1294760003172],
              [-67.16007700035323, 45.1619090004001],
              [-67.03336199975644, 44.939753999847255],
              [-67.18400899961563, 44.918444000090574],
              [-66.98868499981285, 44.814476999913666],
              [-67.24331599973357, 44.64007800009966],
              [-67.39341100021744, 44.69836499994483],
              [-67.40829799965292, 44.59453099960598],
              [-67.58069899995883, 44.62537800029452],
              [-67.56784599989294, 44.531137999918826],
              [-67.85269000004342, 44.482648999551714],
              [-68.05952330035996, 44.33168799960157],
              [-68.19521099978778, 44.51578599972419],
              [-68.43419700039124, 44.40152699977125],
              [-68.57353100015547, 44.40182900020824],
              [-68.52499300022674, 44.22805599958474],
              [-68.82647200038247, 44.31148599967918],
              [-68.78356300013229, 44.473871000346435],
              [-68.99496799957348, 44.42358799998624],
              [-68.95442999984459, 44.32406599974615],
              [-69.25572899979346, 43.92261800032048],
              [-69.35381200022357, 44.016656000374155],
              [-69.85484700018884, 43.70432099961448],
              [-69.90117099964186, 43.82879600033522],
              [-70.10733100002557, 43.81986999970076],
              [-70.25284999992749, 43.6777760003622],
              [-70.19635600002931, 43.56527999987213],
              [-70.351171999688, 43.536335999706694],
              [-70.5209080003039, 43.3434829996408],
              [-70.81659699965178, 42.85535799967198],
              [-70.71669499987428, 42.6473100003563],
              [-70.86806699989211, 42.54866500008973],
              [-71.04723950040255, 42.32362089958491],
              [-70.71370699967827, 42.20016899999939],
              [-70.64984299985451, 41.950212999830114],
              [-70.5392170001644, 41.92666600033567],
              [-70.47667099996664, 41.76293299955836],
              [-70.26011200026858, 41.71222800042193],
              [-70.00375199975497, 41.80829100032946],
              [-70.0099010000311, 41.672321000114096],
              [-70.43304299983453, 41.620787999666504],
              [-70.63025400032183, 41.53962899997845],
              [-70.66723599974154, 41.71825599961477],
              [-70.92154099991717, 41.61441699994464],
              [-70.92877599991243, 41.53956799986338],
              [-71.19509800027248, 41.45402999968479],
              [-71.16404900016119, 41.70627200005282],
              [-71.298111999669, 41.723066000195786],
              [-71.45809800032242, 41.582701999697576],
              [-71.48125799995671, 41.360119000091856],
              [-71.85863020032343, 41.31009519963379],
              [-71.88221300002988, 41.35049299955233],
              [-72.38843700006748, 41.260671999713054],
              [-72.91525500011812, 41.296591999621114],
              [-73.13023199970701, 41.14713199964211],
              [-73.34511200021859, 41.11363199981702],
              [-73.66089499990426, 40.98739100039438],
            ],
          ],
        ],
      },
      id: 10,
      NAME: 'NEWE',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'NWPP',
        id: 11,
        label: 'NWPP',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.27481869222399996,
        year: 2023,
        centroid: [141.08178768325007, 134.16357942357016],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-107.78858099981323, 37.00000199999238],
              [-108.09902899988839, 36.91910399974984],
              [-108.04731099990266, 36.99972899999341],
              [-107.78858099981323, 37.00000199999238],
            ],
          ],
          [
            [
              [-106.07372499980886, 42.9666379998439],
              [-106.07282799981232, 42.839786000123866],
              [-106.27930100024093, 42.89811900029167],
              [-106.07372499980886, 42.9666379998439],
            ],
          ],
          [
            [
              [-106.07806899958462, 43.494470999936766],
              [-106.0735879997863, 43.32124999958785],
              [-106.285389000402, 43.269403999994665],
              [-106.44476299981255, 43.43491900021172],
              [-106.40721200023359, 43.49277399992019],
              [-106.07806899958462, 43.494470999936766],
            ],
          ],
          [
            [
              [-105.4256150001321, 44.29641199971405],
              [-105.20959700020137, 44.08468299972071],
              [-105.08030699956834, 44.06405700003057],
              [-105.07979400019292, 43.49845100001369],
              [-104.8999409997773, 43.49964100003217],
              [-104.89808799976134, 42.973587000140014],
              [-104.64844000030575, 43.034912999835115],
              [-104.60421200038348, 42.674848000434906],
              [-104.65495600041908, 42.41265599987457],
              [-104.9136689997245, 42.45993400015402],
              [-104.84940600038658, 42.23005300034572],
              [-104.90634600016773, 42.13090999959684],
              [-104.65445599984446, 42.18936700008703],
              [-104.65334399982572, 41.81216299992258],
              [-105.07097700008848, 41.783959999754245],
              [-105.11866699958233, 41.656416999644875],
              [-105.3239289999234, 41.66076899978958],
              [-105.38813400018392, 41.85537299966427],
              [-105.27161700042421, 41.89625099978389],
              [-105.28127000041013, 42.1425510004284],
              [-105.4149450000117, 42.15146899979453],
              [-105.37554199956361, 42.290139999561404],
              [-105.6138650001696, 42.30445799973694],
              [-105.55604200013818, 42.4305830001054],
              [-105.69849699993654, 42.431060999665476],
              [-105.80235400043671, 42.54955899994792],
              [-105.64324199961857, 42.7978339999392],
              [-105.65294500011163, 42.91031499973752],
              [-105.78652900001333, 42.95102200006528],
              [-105.68782499972394, 43.25473799995876],
              [-105.92189400020789, 43.49442899979857],
              [-106.01736699988709, 43.49496999956585],
              [-106.01655500021303, 44.21637899979106],
              [-105.8950180000806, 44.175600999786354],
              [-105.58795499962349, 44.29479399974332],
              [-105.4256150001321, 44.29641199971405],
            ],
            [
              [-105.65501300014978, 43.648985000057735],
              [-105.46942899984845, 43.676636999997584],
              [-105.47561800017053, 43.75927000021039],
              [-105.65501300014978, 43.648985000057735],
            ],
          ],
          [
            [
              [-104.17211300031465, 45.56714900022621],
              [-104.42251500036696, 45.76097400015004],
              [-104.72374599987796, 45.78965599992449],
              [-104.66318000015684, 45.71115000027237],
              [-104.86434799966042, 45.57247799956008],
              [-104.61842500021356, 45.40433599960676],
              [-104.89585100002358, 45.22212400012256],
              [-104.51765299988602, 45.175602999678745],
              [-104.39194699995403, 45.25423899992995],
              [-104.48534800030995, 45.356514000320885],
              [-104.33553300014779, 45.42020100007613],
              [-104.03995799976184, 45.21292600043461],
              [-104.04030300038312, 44.99777099983186],
              [-105.03840499989082, 45.000345999868046],
              [-105.0382360001912, 45.352052999646276],
              [-104.9871430002492, 45.352024000107576],
              [-104.98203600036112, 45.78701000021141],
            ],
          ],
          [
            [
              [-122.5954859999789, 48.39728000007199],
              [-122.50597199990784, 48.3092439998108],
              [-122.6283520002446, 48.22246800009816],
              [-122.5191050002955, 48.02189700024644],
              [-122.37573999990104, 48.0337229997167],
              [-122.37890900035006, 47.90473999975126],
              [-122.60763700004748, 48.03064399982077],
              [-122.6115850004474, 48.15462500024364],
              [-122.770206799704, 48.22454220006256],
              [-122.5954859999789, 48.39728000007199],
            ],
          ],
          [
            [
              [-122.60653899977501, 48.52125100003366],
              [-122.50196500038442, 48.43703000033429],
              [-122.6567486001677, 48.4079243002663],
              [-122.60653899977501, 48.52125100003366],
            ],
          ],
          [
            [
              [-123.1454610004248, 48.62354200026317],
              [-122.96275499974342, 48.450482000144234],
              [-123.15066300019726, 48.5138020000623],
              [-123.1454610004248, 48.62354200026317],
            ],
          ],
          [
            [
              [-122.90340999967174, 48.71509099974992],
              [-122.83029000018331, 48.60027300009892],
              [-123.01038800020604, 48.65505100000371],
              [-122.90340999967174, 48.71509099974992],
            ],
          ],
          [
            [
              [-104.04873699991259, 48.99987799996978],
              [-105.77799600041504, 48.99967200036258],
              [-104.04873699991259, 48.99987799996978],
            ],
          ],
          [
            [
              [-106.83187900021568, 48.999921000154075],
              [-105.34463199956707, 45.66982900040807],
              [-105.7357459999779, 45.71380799963953],
              [-105.77598899959264, 45.60583800012364],
              [-105.51193489967585, 45.56861100019756],
              [-105.6516089996556, 45.49145499984843],
              [-105.54626099964537, 45.33663600005144],
              [-105.72570609995654, 45.21527380024571],
              [-105.92818499983781, 44.9936470003089],
              [-106.18348910004192, 44.99360469979712],
              [-106.09095600031912, 44.87050499990585],
              [-106.22703400011898, 44.75598599965423],
              [-106.20781399961635, 44.562139999661326],
              [-107.24861599962867, 44.661772999624304],
              [-107.1643889996526, 44.71241000012145],
              [-107.18392000010789, 44.91020799979941],
              [-107.40351699960979, 44.91052800016712],
              [-107.60699200028057, 45.00093099986583],
              [-108.6213130003946, 45.0002780003295],
              [-108.57343500032499, 44.4612619998415],
              [-108.9363230004061, 44.49499599966572],
              [-108.9455909997248, 44.405376000102365],
              [-109.239811999724, 44.3056230000015],
              [-109.39338999984858, 44.33330500042547],
              [-109.54947100028642, 44.20845100021353],
              [-109.54233300026772, 43.96135299964129],
              [-109.78737000022528, 43.80115600004939],
              [-109.85875399969729, 43.95798900009231],
              [-109.9938720001926, 43.949557999801925],
              [-110.05335799957197, 44.132629000228235],
              [-111.04909199959604, 44.13236799988334],
              [-111.04672500015857, 43.82160799980937],
              [-110.92380600014678, 43.864263000037454],
              [-110.82305199974996, 43.68937400011009],
              [-111.04551099993267, 43.583468999594686],
              [-110.82232200026004, 43.61181199992393],
              [-110.80078700002002, 43.546683000220355],
              [-110.96686700021183, 43.315834999885396],
              [-110.81399400022292, 43.235177999964776],
              [-110.34396200004625, 43.29116499986492],
              [-110.4258009996164, 43.60936000016392],
              [-110.6639629999924, 43.624589000082324],
              [-110.62725100043326, 43.7499840000616],
              [-110.05142500036345, 43.704341999683606],
              [-110.05157099990168, 43.46478399968191],
              [-109.75471699988958, 43.46320000037974],
              [-109.62155699975568, 43.1265250004285],
              [-109.3622669999221, 42.91743599987154],
              [-109.67368599980898, 42.82399999970028],
              [-109.70190570038773, 42.5670181998301],
              [-109.843949000446, 42.60267599969768],
              [-110.07228299996046, 42.523834999885366],
              [-110.18877200022757, 42.27073699961289],
              [-109.49668499961302, 42.26331900017175],
              [-107.52272300016631, 42.26175700008554],
              [-107.50972100042378, 41.65745199971008],
              [-107.92973699996253, 41.65959699970182],
              [-107.91842199977543, 41.00203700040731],
              [-110.00103100028042, 40.99765799991684],
              [-110.00070899982046, 40.813750999609],
              [-109.87020799999914, 40.76382999975476],
              [-109.3944819998444, 40.8580730002688],
              [-109.20325300002588, 40.858642000428006],
              [-109.0500710001765, 40.54043699966786],
              [-108.50178700036975, 40.436346000067886],
              [-108.6210520000497, 40.222370999921736],
              [-108.31475499984333, 40.221632000016825],
              [-108.25909999996497, 40.04070799967451],
              [-108.54865699982065, 40.03364400037037],
              [-108.61243700026733, 39.85081600035818],
              [-108.50958400020141, 39.729357000225434],
              [-108.55463000007438, 39.650165999561295],
              [-109.05116300017227, 39.66047300002896],
              [-109.06006299960774, 38.275490000163416],
              [-109.04176300016229, 38.164690999689924],
              [-109.04522299964168, 36.99908499997281],
              [-108.25063499990529, 36.99956200038605],
              [-124.140134000084, 41.685371000271516],
              [-124.25578400033129, 41.78294599975811],
              [-124.20452199979042, 41.981723999662904],
              [-124.35364200027806, 42.103307000118036],
              [-124.4355229999864, 42.43800000039977],
              [-124.41522600017976, 42.66067999998205],
              [-124.55338899990238, 42.83056600032069],
              [-124.45803999964625, 43.00098700014996],
              [-124.37494999994249, 43.3400949998844],
              [-124.22105300039561, 43.597874000185016],
              [-124.1547899996587, 43.88117400018001],
              [-124.05869199993583, 44.72901599968867],
              [-123.97119500024905, 45.159158000341506],
              [-123.96945700014044, 45.78236199990641],
              [-123.93313499968048, 46.06800900021523],
              [-124.04233200002176, 46.2749370000426],
              [-123.83922700022583, 46.70843099969096],
              [-124.0945289996136, 46.736970000065526],
              [-124.13454219996254, 46.90430820036323],
              [-123.82309099984974, 46.95765100009362],
              [-124.15110899988042, 47.02099300012691],
              [-124.23636000031371, 47.287287000095034],
              [-124.32105800042632, 47.354965000434504],
              [-124.42519500034894, 47.738433999929214],
              [-124.64624200016812, 47.91216999974574],
              [-124.70414500029148, 48.18442200017523],
              [-124.59021500022203, 48.37361999986314],
              [-124.05074899966655, 48.17770199964764],
              [-123.39491900011171, 48.11419800023759],
              [-123.12483299974309, 48.1535100000865],
              [-123.02271100011251, 48.08269599992053],
              [-122.80096699962729, 48.08613600027627],
              [-122.68319300035665, 47.9723970000216],
              [-122.81028400030635, 47.68192999956989],
              [-122.87511199961904, 47.745503000363215],
              [-123.14123699988761, 47.40397399960045],
              [-122.91717500042591, 47.62213300023785],
              [-122.52509799967294, 47.91236399969887],
              [-122.60653300039763, 47.54832100031399],
              [-122.53203000008438, 47.4690589999729],
              [-122.5883910001445, 47.25459399971339],
              [-122.72660200028207, 47.33809999971527],
              [-122.92796599983097, 47.2806430003742],
              [-122.92090299967367, 47.162893000411714],
              [-122.67701599968859, 47.102255000068226],
              [-122.53401030003528, 47.31711539985588],
              [-122.32477200032753, 47.34873900020477],
              [-122.43622999971467, 47.66195900040759],
              [-122.30764700020887, 47.948108999630676],
              [-122.21788000016187, 47.98256200023616],
              [-122.45092900037304, 48.23226699962237],
              [-122.49381100027739, 48.377459999779205],
              [-122.49021099973783, 48.74262699973633],
              [-122.64740700033275, 48.77392799977741],
              [-122.81814000016084, 48.9390309998808],
              [-122.75787769969605, 49.00212409994731],
              [-121.12884599994288, 49.00139899996395],
              [-117.12607599980748, 48.998888000181125],
              [-113.69298200031903, 48.997631999816974],
              [-111.50081299982003, 48.99696399958896],
              [-109.45402299996147, 49.00113200024168],
              [-106.83187900021568, 48.999921000154075],
            ],
            [
              [-106.2492039999646, 45.643472999979],
              [-106.33663200006674, 45.51237499960661],
              [-106.23394999979263, 45.453330999925754],
              [-106.2492039999646, 45.643472999979],
            ],
          ],
        ],
      },
      id: 11,
      NAME: 'NWPP',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'NYCW',
        id: 12,
        label: 'NYCW',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.40214559536,
        year: 2023,
        centroid: [594.9215702064422, 145.26276436204355],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-74.08265499982832, 40.64837000017542],
              [-74.24672099977425, 40.49587300043868],
              [-74.2002719999528, 40.63142000003302],
              [-74.08265499982832, 40.64837000017542],
            ],
          ],
          [
            [
              [-73.74680300005838, 40.78040999992163],
              [-73.70761899981693, 40.617058999673134],
              [-74.04187699982367, 40.624363000152414],
              [-73.90962600023965, 40.79093799978892],
              [-73.74680300005838, 40.78040999992163],
            ],
          ],
          [
            [
              [-73.51424900019117, 41.19865100034343],
              [-73.66089499990426, 40.98739100039438],
              [-73.80491700001949, 40.81212400012254],
              [-74.02518599993391, 40.70592100025402],
              [-73.91988100010803, 40.91339900026372],
              [-73.88677599961267, 41.13732399970286],
              [-73.9712779996799, 41.24797399960045],
              [-73.75299200038046, 41.345240000125955],
              [-73.51424900019117, 41.19865100034343],
            ],
          ],
        ],
      },
      id: 12,
      NAME: 'NYCW',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'NYLI',
        id: 13,
        label: 'NYLI',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.548533795112,
        year: 2023,
        centroid: [597.9918858936948, 170.1877020603823],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-71.89711200001875, 41.07863500020517],
              [-71.94768150010111, 41.030919700084155],
              [-72.43129399971826, 40.85705500008822],
              [-72.37204300038411, 40.99329900034866],
              [-72.10495299968113, 40.99102199966558],
              [-71.89711200001875, 41.07863500020517],
            ],
          ],
          [
            [
              [-73.70761899981693, 40.617058999673134],
              [-73.74680300005838, 40.78040999992163],
              [-73.63323300040258, 40.902787000119986],
              [-73.21678900011221, 40.908374999706496],
              [-73.13521800031043, 40.96703799980389],
              [-72.63471100041232, 40.9819840001615],
              [-72.3154539997023, 41.140403999644946],
              [-72.62700600032662, 40.910997000111536],
              [-72.4909309997658, 40.87385399956247],
              [-72.87407200032254, 40.73727800017963],
              [-73.2282580002065, 40.71683399988922],
              [-73.55530699961832, 40.61588100020805],
              [-73.70761899981693, 40.617058999673134],
            ],
          ],
        ],
      },
      id: 13,
      NAME: 'NYLI',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'NYUP',
        id: 14,
        label: 'NYUP',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.124914247288,
        year: 2023,
        centroid: [540.1492331624623, 130.69291320072008],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-73.34312400027238, 45.010839999966095],
              [-73.91988100010803, 40.91339900026372],
              [-73.95893699984265, 41.022573000443685],
              [-74.1641020002071, 41.02196700037683],
              [-74.21329099957995, 41.13399499996933],
              [-74.42812000043762, 41.15040200025214],
              [-74.41339999971018, 41.226194999799475],
              [-74.81619900028358, 41.441384000171524],
              [-74.98344899957164, 41.48106900013431],
              [-75.07217200003771, 41.81373200033158],
              [-75.25119700004149, 41.86204000044569],
              [-75.35957369996623, 41.999431899862316],
              [-76.37465999975916, 41.998410000221384],
              [-78.26181230009752, 41.99909150017265],
              [-79.76095000014237, 41.99881769977708],
              [-79.76194970001859, 42.269336200305474],
              [-79.31769500002417, 42.50244199989845],
              [-79.14900399993462, 42.55350600030175],
              [-79.04756200018613, 42.69153800027857],
              [-78.85428400030634, 42.78379099985483],
              [-79.01156400027833, 42.9852559995648],
              [-79.07046999989052, 43.262453999652394],
              [-78.63758400040126, 43.35740000020991],
              [-78.10450999963672, 43.375627999932306],
              [-77.71375799973185, 43.323343999925726],
              [-77.57696600028066, 43.24286700021196],
              [-77.14644800027497, 43.289999000053854],
              [-76.94179400009301, 43.24343999965629],
              [-76.71280299995846, 43.312648999551755],
              [-76.63094599955821, 43.41298400041137],
              [-76.20332400000257, 43.57631799987587],
              [-76.22861599992842, 43.802879000365635],
              [-76.12882099968937, 43.896070000030534],
              [-76.33919700024131, 44.1295850001477],
              [-76.01239599967562, 44.26676999973574],
              [-76.00191099999262, 44.34607000003052],
              [-75.30278300023525, 44.838474000374845],
              [-74.9724630001673, 44.98340300004844],
              [-73.34312400027238, 45.010839999966095],
            ],
          ],
        ],
      },
      id: 14,
      NAME: 'NYUP',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'RFCE',
        id: 15,
        label: 'RFCE',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.29951178711200005,
        year: 2023,
        centroid: [534.2994794813319, 174.6025392559633],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-73.91988100010803, 40.91339900026372],
              [-74.02518599993391, 40.70592100025402],
              [-74.20307999994202, 40.634354000436815],
              [-74.28304200018812, 40.500400999706414],
              [-73.99227200015264, 40.40804499987689],
              [-74.05654709986874, 40.04030430030326],
              [-74.18483500033494, 39.794527000021105],
              [-74.16810699963827, 39.7028330001429],
              [-74.41135699992554, 39.53487499968156],
              [-74.55031200019863, 39.321566999717334],
              [-74.97201800033042, 38.940427999752444],
              [-74.90131800002564, 39.17465300023582],
              [-75.11107299981904, 39.211653999632404],
              [-75.59306900043396, 39.47918700008006],
              [-75.40572399986269, 39.25870700032783],
              [-75.40237800024448, 39.067453000255796],
              [-75.18295000044213, 38.801866999662366],
              [-75.06250200016711, 38.5819550000233],
              [-75.09468999974365, 38.32940299974871],
              [-75.36552999980961, 38.07644799977544],
              [-75.70136399964883, 37.574644000320404],
              [-75.89735499963348, 37.357085000372535],
              [-75.96923500039492, 37.11656199993638],
              [-76.02535900031756, 37.257643000224334],
              [-75.94037399956039, 37.5655120000788],
              [-75.73154400015545, 37.919782000239195],
              [-75.83657700002851, 37.934938000388456],
              [-75.82767399955537, 38.13343900010983],
              [-75.92912000038768, 38.21642999974472],
              [-76.1722200000529, 38.24748600017881],
              [-76.33137800029442, 38.47349000016345],
              [-76.33534899995635, 38.77377300002399],
              [-76.20640199985235, 38.85595500012323],
              [-76.2280376998799, 38.96535840027002],
              [-76.3762029998685, 38.850461000374935],
              [-76.27831000010639, 39.148078999646145],
              [-76.06165499957854, 39.447925000038765],
              [-76.38038800040584, 39.298786999620404],
              [-76.47955200032453, 39.19186900005434],
              [-76.39454999968268, 39.01236599959128],
              [-76.55729399981817, 38.74415300016091],
              [-76.48938599966414, 38.47918500018767],
              [-76.23674299968962, 37.88864399962091],
              [-76.51654800038989, 38.02656599992099],
              [-76.61037870041667, 38.148494199747574],
              [-76.94892399974276, 38.20826099984532],
              [-77.01165600042407, 38.37438500026758],
              [-77.2471500000724, 38.33152400043235],
              [-77.32560500007065, 38.44319599979559],
              [-77.24640399984469, 38.59341899988698],
              [-77.04279400014298, 38.71867199961315],
              [-77.04049660013794, 38.871305500248695],
              [-77.2485800003667, 39.026764999904856],
              [-77.50368200042396, 39.1151849998879],
              [-77.19823399979919, 39.286696999666844],
              [-77.27170400013944, 39.50486399977382],
              [-77.1803250003984, 39.59478999995861],
              [-77.2646670002818, 39.72000399968488],
              [-77.47886049971225, 39.72001879982781],
              [-77.47669399962837, 39.84217999960737],
              [-77.67292499988878, 39.804791000304476],
              [-77.75063999993603, 39.929155000403],
              [-77.9586049999208, 39.914018000230556],
              [-78.14055499991326, 39.72238399972184],
              [-79.52371500024702, 39.72090399981977],
              [-79.4969289997735, 39.82788100030797],
              [-79.66097899988091, 40.01745700034036],
              [-79.48792900022312, 39.97386099988529],
              [-79.38527500034098, 40.04508700016498],
              [-79.31442240037342, 40.322322699832796],
              [-79.50491600027317, 40.3891309999957],
              [-79.66553500043989, 40.52252600017482],
              [-79.4864389998599, 40.639622999701714],
              [-79.53990100023094, 40.706685000412506],
              [-79.85506800028793, 40.63088799978141],
              [-79.94969799976286, 40.5317069999781],
              [-80.10158600019372, 40.67421000019141],
              [-80.22946200037097, 40.96172300021635],
              [-80.26502700009593, 40.88071500029707],
              [-80.43503899994982, 41.01808300023032],
              [-80.28265800016652, 41.04089700009655],
              [-80.0462230002912, 41.29678500042746],
              [-80.15233499956054, 41.40746900009435],
              [-80.34542999999445, 41.321859000192774],
              [-80.51909099994964, 41.34784199960865],
              [-80.51937599960269, 41.97723300030276],
              [-79.76194970001859, 42.269336200305474],
            ],
            [
              [-78.39020500036042, 41.74528100031796],
              [-78.33621700001453, 41.62373399972438],
              [-78.20342199962556, 41.61815699974579],
              [-78.39020500036042, 41.74528100031796],
            ],
            [
              [-78.48342730002986, 41.62333929986886],
              [-78.79006200016113, 41.624935000250105],
              [-78.8862749997914, 41.46997100006166],
              [-78.72457400009, 41.518262000291145],
              [-78.63742400021738, 41.390609999651815],
              [-78.42005700013044, 41.39801400024595],
              [-78.48342730002986, 41.62333929986886],
            ],
            [
              [-77.8002919999758, 41.08292300009646],
              [-77.82305400014195, 40.92992000040772],
              [-77.9252070003028, 40.858230000314336],
              [-77.82487200034251, 40.74353600008641],
              [-77.59505399984221, 40.94276800024306],
              [-77.7340350004149, 40.94674500018169],
              [-77.8002919999758, 41.08292300009646],
            ],
          ],
        ],
      },
      id: 15,
      NAME: 'RFCE',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'RFCM',
        id: 16,
        label: 'RFCM',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.555281429704,
        year: 2023,
        centroid: [448.25053319805374, 144.5507082099222],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-85.56248800012105, 45.759532000201716],
              [-85.49086300032718, 45.608065000299575],
              [-85.63001599983846, 45.598165999761136],
              [-85.56248800012105, 45.759532000201716],
            ],
          ],
          [
            [
              [-83.45534599961815, 41.73280599969718],
              [-83.99869400022789, 41.71685799989683],
              [-83.94613400008399, 41.4872089999954],
              [-84.43828000022182, 41.427233999649445],
              [-84.51462600008978, 41.7032809997184],
              [-84.80596600033061, 41.696087999861334],
              [-84.80581299957026, 41.76018499963806],
              [-85.29210000021482, 41.75996200014623],
              [-85.44863700009745, 41.92635300029076],
              [-85.54359800044733, 41.758838999620195],
              [-85.82744499958704, 41.75913699987268],
              [-85.66675599978953, 42.0701119999689],
              [-85.81986499986982, 42.102629000328136],
              [-86.0875950004089, 41.91200200039208],
              [-86.22344039955476, 41.92760599961724],
              [-86.19573699976269, 42.178790999804846],
              [-86.41314099975727, 42.18652400028242],
              [-86.31148199989434, 42.3311339996344],
              [-86.19658200005921, 42.32257899992095],
              [-86.14858099971332, 42.48386600031574],
              [-86.24438500026753, 42.51075099995876],
              [-86.20662600008978, 42.71026399958396],
              [-86.25537900004076, 43.085829999754765],
              [-86.42670300014328, 43.374130000099456],
              [-86.53933399966434, 43.6561890004221],
              [-86.43437799974487, 43.797961000200075],
              [-86.50045299990597, 44.075608000309046],
              [-86.2676579997169, 44.34650300021332],
              [-86.24434999955281, 44.701758999977926],
              [-86.0731030003032, 44.76981299967025],
              [-86.07233900014472, 44.88301500034203],
              [-85.80948399958686, 44.94866399974387],
              [-85.61865600027414, 45.18696100005019],
              [-85.5662740002449, 45.059227000125986],
              [-85.64704199988836, 44.88032799963753],
              [-85.59466700018186, 44.767758000231595],
              [-85.47500900036505, 44.99158200040904],
              [-85.5259880004458, 44.748064000353395],
              [-85.40891700031926, 44.90544899977158],
              [-85.37136699988707, 45.27170499958612],
              [-85.04127000021032, 45.43649399959844],
              [-85.11991099979275, 45.56944299989459],
              [-84.79161699962481, 45.78237100032146],
              [-84.47892019980736, 45.656449000321174],
              [-84.21526799971838, 45.63476799964354],
              [-84.11740300034813, 45.514077999899825],
              [-83.46382100013903, 45.33096800037299],
              [-83.31328800014103, 45.126303999729885],
              [-83.46340599988696, 44.995798999724116],
              [-83.31256299998245, 44.88292699988119],
              [-83.27242399976774, 44.713208000049235],
              [-83.33331400004101, 44.33751000008647],
              [-83.54906900043397, 44.22727000021041],
              [-83.57800700032277, 44.04884600004294],
              [-83.83122799997216, 43.998009000215234],
              [-83.95683199969699, 43.76054999988264],
              [-83.90553200010169, 43.670327000390785],
              [-83.66604399973079, 43.59128300021035],
              [-83.48987500013112, 43.69868499961308],
              [-83.26195199978491, 43.97541199956419],
              [-82.92951700020933, 44.06952400033242],
              [-82.74062999957476, 43.99218100035296],
              [-82.61390100013102, 43.779584999947815],
              [-82.52303000043412, 43.22528100041791],
              [-82.41298000032674, 42.9770200001729],
              [-82.51855399996708, 42.61466000015895],
              [-82.62525300022577, 42.67327599988755],
              [-82.81872299996644, 42.62932700024095],
              [-82.89832499979889, 42.38474899986653],
              [-83.1280230001613, 42.23883899991995],
              [-83.14496199979641, 42.054558000351506],
              [-83.38204800001517, 41.87097699978875],
              [-83.45534599961815, 41.73280599969718],
            ],
          ],
        ],
      },
      id: 16,
      NAME: 'RFCM',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'RFCW',
        id: 17,
        label: 'RFCW',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.456270007168,
        year: 2023,
        centroid: [464.6393384649164, 191.75578666412153],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-83.38843270000905, 37.69990749963148],
              [-83.16225749968385, 37.634335299634415],
              [-83.26177899990091, 37.580306999768254],
              [-83.38843270000905, 37.69990749963148],
            ],
          ],
          [
            [
              [-86.31148199989434, 42.3311339996344],
              [-86.24438500026753, 42.51075099995876],
            ],
          ],
          [
            [
              [-87.699249000441, 43.965307000317864],
              [-87.72666700038172, 43.64996400023847],
              [-87.91201000036119, 43.24903499956565],
              [-87.82397400010001, 42.83492800002722],
              [-87.83608800026099, 42.309314899962715],
              [-87.68009100009954, 42.078524000282414],
              [-87.52108200043392, 41.710116000153334],
              [-87.2991539995574, 41.619264000433304],
              [-86.92233700015242, 41.71390799965451],
              [-86.68584300025424, 41.83889499970451],
              [-86.41314099975727, 42.18652400028242],
              [-83.45534599961815, 41.73280599969718],
              [-83.10372600025465, 41.613301999787495],
              [-82.92256699986712, 41.41909400018801],
              [-82.8109130004346, 41.47633999969128],
              [-82.47292600023468, 41.38194100007712],
              [-82.0125999997901, 41.515676999793754],
              [-81.74286899960458, 41.48783400003913],
              [-81.28224899999134, 41.765888000031225],
              [-80.51937599960269, 41.97723300030276],
              [-77.50368200042396, 39.1151849998879],
              [-77.45785699970071, 39.22575599973965],
              [-77.7189303002931, 39.321285699875205],
              [-77.82815699984565, 39.13232899998343],
              [-78.24536300020225, 39.40271399975131],
              [-78.25830030001879, 39.27699290020223],
              [-78.4291729996342, 39.13227200005281],
              [-78.47007299986899, 38.978475999767625],
              [-78.39543100034035, 38.915862000031325],
              [-78.6274499998176, 38.616849000281206],
              [-78.58291300003486, 38.45493199961214],
              [-78.78334699986414, 38.569719999678284],
              [-79.02052699992106, 38.579829000008374],
              [-78.86458100031285, 38.3814020001023],
              [-78.70420699975318, 38.49458599994398],
              [-78.73191589979888, 38.30598659980177],
              [-78.92260399967483, 38.23675900012779],
              [-78.77269000034318, 38.15325100003366],
              [-78.83470500033548, 38.040049000261206],
              [-78.48524459965853, 38.0561007998121],
              [-78.35138199967952, 37.9557420001932],
              [-78.36341100041727, 37.73075500034304],
              [-78.51162100030888, 37.63671600024327],
              [-78.64403600026117, 37.73314299984963],
              [-78.71903700015741, 37.66114299984963],
              [-78.65132900023315, 37.3406859995593],
              [-78.77429599976057, 37.32248900036711],
              [-78.73409600033011, 37.220091999746046],
              [-78.96591289966057, 37.19335830024539],
              [-78.96422859986995, 37.0643483997589],
              [-79.19299399967332, 37.05456099969041],
              [-79.20629799985278, 37.190658000366454],
              [-79.48787599957768, 37.06689800024259],
              [-79.5249390000348, 36.94540500034054],
              [-79.18500499998072, 36.81910199985748],
              [-79.01527079980752, 36.876957799962554],
              [-78.85466199975144, 36.85407300006892],
              [-78.82913399973427, 36.713627000285896],
              [-78.9548530002657, 36.758445000436495],
              [-79.14563800029345, 36.63991999980817],
              [-78.87288600018871, 36.60684899998142],
              [-78.88070839957294, 36.5420422003873],
              [-80.29486300002742, 36.54398300031528],
              [-81.67753500033996, 36.588118000445434],
              [-82.9851239996728, 36.59373000023936],
              [-82.86725100033334, 36.69348400038638],
              [-82.86918400044124, 36.97418300004546],
              [-83.07699699971175, 37.047806000246794],
              [-83.18533500001018, 37.02133199977203],
              [-83.31878900021218, 37.13684900018126],
              [-83.32287899996584, 37.47908500027262],
              [-83.11599200023056, 37.51873999975123],
              [-82.97704279968542, 37.348904900141065],
              [-82.63739149971792, 37.54243289985851],
              [-82.58203099993068, 37.764443999890716],
              [-82.46829099962991, 37.81527600038714],
              [-82.48881700010446, 37.99868500021262],
              [-82.61945199980988, 38.12074500018167],
              [-82.66486599956619, 38.26470199999733],
              [-82.81323000026424, 38.21297399955051],
              [-82.74511799969588, 38.469445999833056],
              [-82.89039300003691, 38.75627699988371],
              [-83.2865140002209, 38.59924200041803],
              [-83.52095299978106, 38.703046000272764],
              [-83.76500900036501, 38.652845000096704],
              [-83.87044299984456, 38.76160900025519],
              [-84.21290499956604, 38.80570699957843],
              [-84.32653900037451, 39.02746299971773],
              [-84.44524200021812, 39.11446099977536],
              [-84.63244599968311, 39.07676099962049],
              [-84.75074899996633, 39.14735899971811],
              [-84.89387300003887, 39.06246699965237],
              [-84.78523500029502, 38.88043899966016],
              [-84.8146420002281, 38.784488999567714],
              [-85.14327499984131, 38.696870999696955],
              [-85.45211400036078, 38.70934899955671],
              [-85.43394299966968, 38.52348299974068],
              [-85.62063060032193, 38.42339579987629],
              [-85.65242299982157, 38.32977099963199],
              [-85.82958900043201, 38.27683500013518],
              [-85.92479300029669, 38.0242110001376],
              [-86.17898399971176, 38.01130899961072],
              [-86.32594100027688, 38.154316999729815],
              [-86.51175999972418, 38.04444799987533],
              [-86.50700099969634, 37.92986899955474],
              [-86.74653000015934, 37.907743999985655],
              [-86.79503200022657, 37.9892100003413],
              [-87.04586600041557, 37.89187600027725],
              [-87.12962999972467, 37.78660800035897],
              [-87.38024799984527, 37.93559600015533],
              [-87.60141699989458, 37.97254199971354],
              [-87.68717500032596, 37.90357600023225],
              [-87.9406469998591, 37.885547999840355],
              [-88.02802999968469, 37.799225000333536],
              [-88.09495699956585, 37.89368900024721],
              [-87.74002400030736, 38.47922300014142],
              [-87.64537199981788, 38.513836000031404],
              [-87.49538099963337, 38.78381099977787],
              [-87.51218800037589, 38.9544180000907],
              [-87.65874699967424, 39.135997000061536],
              [-87.53164700020886, 39.34788900037711],
              [-87.52664199962857, 41.121449999717754],
              [-87.73939299998693, 41.130870999796855],
              [-87.92477399992015, 41.002393999783294],
              [-88.13437799994472, 41.10752399963292],
              [-88.13074000035073, 40.93922000030284],
              [-88.57743800006364, 40.93279699998163],
              [-88.83512199958056, 40.9734899996638],
              [-89.06693400030383, 40.926083999776836],
              [-89.16226499972993, 41.10398800024609],
              [-88.96128099971833, 41.20371199990893],
              [-88.74122239979386, 41.199063299931424],
              [-88.60443699956784, 41.29079500028911],
              [-88.65380600004681, 41.4445319996521],
              [-88.40409200024556, 41.45977100003165],
              [-88.32590199987737, 41.56329400041784],
              [-88.48990300042311, 41.72203799955406],
              [-88.94052500032848, 41.71718399964192],
              [-88.94590400016943, 41.652419999683275],
              [-89.28639099964488, 41.67743600037119],
              [-89.305008000219, 41.6138410003619],
              [-89.54817999960727, 41.64261399983627],
              [-89.6314769998636, 41.584896000150366],
              [-89.82461699967473, 41.72183700017746],
              [-90.03138800035589, 41.66321200003381],
              [-90.07419899968403, 41.56234799996031],
              [-90.25410599989192, 41.52253100020556],
              [-90.43714680018462, 42.50723499969553],
            ],
            [
              [-79.66197499994627, 38.56761599977864],
              [-79.68967500030101, 38.43143999995607],
              [-79.94522600037959, 38.13225699956092],
              [-80.34346300011731, 37.89152800041694],
              [-80.39680610022128, 37.781676000447135],
              [-80.6019750000462, 37.72278999995859],
              [-80.47988079975909, 37.605346700290056],
              [-80.29610699983812, 37.69179100035444],
              [-80.22289299961221, 37.54475899992798],
              [-79.92268899979746, 37.698379000190755],
              [-79.81669399962834, 37.80097400005013],
              [-79.67400599987695, 37.763052000449534],
              [-79.57141400015593, 37.601726000054896],
              [-79.4697767998594, 37.72421750013757],
              [-79.34520599975707, 37.660374000359866],
              [-79.20137799959497, 37.90409900006887],
              [-79.04587699982363, 37.85732299955686],
              [-78.89312299992645, 37.996415999898545],
              [-79.05290300007334, 37.94073000038924],
              [-79.2747970002813, 37.982315999883554],
              [-79.2100579996769, 38.03835999971426],
              [-79.32361200039344, 38.14834799966053],
              [-79.28321900015669, 38.40082900025823],
              [-79.66197499994627, 38.56761599977864],
            ],
          ],
          [
            [
              [-83.6441340001839, 46.10297900038063],
              [-83.47322200019511, 45.98442300012141],
              [-83.5279529997311, 45.91817900026069],
              [-83.88324000002592, 45.96914299964976],
              [-83.6441340001839, 46.10297900038063],
            ],
          ],
          [
            [
              [-89.18152899956362, 45.982397000221454],
              [-89.4292069999031, 46.115439000309664],
            ],
          ],
          [
            [
              [-88.97871100041232, 45.9822170000146],
              [-88.57883499973542, 46.00971900023171],
              [-88.52459939984237, 46.04276559965274],
              [-88.61729199972598, 46.42013699962291],
            ],
          ],
          [
            [
              [-86.11661789989614, 45.965004600182226],
              [-85.8644140002059, 46.68970400033942],
              [-85.501366999987, 46.67642000018293],
              [-85.25718499988778, 46.75335600027927],
              [-84.95644999986757, 46.77201800023056],
              [-85.04931799992573, 46.503140999857294],
              [-84.59545099966385, 46.4143259996452],
              [-84.30618439989013, 46.48924229959249],
              [-84.07231000010637, 46.09424200036807],
              [-83.8981200998627, 45.99248889994283],
              [-84.30014700008394, 45.97791500037704],
              [-84.65794700025384, 46.05247299962929],
              [-84.75082199973548, 45.83911600010339],
              [-85.01239399958337, 46.01021399967641],
              [-85.5215330000479, 46.0912530001259],
              [-85.69148799997117, 45.95832499989888],
              [-85.91372799994718, 45.919437999863874],
              [-86.11661789989614, 45.965004600182226],
            ],
          ],
        ],
      },
      id: 17,
      NAME: 'RFCW',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'RMPA',
        id: 18,
        label: 'RMPA',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.5133450349359999,
        year: 2023,
        centroid: [229.32547324811722, 184.01851926740062],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-104.98203600036112, 45.78701000021141],
              [-104.03995799976184, 45.21292600043461],
              [-101.81280700034273, 40.002851000373425],
              [-102.05174399958588, 40.0030780000497],
              [-102.0423105996544, 36.99311010035092],
              [-102.86544999961774, 36.99959099992475],
              [-108.09902899988839, 36.91910399974984],
              [-108.25033200032152, 36.91011299971524],
              [-107.24861599962867, 44.661772999624304],
              [-106.61476700019688, 44.557061000165106],
              [-105.34463199956707, 45.66982900040807],
            ],
          ],
          [
            [
              [-104.17211300031465, 45.56714900022621],
              [-104.33553300014779, 45.42020100007613],
            ],
          ],
        ],
      },
      id: 18,
      NAME: 'RMPA',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'SPNO',
        id: 19,
        label: 'SPNO',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.43516754655199996,
        year: 2023,
        centroid: [312.5512080556987, 222.4719199466715],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-93.80847900020564, 37.04339299998702],
              [-93.73574200039297, 36.79086299982765],
              [-93.84311700034925, 36.80365799991682],
              [-93.80847900020564, 37.04339299998702],
            ],
          ],
          [
            [
              [-93.22709300004186, 37.1153370001025],
              [-93.15242400016746, 37.18698900024219],
              [-92.97467100036636, 37.268285999998966],
              [-93.01756800006314, 37.02231300004496],
              [-93.22709300004186, 37.1153370001025],
            ],
          ],
          [
            [
              [-92.76304100044177, 39.31851800030552],
              [-92.72863600025119, 39.20890100038093],
              [-92.99802099976927, 39.17755400001715],
              [-93.0505609998902, 39.25259700005154],
              [-92.76304100044177, 39.31851800030552],
            ],
          ],
          [
            [
              [-94.7080209997693, 40.57224199956869],
              [-94.60874700017388, 40.38670599968219],
              [-94.36686099983524, 40.470392999937076],
              [-94.35012399962284, 40.30004199973854],
              [-94.49591899966208, 40.29933200027165],
              [-94.46444499973688, 40.11192300034622],
              [-94.35072400031231, 40.04086000038876],
              [-94.54670799997416, 39.944254999768475],
              [-94.54616900029907, 39.84947599971764],
              [-94.33851200012867, 39.834335000260126],
              [-94.33700900006528, 39.65986599991601],
              [-94.46998499980788, 39.747613000339754],
              [-94.52827199965304, 39.539846999639394],
              [-94.40666800002816, 39.302671999813015],
              [-94.2896820002241, 39.238663999643904],
              [-94.09230800031395, 39.296403000298255],
              [-93.91599100018448, 39.08605300004598],
              [-93.74947799980981, 39.155837000377346],
              [-93.48497799983477, 39.154348000060224],
              [-93.47723099961092, 39.29279800042741],
              [-93.64501900032656, 39.31084399985076],
              [-93.64500299958871, 39.467004000334384],
              [-93.49464799970536, 39.43409299979214],
              [-93.42159999993999, 39.52913899956525],
              [-93.27628999978361, 39.52962100020903],
              [-92.9753080000641, 39.76180700019296],
              [-92.81927199990281, 39.73582599996996],
              [-92.80865160009125, 39.856985599605764],
              [-92.59904099994213, 39.86950599980213],
              [-92.62116000013384, 39.609273999695404],
              [-92.8581460002377, 39.68564099963248],
              [-92.87368800020101, 39.34544299999453],
              [-93.10607000023032, 39.38372500000878],
              [-93.13375299980106, 39.226487000174984],
              [-93.25837500010613, 39.232969999665784],
              [-93.30372799974737, 39.06697499979646],
              [-93.58173500026999, 39.054520000097966],
              [-93.7116798998075, 38.99381200012374],
              [-93.62252299983652, 38.86998200036908],
              [-93.59146400016346, 38.61631900012179],
              [-93.93707700040324, 38.42890299987357],
              [-93.96010800038385, 38.29885600030423],
              [-93.83235000025229, 38.16944699957941],
              [-93.43662190038037, 38.20358280030604],
              [-93.51142099977926, 37.927595999955486],
              [-93.41294199997327, 38.07004300028427],
              [-93.0651990004335, 38.062479000405574],
              [-93.07647299962917, 37.82949799973295],
              [-92.96531999991805, 37.71259900034363],
              [-93.2707669995973, 37.35350099967144],
              [-93.44769399997807, 37.275289000087355],
              [-93.35338500001768, 37.017430999740895],
              [-93.37783899996981, 36.90460600026677],
              [-93.61245999982907, 36.84974500013169],
              [-93.70244399999058, 36.9060359996617],
              [-93.64490699965825, 37.14108400032643],
              [-93.90281799975082, 37.175604999571135],
              [-93.91470000000498, 37.05957399974034],
              [-94.19099599986549, 36.93957999971724],
              [-94.09934200003323, 36.92885899994292],
              [-94.25606400035332, 36.617983999961666],
              [-94.55719099956497, 36.59022499958411],
              [-94.61802599999987, 36.65988499959309],
              [-94.61802599999987, 36.669431000040674],
              [-94.61792099965436, 36.99818399979182],
              [-98.12816500011462, 36.99810599979213],
              [-98.18385299971612, 37.09411499990739],
              [-98.1673250001486, 37.38432200006031],
              [-98.34950359971134, 37.38400220024141],
              [-98.34873599956671, 37.21010200040706],
              [-98.45832700009095, 37.108352999990984],
              [-98.62321300007983, 37.123710000416224],
              [-98.62224899969152, 36.998934000203974],
              [-98.81183300009286, 36.99929599981061],
              [-98.85776600040055, 37.29563000012445],
              [-99.00194599970808, 37.29714299974967],
              [-99.00100500038042, 37.12382300023131],
              [-99.12692500028851, 37.118524999629074],
              [-99.29134190040833, 37.38260860000696],
              [-99.54318900037202, 37.381125000118686],
              [-99.54111700014943, 36.99960999990162],
              [-102.0423105996544, 36.99311010035092],
              [-101.81280700034273, 40.002851000373425],
            ],
            [
              [-93.31338700000998, 37.89033500026011],
              [-93.37639099974479, 37.734899999935124],
              [-93.53969899980893, 37.639822999631804],
              [-93.50700100009607, 37.54132299975669],
              [-93.27486699981216, 37.47765499997831],
              [-93.31938599966412, 37.67473399977433],
              [-93.25358599959418, 37.804076000107386],
              [-93.31338700000998, 37.89033500026011],
            ],
            [
              [-98.37334699956432, 37.47499899980403],
              [-98.46476400015843, 37.529037999803904],
              [-98.46491299983506, 37.38407500036101],
              [-98.37334699956432, 37.47499899980403],
            ],
            [
              [-94.39086000038867, 37.64909700012652],
              [-94.38025699976072, 37.70751399967139],
              [-94.61772599965514, 37.771921000254],
              [-94.61772699970123, 37.65356600027076],
              [-94.39086000038867, 37.64909700012652],
            ],
          ],
        ],
      },
      id: 19,
      NAME: 'SPNO',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'SPSO',
        id: 20,
        label: 'SPSO',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.44236695877599996,
        year: 2023,
        centroid: [301.46286265091464, 276.7406020107352],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-90.12381299977011, 30.367399999910106],
              [-90.24355099967886, 30.36371199980897],
              [-90.24423799988375, 30.48033449993727],
              [-90.12381299977011, 30.367399999910106],
            ],
          ],
          [
            [
              [-93.48143900030959, 33.796907000357805],
              [-93.36923299970312, 33.721074999911366],
              [-93.46377399957038, 33.606455000398],
              [-93.48143900030959, 33.796907000357805],
            ],
          ],
          [
            [
              [-90.76695399962733, 36.069684000316386],
              [-90.49966999987055, 35.87792899962369],
              [-90.52692000015787, 35.706678000189584],
              [-90.90881299982004, 35.70611100012263],
              [-90.85512599986498, 36.00221899990697],
              [-90.76695399962733, 36.069684000316386],
            ],
          ],
          [
            [
              [-90.30052900031308, 36.646907000058036],
              [-90.46694399976576, 36.66353799987883],
              [-90.69890900035006, 36.843932000061784],
              [-90.51456599972107, 36.911199000333625],
              [-90.25814299989946, 36.88591699996965],
              [-90.33479300029671, 36.765177999764944],
              [-90.30052900031308, 36.646907000058036],
            ],
          ],
          [
            [
              [-94.35267000012038, 36.04443499967556],
              [-94.35267000012038, 36.04443499967556],
              [-94.37913490035533, 35.97972729997497],
              [-94.37913490035533, 35.97972729997497],
              [-94.49357500038593, 35.76308299958083],
              [-94.43438999959875, 35.403978000384484],
              [-94.46233200032151, 34.4629820002192],
              [-94.28919100006459, 34.44400199999234],
              [-94.32401199965403, 34.327007999819386],
              [-94.46636800028296, 34.33267200021271],
              [-94.4858749996315, 33.637867000161975],
              [-94.39765299978609, 33.555243000364214],
              [-94.18391299968516, 33.594682999820634],
              [-94.04338499971794, 33.551814999662554],
              [-94.04296400008849, 33.01922000030282],
              [-93.81455399976721, 33.01937300016385],
              [-93.7531209996344, 32.63027299999902],
              [-93.6184999995753, 32.63033500016019],
              [-93.59555399991712, 32.387205000010795],
              [-93.49859700015139, 32.26845599984455],
              [-93.54120199987238, 32.10479899987399],
              [-93.40207199962305, 31.946954999973343],
              [-93.43402400000758, 31.86797800018462],
              [-93.03657099955194, 31.956287000444775],
              [-92.90839599997537, 31.85078399958195],
              [-92.84549200035548, 32.036165000414485],
              [-92.58563400040873, 32.0076039999247],
              [-92.44287800021948, 31.914826000419623],
              [-92.4216030002782, 31.796835000135218],
              [-92.14238699976022, 31.71558799998627],
              [-92.07005699983063, 31.791375000156165],
              [-91.82862299965166, 31.763673999755326],
              [-91.81500500028051, 31.64015599999948],
              [-91.5139629995927, 31.532084000276427],
              [-91.53351300002487, 31.27439100034445],
              [-91.63878099994315, 31.28283500033507],
              [-91.6421430002992, 31.482014999892385],
              [-91.86442100022896, 31.30546599985604],
              [-91.69218100015297, 31.263205999857064],
              [-91.72380499980085, 31.044254999568636],
              [-91.66137300036365, 30.85709899961921],
              [-91.53947399972526, 30.791224999734027],
              [-91.83047699971371, 30.56617110021614],
              [-91.64009999961524, 30.44272899964369],
              [-91.62105600003434, 30.30993900038459],
              [-91.4753030001333, 30.22949100020952],
              [-91.46383299999292, 30.10249400009809],
              [-91.15905599973456, 30.018804999751012],
              [-91.15028499995276, 29.90072799999723],
              [-90.99176100016996, 29.732728000297016],
              [-91.08543599967163, 29.623815999608723],
              [-91.26688099975831, 29.541725000108727],
              [-91.26441800039038, 29.471031000080643],
              [-91.41049800008261, 29.552878000019746],
              [-91.55105799972688, 29.51909100044935],
              [-91.62151300042461, 29.73542999989462],
              [-91.88064500016657, 29.710701999897424],
              [-91.82772899979346, 29.830967999873337],
              [-92.19797900033058, 29.75260100033597],
              [-92.11144400004054, 29.61702600034971],
              [-92.30836799988327, 29.533074999611586],
              [-92.2409210003039, 29.75100799971949],
              [-92.38001499979237, 29.8327500002124],
              [-92.1996330001628, 30.032290000183423],
              [-92.06977500031599, 30.026072000322586],
              [-92.15367499960149, 30.255542000063315],
              [-92.17531100000264, 30.108328000237066],
              [-92.39519800028745, 30.07873399977433],
              [-92.49757499998623, 30.2769889998425],
              [-92.62514000021082, 30.301336000256242],
              [-92.47452600007483, 30.499826000369694],
              [-92.21114300034913, 30.56812999989961],
              [-92.172398999714, 30.767985000007798],
              [-92.28071599994342, 30.935954000077118],
              [-92.22713899966504, 31.07486800025805],
              [-92.37587019984983, 31.014464400112047],
              [-92.5436949999243, 31.124987000249916],
              [-92.70995600036906, 31.09392300034625],
              [-92.82895100018845, 31.165383999771848],
              [-92.87975600033911, 31.31737400040987],
              [-93.2318150001621, 31.364529999559863],
              [-93.2354109996179, 31.305729000293184],
              [-93.535414000056, 31.27640199955266],
              [-104.84775799993173, 32.00051999969827],
              [-102.86544999961774, 36.99959099992475],
              [-102.0423105996544, 36.99311010035092],
              [-94.61802599999987, 36.669431000040674],
              [-94.61802599999987, 36.65988499959309],
              [-94.25606400035332, 36.617983999961666],
              [-94.15646500015959, 36.498738000258584],
              [-93.5211289996036, 36.49888099965847],
              [-93.53756000009389, 36.72384500024663],
              [-93.61245999982907, 36.84974500013169],
              [-93.37783899996981, 36.90460600026677],
              [-93.18962099960942, 36.70220100037591],
              [-93.1510450004264, 36.49787900021573],
              [-93.01748499983285, 36.498199999730275],
              [-93.08840300029817, 36.411264999879904],
              [-92.9426440999452, 36.37443960030737],
              [-92.82714599968807, 36.21040600023679],
              [-93.03193799993869, 36.09608900030719],
              [-92.92603400036876, 36.02956900030915],
              [-92.67757299989398, 36.12431599978362],
              [-92.59068200027406, 36.01969399997819],
              [-92.69309580023094, 35.92648059999976],
              [-92.86602000002296, 35.91891700031937],
              [-92.9512969998566, 35.7245729998441],
              [-93.16445300000589, 35.72883200019669],
              [-93.15249699993655, 35.90427799972997],
              [-93.58120500011063, 35.882872199692315],
              [-93.7140950003839, 35.76911799999573],
              [-93.94139099969482, 35.77675200040454],
              [-94.06092800022697, 35.95589499955463],
              [-94.35267000012038, 36.04443499967556],
            ],
            [
              [-94.95469000034319, 35.87082899955874],
              [-95.00450399975972, 35.76244099965248],
              [-95.12714470006784, 35.75862650001301],
              [-95.12746499990976, 35.63888700003508],
              [-94.82920699990308, 35.638616000128366],
              [-94.95469000034319, 35.87082899955874],
            ],
            [
              [-92.09258399995161, 30.435647999555613],
              [-92.12667629957156, 30.298366400189252],
              [-91.96452400028232, 30.307698999609215],
              [-92.09258399995161, 30.435647999555613],
            ],
          ],
          [
            [
              [-93.2707669995973, 37.35350099967144],
              [-93.22529099967983, 37.22425600021427],
              [-93.44769399997807, 37.275289000087355],
            ],
          ],
        ],
      },
      id: 20,
      NAME: 'SPSO',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'SRMV',
        id: 21,
        label: 'SRMV',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.36453283953599996,
        year: 2023,
        centroid: [375.2738270328863, 302.90620142025386],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-91.23210599959219, 29.37382399957795],
              [-91.1795830002552, 29.219705999732128],
              [-91.3067789996511, 29.308508000244046],
              [-91.23210599959219, 29.37382399957795],
            ],
          ],
          [
            [
              [-94.56667399980523, 29.531988999892462],
              [-94.49958299955574, 29.506631999667093],
              [-94.77533100022544, 29.378320000068015],
              [-94.56667399980523, 29.531988999892462],
            ],
          ],
          [
            [
              [-91.90228709976981, 29.63454139976585],
              [-91.7104219995756, 29.55573799970898],
              [-91.8215770002783, 29.4739250004385],
              [-92.01490899995036, 29.560980000426753],
              [-91.90228709976981, 29.63454139976585],
            ],
          ],
          [
            [
              [-93.5672709996569, 31.178780999743367],
              [-92.30836799988327, 29.533074999611586],
              [-92.6060149995925, 29.577082000134226],
              [-93.21395300023073, 29.776269000014395],
              [-93.6790230000114, 29.747767999593577],
              [-93.83594499966199, 29.69458600044362],
              [-93.9045210000441, 29.794653999782327],
              [-93.80347999990204, 29.83005800017662],
              [-93.79023699983765, 30.000222999891605],
              [-93.86624899959162, 29.99049800018264],
              [-93.93801100030737, 29.781108000134168],
              [-93.83870199999728, 29.678560999790363],
              [-94.12737300036366, 29.64878800006619],
              [-94.49908099978825, 29.50686200038109],
              [-94.54578000034672, 29.572376999898665],
              [-94.7632210002489, 29.52443799971394],
              [-94.68945499974842, 29.696814999812432],
              [-94.740107000038, 29.788410999667974],
              [-94.87054799979035, 29.674058999922977],
              [-94.97018199979942, 29.681372999964026],
              [-94.97753799997867, 29.67753500014021],
              [-94.97966399999359, 29.678269999860674],
            ],
          ],
          [
            [
              [-94.37913490035533, 35.97972729997497],
              [-93.01748499983285, 36.498199999730275],
              [-91.67234399997557, 36.499463000417165],
              [-91.54929700035626, 36.64802100016908],
              [-91.45619400025288, 36.64688499994287],
              [-91.44999799960794, 36.49783299989309],
              [-91.30776200001623, 36.55479699988172],
              [-91.12652899981344, 36.497711999709054],
              [-91.12289799964293, 36.64376700004709],
              [-91.01673199968201, 36.49819000016845],
              [-90.72011499980738, 36.49850100012111],
              [-90.61051000043614, 36.65188000006202],
              [-90.46694399976576, 36.66353799987883],
              [-90.30052900031308, 36.646907000058036],
              [-90.02893100036533, 36.629870000400274],
              [-89.9592670001719, 36.146722999766666],
              [-90.1684139998062, 36.06846900004439],
              [-90.3191690001492, 36.08997699993864],
              [-90.37789000022332, 35.99568299977068],
              [-89.73309599968059, 36.000608000259035],
              [-89.65313999971119, 35.92261800012068],
              [-89.82121700026431, 35.75671600004341],
              [-89.95871900008177, 35.72742800020211],
              [-89.84839399988317, 35.64411300001501],
              [-89.73763200021659, 35.74314500014168],
              [-89.49348800007112, 35.65200000039977],
              [-89.79380999993151, 35.63774300033924],
              [-89.7554279998023, 35.52864600011287],
              [-89.99190799995421, 35.52676499970505],
              [-90.18391389980661, 35.46621919965639],
              [-90.07499200028053, 35.3841529998611],
              [-90.15000599987695, 35.25501499994232],
              [-90.06476900008926, 35.13893999988113],
              [-90.30929699995653, 34.99569499962456],
              [-89.72423600029117, 34.99526899976456],
              [-89.80350900024013, 34.82685199972008],
              [-89.72353799957898, 34.77245999962935],
              [-89.70350600030162, 34.4770040002345],
              [-89.73954800043981, 34.05715000007251],
              [-89.50779699983161, 34.06720699980326],
              [-89.50726300038713, 33.80900799991929],
              [-89.87496100015, 33.83846200022117],
              [-90.06640240005066, 33.99848599992902],
              [-90.03815339955969, 34.08808660021646],
              [-90.23766399979371, 34.072825999919985],
              [-90.27802700044566, 33.89671300020484],
              [-90.45069599962068, 33.89829799955311],
              [-90.45164400017046, 33.81137800039443],
              [-90.18284699988908, 33.8093610000102],
              [-90.29587100044625, 33.75080799958954],
              [-90.13678700001998, 33.721641999978374],
              [-90.13700900036503, 33.67694299991956],
              [-89.85056200003623, 33.67659600010535],
              [-89.90890599981202, 33.59019899988397],
              [-89.78732799958749, 33.48630739976676],
              [-89.78688599988897, 33.67672699985121],
              [-89.45868100022795, 33.666950999589005],
              [-89.6459000003847, 33.34631500003729],
              [-89.52346600025567, 33.28586200013126],
              [-89.81089600005032, 33.26102300041117],
              [-89.90957199994779, 33.32896999966579],
              [-89.98595000039217, 33.24903599981161],
              [-89.97263699979766, 33.006583000305284],
              [-89.83332200001024, 33.06225400002211],
              [-89.89892499998871, 32.94391499987739],
              [-89.81861800002065, 32.88553600028621],
              [-89.98488099965834, 32.74883300044269],
              [-89.82127000001043, 32.74313000004952],
              [-89.73030499957605, 32.634228999868526],
              [-90.01934800001015, 32.47729299957234],
              [-90.01411199956908, 32.166661000005206],
              [-89.72997599969261, 32.06034799956058],
              [-89.62361100044728, 32.22368400001665],
              [-89.50118299969563, 32.14024999973776],
              [-89.32269200003572, 32.223472000132745],
              [-89.34609800022247, 31.984841999758544],
              [-89.47152099969435, 31.981898800189526],
              [-89.48451499996725, 31.772217999860857],
              [-89.58663999973618, 31.696608999805562],
              [-89.97466299969761, 31.682548999836513],
              [-89.99821600036807, 31.394462000321084],
              [-90.12591599962366, 31.369694000277946],
              [-90.24451500006717, 31.48790399986973],
              [-90.36317799986477, 31.326131999592178],
              [-90.05552800021701, 31.26206800043792],
              [-89.94607499976138, 31.14758800018609],
              [-89.94093200001174, 31.00151499991739],
              [-89.72769799986276, 30.993329000133315],
              [-89.84725200027952, 30.670389999598854],
              [-89.68348799987126, 30.45166499983992],
              [-89.64757700037825, 30.290503999859766],
              [-89.5245039995599, 30.180754000097068],
              [-89.717681000178, 30.167321000263996],
              [-90.01801799983082, 30.32052700032085],
              [-90.11738300002537, 30.366637999843874],
              [-90.24355099967886, 30.36371199980897],
              [-90.43369699991655, 30.1518010004159],
              [-90.40910699998801, 30.081932999808146],
              [-90.18253099970582, 30.02298500005776],
              [-90.01217700026831, 30.038153999907195],
              [-89.8801660000608, 30.148546999644395],
              [-89.81270699992808, 30.098243000114394],
              [-89.6343750004059, 30.152840999812327],
              [-89.83893900003477, 29.94657800007468],
              [-89.59764199987836, 29.880586000143865],
              [-89.48896600018071, 30.040966000080914],
              [-89.35478000039666, 29.848655999874552],
              [-89.53472699975123, 29.669487999571572],
              [-89.72097500009613, 29.584942000173214],
              [-89.53064000013586, 29.372842000158244],
              [-89.23677200022757, 29.253931999762017],
              [-89.30566099975528, 29.147347000263892],
              [-89.49115999973418, 29.243440999802374],
              [-89.8309929996272, 29.31523300010292],
              [-89.77667500025103, 29.417254999618592],
              [-89.90918199994928, 29.529979999877128],
              [-90.06571200040844, 29.481133000087937],
              [-90.05916199962655, 29.31569900000892],
              [-90.15360600041657, 29.378875999627724],
              [-90.07460500042038, 29.174987999696498],
              [-90.22371000021627, 29.085064999650058],
              [-90.3639409999771, 29.35592499973899],
              [-90.37968600030865, 29.28330199978751],
              [-90.5546930002817, 29.418726000004938],
              [-90.69032600024468, 29.122592999967026],
              [-90.87758400040127, 29.10489100021954],
              [-91.0636159997785, 29.246516000413123],
              [-91.1790079998193, 29.219705999732128],
              [-91.12996099980029, 29.337309000110338],
              [-91.26441800039038, 29.471031000080643],
            ],
            [
              [-90.99027230022642, 33.89960029971411],
              [-91.03734399962582, 33.81065200018969],
              [-90.88482730023969, 33.791342699705865],
              [-90.99027230022642, 33.89960029971411],
            ],
            [
              [-90.65419300040662, 33.681158000041705],
              [-90.90260200028206, 33.674319000321645],
              [-90.92065099984376, 33.53029500011422],
              [-90.6585889998824, 33.54354499960209],
              [-90.65419300040662, 33.681158000041705],
            ],
            [
              [-91.14418900032206, 31.917948999646683],
              [-91.33841399980622, 31.85126099999519],
              [-91.3656149996325, 31.760763999559003],
              [-91.18321300037962, 31.76917499982642],
              [-91.15386400042325, 31.610068000138142],
              [-90.70879229962492, 31.611227600373525],
              [-90.67119100006454, 31.83362599974015],
              [-90.85927000031023, 31.911952000084796],
              [-90.90835600032909, 31.840123999922696],
              [-91.14418900032206, 31.917948999646683],
            ],
            [
              [-90.67603100023047, 31.26034800026008],
              [-90.67603100023047, 31.26034800026008],
              [-90.57999399972329, 31.4358349998854],
              [-90.72051200012868, 31.440136000376185],
              [-90.78658200005924, 31.315705999931993],
              [-90.67603100023047, 31.26034800026008],
            ],
            [
              [-91.03692299999642, 31.290601999682565],
              [-91.23266400014347, 31.373898999938945],
              [-91.29962899997832, 31.297481000347943],
              [-91.19060300032817, 31.225267000371844],
              [-91.03692299999642, 31.290601999682565],
            ],
          ],
        ],
      },
      id: 21,
      NAME: 'SRMV',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'SRMW',
        id: 22,
        label: 'SRMW',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.626026813168,
        year: 2023,
        centroid: [387.99123757435075, 213.69788848899194],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-93.61245999982907, 36.84974500013169],
              [-94.25606400035332, 36.617983999961666],
            ],
          ],
          [
            [
              [-88.02802999968469, 37.799225000333536],
              [-88.16018800037585, 37.657591999771],
              [-88.06811700019938, 37.481593999963195],
              [-88.47607300026868, 37.38787900041558],
              [-88.5115260002247, 37.26161599997846],
              [-88.42438199972946, 37.15242399986778],
              [-88.54540400039429, 37.07000399958497],
              [-88.928021000169, 37.2265180002056],
              [-89.0299819995696, 37.21114399989574],
              [-89.17783800022352, 37.057316999979605],
              [-89.09900800001913, 36.961389000002384],
              [-89.15910260030472, 36.66639639967417],
              [-89.2264536997784, 36.569842199957634],
              [-89.36554899968655, 36.625058999773046],
              [-89.41977100003157, 36.49389700004656],
              [-89.57150999988653, 36.55256999970578],
              [-89.5346760000973, 36.25277900005085],
              [-89.70445900018268, 36.23546900039412],
              [-89.59400100014602, 36.127190000118446],
              [-89.73309599968059, 36.000608000259035],
              [-90.46694399976576, 36.66353799987883],
              [-93.01748499983285, 36.498199999730275],
              [-93.37783899996981, 36.90460600026677],
              [-93.44769399997807, 37.275289000087355],
              [-93.2707669995973, 37.35350099967144],
              [-94.7080209997693, 40.57224199956869],
              [-90.25410599989192, 41.52253100020556],
            ],
            [[-93.15242400016746, 37.18698900024219]],
          ],
        ],
      },
      id: 22,
      NAME: 'SRMW',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'SRSO',
        id: 23,
        label: 'SRSO',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.407170941128,
        year: 2023,
        centroid: [457.1576050146917, 303.2390761308476],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-85.39144799962543, 30.025414999702548],
              [-85.43091920016093, 29.95002950006142],
              [-85.6863650002445, 30.124351999944906],
              [-85.39144799962543, 30.025414999702548],
            ],
          ],
          [
            [
              [-81.36438699986013, 31.312436000221282],
              [-81.26968799990124, 31.2609760004421],
              [-81.36808300033016, 31.145872000192696],
              [-81.36438699986013, 31.312436000221282],
            ],
          ],
          [
            [
              [-89.50118299969563, 32.14024999973776],
              [-89.62361100044728, 32.22368400001665],
              [-89.52732300005636, 32.33300099959649],
              [-89.50118299969563, 32.14024999973776],
            ],
          ],
          [
            [
              [-89.50726300038713, 33.80900799991929],
              [-89.45868100022795, 33.666950999589005],
              [-90.13678700001998, 33.721641999978374],
              [-90.18284699988908, 33.8093610000102],
            ],
          ],
          [
            [
              [-83.32392699973121, 34.78954199956365],
              [-83.35248600012875, 34.71599400012303],
              [-83.55178869958877, 34.750699200307906],
              [-83.43877599991242, 34.867834000139055],
              [-83.32392699973121, 34.78954199956365],
            ],
          ],
          [
            [
              [-83.33838400002156, 34.686995000119225],
              [-83.06945099976377, 34.50213199979203],
              [-82.90266600033561, 34.48590299962376],
              [-82.73188199995428, 34.17836299965279],
              [-82.52607029980447, 33.943642800075224],
              [-82.24803140032884, 33.75308960030486],
              [-82.19689399995809, 33.63143999965632],
              [-82.04695899965805, 33.5641670000071],
              [-81.75202340015977, 33.14848599982906],
              [-81.49195400017692, 33.00909400008811],
              [-81.41798400016143, 32.81819600024528],
              [-81.41865999985907, 32.6293929998871],
              [-81.23286000038865, 32.51606699979226],
              [-81.11963400040878, 32.28759700030139],
              [-81.11113399963432, 32.11200600037665],
              [-80.90819219981012, 32.046921000004204],
              [-80.86371500044686, 31.970899999835183],
              [-81.13539699977167, 31.720936000196332],
              [-81.17600500003067, 31.51637799994478],
              [-81.4360579999767, 31.227134000134072],
              [-81.40472400021241, 30.902809999581848],
              [-85.6160440003303, 30.134254999768473],
              [-85.73245079986447, 30.12294149965055],
              [-85.95954400025539, 30.25459999979023],
              [-86.32166500003967, 30.367567999563562],
              [-86.16063399975923, 30.379991700156893],
              [-86.20655999974417, 30.482104999746014],
              [-86.60515120016771, 30.401357299599738],
              [-87.07006999963073, 30.378308699886645],
              [-86.92772500040843, 30.46065799996677],
              [-87.03832199966052, 30.53878199998934],
              [-87.0679950001691, 30.447821999785504],
              [-87.15801590041343, 30.580404199893962],
              [-87.17458800003612, 30.42875600008938],
              [-87.2667629996127, 30.344223000391196],
              [-87.81903599991142, 30.2395279999173],
              [-87.7712800000719, 30.31057700012849],
              [-87.90757800012454, 30.412166000360685],
              [-87.97761899971704, 30.709650999793837],
              [-88.04969899980898, 30.661090999749888],
              [-88.10917599967263, 30.370782000289125],
              [-88.3583650004444, 30.407481000148096],
              [-88.45159199997079, 30.331643000324277],
              [-88.85675099965886, 30.390507999844374],
              [-89.32989700044618, 30.302965999881053],
              [-89.5245039995599, 30.180754000097068],
              [-89.32269200003572, 32.223472000132745],
              [-89.11441600009829, 32.409667999878366],
              [-89.05975400014694, 32.240447999675496],
              [-88.9143409997373, 32.149133000187874],
              [-88.99221459972398, 32.02425520031727],
              [-88.92249559969213, 31.87092689965675],
              [-88.80934299967964, 31.983621199758602],
              [-88.46879199995078, 31.930354999783447],
              [-88.13998899969255, 34.58170400003962],
              [-87.95294300031918, 34.65083499993534],
              [-87.86420299996843, 34.5797540000471],
              [-87.52318200014918, 34.58136399964894],
              [-87.53071799963595, 34.37117100034146],
              [-87.3937490001162, 34.54956900020926],
              [-87.26163100037036, 34.621792999747186],
              [-87.20053200035147, 34.50342199992542],
              [-87.04963799989372, 34.49317300033374],
              [-87.11010599959218, 34.31335599977962],
              [-87.11173400002406, 34.083310999602986],
              [-87.0197239999626, 34.12971199990892],
              [-86.97189700044618, 33.990535000190164],
              [-86.88384400030031, 34.02979500033905],
              [-86.86883999996599, 34.23104800016512],
              [-86.6466159998285, 34.37217299978414],
              [-86.44133400036378, 34.37522700032588],
              [-86.33473300012781, 34.45087699957395],
              [-86.15554399975576, 34.43385699980075],
              [-86.34900900016521, 34.25834199978351],
              [-86.25850800044384, 34.20033600030621],
              [-86.08155799990175, 34.3733930002868],
              [-85.9260448997523, 34.30389570022646],
              [-85.77367000007041, 34.3871919999109],
              [-85.76468899959764, 34.24484199955867],
              [-85.4446719998129, 34.19990100003116],
              [-85.60516599961113, 34.984678999736104],
              [-85.34245800043635, 34.983776000362184],
              [-85.38732800028697, 34.86112099993426],
              [-85.20163200021659, 34.98585900019276],
              [-84.98191229991266, 34.987633199812365],
              [-84.94685869966924, 34.89460349985171],
              [-84.8105030000134, 34.98753900032466],
              [-84.68942899964856, 34.94597900023075],
              [-84.72395800016153, 34.83169099983985],
              [-84.61727399969527, 34.800559000397584],
              [-84.6214830004401, 34.98832999992959],
              [-84.3593629996027, 34.98826899981452],
              [-84.1855430004091, 34.776427000006095],
              [-84.11392709995567, 34.98752060019558],
              [-83.86544000025577, 34.91449599989056],
              [-83.78040099970633, 34.79289300031178],
              [-83.62329599971059, 34.73219399985328],
              [-83.63820300006836, 34.62216499981491],
              [-83.49477829997852, 34.59252420043157],
              [-83.33838400002156, 34.686995000119225],
            ],
            [
              [-84.77240100020595, 34.601113000264775],
              [-84.77240100020595, 34.601113000264775],
              [-85.05044699982915, 34.61598299981563],
              [-85.063958999708, 34.557997000361354],
              [-84.77240100020595, 34.601113000264775],
            ],
          ],
        ],
      },
      id: 23,
      NAME: 'SRSO',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'SRTV',
        id: 24,
        label: 'SRTV',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.425752791,
        year: 2023,
        centroid: [440.0194774815577, 252.92878811585743],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-90.13678700001998, 33.721641999978374],
              [-90.18284699988908, 33.8093610000102],
            ],
          ],
          [[[-84.77240100020595, 34.601113000264775]]],
          [
            [
              [-81.67753500033996, 36.588118000445434],
              [-81.74171500034697, 36.41238899955272],
              [-81.97332399980269, 36.211214999772494],
              [-82.16192599988494, 36.245753999847295],
              [-82.24475300005088, 36.131211000287465],
              [-82.61088899972754, 35.96740999997155],
              [-82.63246500005965, 36.06580500040047],
              [-82.7758660003156, 36.00080400030441],
              [-82.99190500031546, 35.774013],
              [-83.24067000042015, 35.72676100002019],
              [-83.49833499996026, 35.562980999773345],
              [-83.77173700036224, 35.56211800044542],
              [-84.0233070003178, 35.411484000286464],
              [-83.96487600012728, 35.212675999897556],
              [-84.0136310001705, 35.13460399957495],
              [-83.65976599980104, 35.16024300021434],
              [-83.48327899992586, 34.993292000325596],
              [-83.41246499975989, 34.994491999905904],
              [-83.28118149982635, 35.133824999624096],
              [-83.06020699975318, 35.12287750019652],
              [-83.00870699992805, 35.02751900040158],
              [-83.35248600012875, 34.71599400012303],
              [-89.32269200003572, 32.223472000132745],
              [-89.62361100044728, 32.22368400001665],
              [-89.45868100022795, 33.666950999589005],
              [-89.50726300038713, 33.80900799991929],
              [-89.73309599968059, 36.000608000259035],
              [-88.02802999968469, 37.799225000333536],
            ],
          ],
        ],
      },
      id: 24,
      NAME: 'SRTV',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'SRVC',
        id: 25,
        label: 'SRVC',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.283891439408,
        year: 2023,
        centroid: [519.6734619704152, 248.50946847521743],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-77.50368200042396, 39.1151849998879],
              [-76.23674299968962, 37.88864399962091],
              [-76.30631559998488, 37.82167510032565],
              [-76.36085599990446, 37.51733100042537],
              [-76.2526130003896, 37.43909799987284],
              [-76.27725500001822, 37.30930600037169],
              [-76.41516799990325, 37.40213400038385],
              [-76.37154299990948, 37.26841699974477],
              [-76.50465499962849, 37.24541500020217],
              [-76.2943549998833, 37.12706200031113],
              [-76.32567900008576, 36.96323000036426],
              [-75.98912129960826, 36.90982370040348],
              [-75.81922900041798, 36.360310000006564],
              [-75.57242900009823, 35.868767999843385],
              [-75.73826900001433, 36.04178599982407],
              [-75.94284900038105, 36.72350499985589],
              [-76.02213299993798, 36.46634500022162],
              [-75.899029000388, 36.32646699965238],
              [-75.78942500016359, 36.07907399986527],
              [-75.93432899958361, 36.165141000157064],
              [-76.30199499966943, 36.11382099963947],
              [-76.4603319998219, 36.025099000118814],
              [-76.70732900023313, 36.042690000143466],
              [-76.72711599990345, 35.941996999861715],
              [-76.1693800003867, 35.994553999867264],
              [-75.98601299980004, 35.88943599967172],
              [-75.76796899996936, 35.91222369976401],
              [-75.71589199961608, 35.69238100008312],
              [-75.77615499975337, 35.58009000005353],
              [-75.91731199994882, 35.56513600022629],
              [-76.06968000003195, 35.37005299984611],
              [-76.26876599975105, 35.34033900014481],
              [-76.38919400000304, 35.42759899969411],
              [-76.47005400029184, 35.37148100004816],
              [-76.62926700037173, 35.51893600019628],
              [-76.57508400002655, 35.38822999991464],
              [-76.97937800029445, 35.48445099991375],
              [-76.6686269997362, 35.34161899981706],
              [-76.50182999975465, 35.31495100028849],
              [-76.54736699978719, 35.14794399961596],
              [-76.69903700005744, 35.02108000024185],
              [-76.59088100005806, 34.97829300022181],
              [-76.46388700008492, 35.076048999961415],
              [-76.31333800024845, 34.906712999805166],
              [-76.51566400009347, 34.7179120004385],
              [-76.89487400013496, 34.72522300034126],
              [-77.08260780010983, 34.67358780003701],
              [-77.57836030018768, 34.40362370007375],
              [-77.83044700022884, 34.17145600039413],
              [-77.9597840003313, 33.83981100037744],
              [-78.1360390002996, 33.91178199993942],
              [-78.36281280017056, 33.90276329988643],
              [-78.68665899991288, 33.811729000393086],
              [-78.93822000035271, 33.64026199999137],
              [-79.20340400039424, 33.302498000182595],
              [-79.18786999990056, 33.173712000308626],
              [-79.58368799960147, 33.00592100035391],
              [-79.57843700026729, 32.90746099962547],
              [-79.7922769995838, 32.82352499957909],
              [-79.99316799980329, 32.60755400001716],
              [-80.18557299989396, 32.56869400032792],
              [-80.46272299956672, 32.412805999797115],
              [-80.90819219981012, 32.046921000004204],
              [-83.33838400002156, 34.686995000119225],
              [-83.35248600012875, 34.71599400012303],
              [-83.32392699973121, 34.78954199956365],
              [-83.41246499975989, 34.994491999905904],
              [-83.48327899992586, 34.993292000325596],
              [-81.67753500033996, 36.588118000445434],
            ],
          ],
        ],
      },
      id: 25,
      NAME: 'SRVC',
    },
    {
      type: 'Feature',
      properties: {
        NAME: 'PRMS',
        id: 26,
        label: 'PRMS',
        unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
        type: 'eGRID subregion',
        value: 0.725711819824,
        year: 2023,
        centroid: [603.089293976572, 383.79075975839095],
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-65.39803000857802, 18.162693954762233],
              [-65.27324204558391, 18.13029495085135],
              [-65.57655195480885, 18.119211036859895],
              [-65.39803000857802, 18.162693954762233],
            ],
          ],
          [
            [
              [-67.08208393622465, 18.5136640581498],
              [-66.9069149422707, 18.48364894114576],
              [-66.37820092043609, 18.488461007469596],
              [-65.9036980603172, 18.453110014015977],
              [-65.6745440409747, 18.362612053103817],
              [-65.60150597062403, 18.23015697576386],
              [-65.71785497522689, 18.190264012074522],
              [-65.83419495423374, 18.0121460377095],
              [-66.15967503057817, 17.928387076402487],
              [-66.4638350023834, 17.99069807295774],
              [-66.83622398824645, 17.950433059737975],
              [-67.21344091706464, 17.99252405374216],
              [-67.15809605918577, 18.216891078060826],
              [-67.26716804926605, 18.36786803738005],
              [-67.08208393622465, 18.5136640581498],
            ],
          ],
        ],
      },
      id: 26,
      NAME: 'PRMS',
    },
  ],
}

export default usangeo
